export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Binary: { input: string; output: string; }
  Color: { input: string; output: string; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Object: { input: Record<string, unknown>; output: Record<string, unknown>; }
  SkillRating: { input: string; output: string; }
  UUID: { input: string; output: string; }
};

export enum AccessLevel {
  Read = 'READ',
  Write = 'WRITE'
}

/** Execute one of the actions offered by an actionable notification. */
export type ActOnNotificationInput = {
  /** The action to execute. */
  action: NotificationActionType;
  /** The notification to act on. */
  notificationId: Scalars['UUID']['input'];
};

export type ActiveQuestionnairesByElementInput = {
  element: CreativityElement;
};

export type AddContactsInput = {
  contacts: Array<Scalars['UUID']['input']>;
  groups?: InputMaybe<Array<Scalars['UUID']['input']>>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  removeContactsFromOtherGroups?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddContactsOutput = AddContactsResult | DailyQuotaExceeded | TooManyRecordsResult;

export type AddContactsResult = {
  __typename?: 'AddContactsResult';
  contactsAdded: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type AddContactsResult */
export type AddContactsResultFilterInput = {
  and?: InputMaybe<Array<AddContactsResultFilterInput>>;
  not?: InputMaybe<AddContactsResultFilterInput>;
  or?: InputMaybe<Array<AddContactsResultFilterInput>>;
};

export type AddPinsInput = {
  groups?: InputMaybe<Array<Scalars['UUID']['input']>>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  persons?: InputMaybe<Array<Scalars['UUID']['input']>>;
  removePinsFromOtherGroups?: InputMaybe<Scalars['Boolean']['input']>;
  sharedItems?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type AddPinsOutput = AddPinsResult | DailyQuotaExceeded | TooManyRecordsResult;

export type AddPinsResult = {
  __typename?: 'AddPinsResult';
  personsPinned?: Maybe<Array<Scalars['UUID']['output']>>;
  sharedItemsPinned?: Maybe<Array<Scalars['UUID']['output']>>;
};

/** The filterable fields of type AddPinsResult */
export type AddPinsResultFilterInput = {
  and?: InputMaybe<Array<AddPinsResultFilterInput>>;
  not?: InputMaybe<AddPinsResultFilterInput>;
  or?: InputMaybe<Array<AddPinsResultFilterInput>>;
};

export type Address = Node & {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  district?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  line?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<CountryState>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<AddressType>;
  use: AddressUse;
};

export type AddressConnection = {
  __typename?: 'AddressConnection';
  edges: Array<AddressEdge>;
  nodes: Array<Address>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AddressEdge = {
  __typename?: 'AddressEdge';
  cursor: Scalars['String']['output'];
  node: Address;
};

/** The filterable fields of type Address */
export type AddressFilterInput = {
  and?: InputMaybe<Array<AddressFilterInput>>;
  not?: InputMaybe<AddressFilterInput>;
  or?: InputMaybe<Array<AddressFilterInput>>;
};

/** The parameters for requesting multiple instances of Address. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type AddressQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains information for linking 'Address' to other entities */
export type AddressRelationInput = {
  /** The identifier of 'Address' */
  id: Scalars['ID']['input'];
};

export enum AddressType {
  Both = 'BOTH',
  Physical = 'PHYSICAL',
  Postal = 'POSTAL'
}

export enum AddressUse {
  Billing = 'BILLING',
  Home = 'HOME',
  Old = 'OLD',
  Temp = 'TEMP',
  Work = 'WORK'
}

export enum AdministrativeGender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  Unknown = 'UNKNOWN'
}

export type ApplicationError = {
  correlationId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorId?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ApplicationError */
export type ApplicationErrorFilterInput = {
  and?: InputMaybe<Array<ApplicationErrorFilterInput>>;
  not?: InputMaybe<ApplicationErrorFilterInput>;
  or?: InputMaybe<Array<ApplicationErrorFilterInput>>;
};

export type AttachProjectDocumentInput = {
  files: Array<CreateFileDataInput>;
  matchId: Scalars['UUID']['input'];
};

export type AttachProjectDocumentOutput = AttachProjectDocumentResult;

export type AttachProjectDocumentResult = {
  __typename?: 'AttachProjectDocumentResult';
  match: Match;
};

/** The filterable fields of type AttachProjectDocumentResult */
export type AttachProjectDocumentResultFilterInput = {
  and?: InputMaybe<Array<AttachProjectDocumentResultFilterInput>>;
  not?: InputMaybe<AttachProjectDocumentResultFilterInput>;
  or?: InputMaybe<Array<AttachProjectDocumentResultFilterInput>>;
};

export type Audience = Node & {
  __typename?: 'Audience';
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name?: Maybe<LocalizedText>;
};

/** The filterable fields of type Audience */
export type AudienceFilterInput = {
  and?: InputMaybe<Array<AudienceFilterInput>>;
  not?: InputMaybe<AudienceFilterInput>;
  or?: InputMaybe<Array<AudienceFilterInput>>;
};

/** Contains information for linking 'Audience' to other entities */
export type AudienceRelationInput = {
  /** The identifier of 'Audience' */
  id: Scalars['ID']['input'];
};

export type AudioElement = GrowElement & PlayableGrowElement & {
  __typename?: 'AudioElement';
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  sources: Array<AudioElementSource>;
  thumbnail?: Maybe<Scalars['Binary']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type AudioElement */
export type AudioElementFilterInput = {
  and?: InputMaybe<Array<AudioElementFilterInput>>;
  not?: InputMaybe<AudioElementFilterInput>;
  or?: InputMaybe<Array<AudioElementFilterInput>>;
};

export type AudioElementSource = {
  __typename?: 'AudioElementSource';
  mimeType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type AudioElementSource */
export type AudioElementSourceFilterInput = {
  and?: InputMaybe<Array<AudioElementSourceFilterInput>>;
  not?: InputMaybe<AudioElementSourceFilterInput>;
  or?: InputMaybe<Array<AudioElementSourceFilterInput>>;
};

/** Filtering for fields of type Boolean */
export type BooleanFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<BooleanFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<BooleanFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<BooleanFilterInput>>;
};

/** Counts of records created (or that would have been created in a dry run) per entity collection. */
export type BulkImportPersonCounts = {
  __typename?: 'BulkImportPersonCounts';
  certificates: Scalars['Int']['output'];
  educations: Scalars['Int']['output'];
  experiences: Scalars['Int']['output'];
  expertises: Scalars['Int']['output'];
  languageSkills: Scalars['Int']['output'];
  personUpdated: Scalars['Boolean']['output'];
};

/** The filterable fields of type BulkImportPersonCounts */
export type BulkImportPersonCountsFilterInput = {
  and?: InputMaybe<Array<BulkImportPersonCountsFilterInput>>;
  not?: InputMaybe<BulkImportPersonCountsFilterInput>;
  or?: InputMaybe<Array<BulkImportPersonCountsFilterInput>>;
};

export type BulkImportPersonDetailData = {
  bio?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for the provider-agnostic bulk-import mutation. The caller provides the
 * target personId plus optional lists for each profile collection and an optional
 * personDetail fragment. Collections that are already non-empty for the target
 * person are left untouched and their name is appended to `skipped` in the result.
 * Non-fatal mapping issues surfaced by the caller (e.g. unrecognized language
 * proficiency while parsing a provider export) can be relayed via `clientWarnings`
 * so they appear in the aggregated result alongside any server-side warnings.
 */
export type BulkImportPersonInput = {
  certificates?: InputMaybe<Array<CreateCertificateDataInput>>;
  clientWarnings?: InputMaybe<Array<Scalars['String']['input']>>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  educations?: InputMaybe<Array<CreateEducationDataInput>>;
  experiences?: InputMaybe<Array<CreateExperienceDataInput>>;
  expertises?: InputMaybe<Array<CreateExpertiseDataInput>>;
  languageSkills?: InputMaybe<Array<CreateLanguageSkillDataInput>>;
  personDetail?: InputMaybe<BulkImportPersonDetailData>;
  personId: Scalars['ID']['input'];
};

/**
 * Result of a bulk person-data import. `skipped` lists the collection names that
 * were left untouched because the target person already had data of that kind
 * (current policy: never overwrite existing data). `warnings` aggregates
 * non-fatal issues — both mapping warnings relayed from the caller via
 * `clientWarnings` and any server-side issues (e.g. optimistic-lock loss during
 * personDetail update).
 */
export type BulkImportPersonResult = {
  __typename?: 'BulkImportPersonResult';
  counts: BulkImportPersonCounts;
  skipped: Array<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

/** The filterable fields of type BulkImportPersonResult */
export type BulkImportPersonResultFilterInput = {
  and?: InputMaybe<Array<BulkImportPersonResultFilterInput>>;
  not?: InputMaybe<BulkImportPersonResultFilterInput>;
  or?: InputMaybe<Array<BulkImportPersonResultFilterInput>>;
};

export enum CefrScale {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2'
}

export type CefrScaleFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<CefrScaleFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<CefrScale>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<CefrScale>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<CefrScale>;
  /** Negates the predicate */
  not?: InputMaybe<CefrScaleFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<CefrScaleFilterInput>>;
};

export type Category = {
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type Category */
export type CategoryFilterInput = {
  and?: InputMaybe<Array<CategoryFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CategoryFilterInput>;
  or?: InputMaybe<Array<CategoryFilterInput>>;
};

export type CategorySortInput = {
  name?: InputMaybe<SortOrder>;
};

export type Certificate = Node & SharableEntity & {
  __typename?: 'Certificate';
  date?: Maybe<DateInstant>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  person: Person;
  sharedWith?: Maybe<Array<Audience>>;
};

/** The filterable fields of type Certificate */
export type CertificateFilterInput = {
  and?: InputMaybe<Array<CertificateFilterInput>>;
  not?: InputMaybe<CertificateFilterInput>;
  or?: InputMaybe<Array<CertificateFilterInput>>;
};

export type ChatMessage = Node & {
  __typename?: 'ChatMessage';
  content: Scalars['String']['output'];
  conversationId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  senderId: Scalars['UUID']['output'];
  sentAt: Scalars['DateTime']['output'];
};

/** The filterable fields of type ChatMessage */
export type ChatMessageFilterInput = {
  and?: InputMaybe<Array<ChatMessageFilterInput>>;
  not?: InputMaybe<ChatMessageFilterInput>;
  or?: InputMaybe<Array<ChatMessageFilterInput>>;
};

/** Preview diff for one collection section (experiences, educations, languageSkills, certificates, expertises). */
export type CollectionDiff = {
  __typename?: 'CollectionDiff';
  rows: Array<CollectionRowDiff>;
};

/** The filterable fields of type CollectionDiff */
export type CollectionDiffFilterInput = {
  and?: InputMaybe<Array<CollectionDiffFilterInput>>;
  not?: InputMaybe<CollectionDiffFilterInput>;
  or?: InputMaybe<Array<CollectionDiffFilterInput>>;
};

/**
 * Preview diff for one collection row. `rowKey` is the stable normalized natural-key hash
 * (so a re-preview can recognize an already-saved row and mark it UNCHANGED, keeping
 * re-import idempotent). `existingRowId` identifies the matched existing row (null for an
 * ADD). `fields` carries the per-field diff (existing vs incoming machine values) the
 * client renders and can edit. Existing rows with no incoming match are not emitted — they
 * are always kept.
 */
export type CollectionRowDiff = {
  __typename?: 'CollectionRowDiff';
  action: ImportDiffAction;
  existingRowId?: Maybe<Scalars['ID']['output']>;
  fields: Array<RowFieldDiff>;
  rowKey: Scalars['String']['output'];
};

/** The filterable fields of type CollectionRowDiff */
export type CollectionRowDiffFilterInput = {
  and?: InputMaybe<Array<CollectionRowDiffFilterInput>>;
  not?: InputMaybe<CollectionRowDiffFilterInput>;
  or?: InputMaybe<Array<CollectionRowDiffFilterInput>>;
};

export type Colors = {
  __typename?: 'Colors';
  background?: Maybe<Scalars['Color']['output']>;
  text?: Maybe<Scalars['Color']['output']>;
};

/** The filterable fields of type Colors */
export type ColorsFilterInput = {
  and?: InputMaybe<Array<ColorsFilterInput>>;
  not?: InputMaybe<ColorsFilterInput>;
  or?: InputMaybe<Array<ColorsFilterInput>>;
};

export type Communication = {
  __typename?: 'Communication';
  language: Scalars['String']['output'];
  preferred?: Maybe<Scalars['Boolean']['output']>;
};

/** The filterable fields of type Communication */
export type CommunicationFilterInput = {
  and?: InputMaybe<Array<CommunicationFilterInput>>;
  not?: InputMaybe<CommunicationFilterInput>;
  or?: InputMaybe<Array<CommunicationFilterInput>>;
};

export type CommunicationSkills = {
  __typename?: 'CommunicationSkills';
  charismatic?: Maybe<Scalars['SkillRating']['output']>;
  clear?: Maybe<Scalars['SkillRating']['output']>;
  communicative?: Maybe<Scalars['SkillRating']['output']>;
  diplomatic?: Maybe<Scalars['SkillRating']['output']>;
  eloquent?: Maybe<Scalars['SkillRating']['output']>;
  entertaining?: Maybe<Scalars['SkillRating']['output']>;
  inspiring?: Maybe<Scalars['SkillRating']['output']>;
  multilingual?: Maybe<Scalars['SkillRating']['output']>;
  recipientOriented?: Maybe<Scalars['SkillRating']['output']>;
  sociable?: Maybe<Scalars['SkillRating']['output']>;
};

/** The filterable fields of type CommunicationSkills */
export type CommunicationSkillsFilterInput = {
  and?: InputMaybe<Array<CommunicationSkillsFilterInput>>;
  not?: InputMaybe<CommunicationSkillsFilterInput>;
  or?: InputMaybe<Array<CommunicationSkillsFilterInput>>;
};

export enum ContactEntityType {
  Administrative = 'ADMINISTRATIVE',
  Billing = 'BILLING',
  Employer = 'EMPLOYER',
  HumanResource = 'HUMAN_RESOURCE',
  Other = 'OTHER',
  Person = 'PERSON',
  Press = 'PRESS'
}

export type ContactPoint = {
  __typename?: 'ContactPoint';
  period?: Maybe<Period>;
  rank?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<ContactPointSystem>;
  use?: Maybe<ContactPointUse>;
  value?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ContactPoint */
export type ContactPointFilterInput = {
  and?: InputMaybe<Array<ContactPointFilterInput>>;
  not?: InputMaybe<ContactPointFilterInput>;
  or?: InputMaybe<Array<ContactPointFilterInput>>;
};

export enum ContactPointSystem {
  Bluesky = 'BLUESKY',
  Discord = 'DISCORD',
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Fax = 'FAX',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Mastodon = 'MASTODON',
  Mobile = 'MOBILE',
  Other = 'OTHER',
  Phone = 'PHONE',
  Pinterest = 'PINTEREST',
  Snapchat = 'SNAPCHAT',
  Threads = 'THREADS',
  Tiktok = 'TIKTOK',
  Twitch = 'TWITCH',
  Twitter = 'TWITTER',
  Website = 'WEBSITE',
  Youtube = 'YOUTUBE'
}

export enum ContactPointUse {
  Home = 'HOME',
  Mobile = 'MOBILE',
  Old = 'OLD',
  Temp = 'TEMP',
  Work = 'WORK'
}

export type ContactPowersDevStatsInput = {
  amount: Scalars['Int']['input'];
  days: Scalars['Int']['input'];
};

export type ContactTopElements = {
  __typename?: 'ContactTopElements';
  elements: Array<CreativityElement>;
  person: PersonLean;
};

/** The filterable fields of type ContactTopElements */
export type ContactTopElementsFilterInput = {
  and?: InputMaybe<Array<ContactTopElementsFilterInput>>;
  not?: InputMaybe<ContactTopElementsFilterInput>;
  or?: InputMaybe<Array<ContactTopElementsFilterInput>>;
};

export type ContactTopElementsInput = {
  amount: Scalars['Int']['input'];
};

export type ContactWithGrowScore = {
  __typename?: 'ContactWithGrowScore';
  person: Person;
  score: Scalars['Int']['output'];
  userRank: UserRank;
};

/** The filterable fields of type ContactWithGrowScore */
export type ContactWithGrowScoreFilterInput = {
  and?: InputMaybe<Array<ContactWithGrowScoreFilterInput>>;
  not?: InputMaybe<ContactWithGrowScoreFilterInput>;
  or?: InputMaybe<Array<ContactWithGrowScoreFilterInput>>;
};

export type Contacts = {
  __typename?: 'Contacts';
  bluesky?: Maybe<Scalars['String']['output']>;
  discord?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  github?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  mastodon?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pinterest?: Maybe<Scalars['String']['output']>;
  snapchat?: Maybe<Scalars['String']['output']>;
  threads?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitch?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Contacts */
export type ContactsFilterInput = {
  and?: InputMaybe<Array<ContactsFilterInput>>;
  not?: InputMaybe<ContactsFilterInput>;
  or?: InputMaybe<Array<ContactsFilterInput>>;
};

export type ContactsWithHighestScoreInput = {
  limit: Scalars['Int']['input'];
};

export type ContractType = Node & {
  __typename?: 'ContractType';
  desc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localizedDesc?: Maybe<LocalizedText>;
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ContractType */
export type ContractTypeFilterInput = {
  and?: InputMaybe<Array<ContractTypeFilterInput>>;
  desc?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContractTypeFilterInput>;
  or?: InputMaybe<Array<ContractTypeFilterInput>>;
};

/** Contains information for linking 'ContractType' to other entities */
export type ContractTypeRelationInput = {
  /** The identifier of 'ContractType' */
  id: Scalars['ID']['input'];
};

export type ContractTypeSortInput = {
  desc?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type ContractTypesResult = {
  __typename?: 'ContractTypesResult';
  contractTypes: Array<ContractType>;
};

/** The filterable fields of type ContractTypesResult */
export type ContractTypesResultFilterInput = {
  and?: InputMaybe<Array<ContractTypesResultFilterInput>>;
  not?: InputMaybe<ContractTypesResultFilterInput>;
  or?: InputMaybe<Array<ContractTypesResultFilterInput>>;
};

export type Conversation = Node & {
  __typename?: 'Conversation';
  createdAt: Scalars['DateTime']['output'];
  createdById: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  participantIds: Array<Scalars['UUID']['output']>;
};

export type ConversationEvent = {
  __typename?: 'ConversationEvent';
  conversationId: Scalars['UUID']['output'];
  message?: Maybe<ChatMessage>;
  presence?: Maybe<PresenceIndicator>;
  readReceipt?: Maybe<ConversationReadReceipt>;
  type: ConversationEventType;
  typing?: Maybe<TypingIndicator>;
};

/** The filterable fields of type ConversationEvent */
export type ConversationEventFilterInput = {
  and?: InputMaybe<Array<ConversationEventFilterInput>>;
  not?: InputMaybe<ConversationEventFilterInput>;
  or?: InputMaybe<Array<ConversationEventFilterInput>>;
};

export enum ConversationEventType {
  MessageCreated = 'MESSAGE_CREATED',
  PresenceChanged = 'PRESENCE_CHANGED',
  ReadReceiptUpdated = 'READ_RECEIPT_UPDATED',
  TypingChanged = 'TYPING_CHANGED'
}

/** The filterable fields of type Conversation */
export type ConversationFilterInput = {
  and?: InputMaybe<Array<ConversationFilterInput>>;
  not?: InputMaybe<ConversationFilterInput>;
  or?: InputMaybe<Array<ConversationFilterInput>>;
};

export type ConversationLifecycleEvent = {
  __typename?: 'ConversationLifecycleEvent';
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['UUID']['output'];
  type: ConversationLifecycleEventType;
};

/** The filterable fields of type ConversationLifecycleEvent */
export type ConversationLifecycleEventFilterInput = {
  and?: InputMaybe<Array<ConversationLifecycleEventFilterInput>>;
  not?: InputMaybe<ConversationLifecycleEventFilterInput>;
  or?: InputMaybe<Array<ConversationLifecycleEventFilterInput>>;
};

export enum ConversationLifecycleEventType {
  Created = 'CREATED',
  Deleted = 'DELETED'
}

export type ConversationMessagesInput = {
  afterMessageId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['UUID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationReadReceipt = {
  __typename?: 'ConversationReadReceipt';
  conversationId: Scalars['UUID']['output'];
  lastReadMessageId: Scalars['UUID']['output'];
  personId: Scalars['UUID']['output'];
  readAt: Scalars['DateTime']['output'];
};

/** The filterable fields of type ConversationReadReceipt */
export type ConversationReadReceiptFilterInput = {
  and?: InputMaybe<Array<ConversationReadReceiptFilterInput>>;
  not?: InputMaybe<ConversationReadReceiptFilterInput>;
  or?: InputMaybe<Array<ConversationReadReceiptFilterInput>>;
};

export type CountriesResult = {
  __typename?: 'CountriesResult';
  countries: Array<Country>;
};

/** The filterable fields of type CountriesResult */
export type CountriesResultFilterInput = {
  and?: InputMaybe<Array<CountriesResultFilterInput>>;
  not?: InputMaybe<CountriesResultFilterInput>;
  or?: InputMaybe<Array<CountriesResultFilterInput>>;
};

export type Country = Node & {
  __typename?: 'Country';
  hasStates?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  iso2?: Maybe<Scalars['String']['output']>;
  iso3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  obsolete?: Maybe<Scalars['Boolean']['output']>;
  osmId?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type Country */
export type CountryFilterInput = {
  and?: InputMaybe<Array<CountryFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  iso2?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CountryFilterInput>;
  or?: InputMaybe<Array<CountryFilterInput>>;
};

/** Filtering options for a list of elements with type Country */
export type CountryListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<CountryFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<CountryFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<CountryFilterInput>;
};

/** Contains information for linking 'Country' to other entities */
export type CountryRelationInput = {
  /** The identifier of 'Country' */
  id: Scalars['ID']['input'];
};

export type CountryState = Node & {
  __typename?: 'CountryState';
  countryId: Scalars['UUID']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  osmId?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type CountryState */
export type CountryStateFilterInput = {
  and?: InputMaybe<Array<CountryStateFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CountryStateFilterInput>;
  or?: InputMaybe<Array<CountryStateFilterInput>>;
};

/** Contains information for linking 'CountryState' to other entities */
export type CountryStateRelationInput = {
  /** The identifier of 'CountryState' */
  id: Scalars['ID']['input'];
};

export type CountryStatesByCountryInput = {
  countryId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CountryStatesByCountryResult = {
  __typename?: 'CountryStatesByCountryResult';
  states: Array<CountryState>;
};

/** The filterable fields of type CountryStatesByCountryResult */
export type CountryStatesByCountryResultFilterInput = {
  and?: InputMaybe<Array<CountryStatesByCountryResultFilterInput>>;
  not?: InputMaybe<CountryStatesByCountryResultFilterInput>;
  or?: InputMaybe<Array<CountryStatesByCountryResultFilterInput>>;
};

/** The input data for creating an instance of Address */
export type CreateAddressDataInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  district?: InputMaybe<Scalars['String']['input']>;
  line?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<CountryStateRelationInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressType>;
  use: AddressUse;
};

/** Data structure to create a new instance of Address */
export type CreateAddressInput = {
  /** The actual data of Address */
  data: CreateAddressDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Address */
export type CreateAddressOutput = CreateAddressResult | ValidateAddressResult;

/** The result data structure of creating an instance of Address */
export type CreateAddressResult = {
  __typename?: 'CreateAddressResult';
  /** The actual data returned for Address */
  result: Address;
};

/** The input data for creating an instance of Certificate */
export type CreateCertificateDataInput = {
  date?: InputMaybe<CreateDateInstantDataInput>;
  name: Scalars['String']['input'];
  person: PersonRelationInput;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
};

/** Data structure to create a new instance of Certificate */
export type CreateCertificateInput = {
  /** The actual data of Certificate */
  data: CreateCertificateDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Certificate */
export type CreateCertificateOutput = CreateCertificateResult | ValidateCertificateResult;

/** The result data structure of creating an instance of Certificate */
export type CreateCertificateResult = {
  __typename?: 'CreateCertificateResult';
  /** The actual data returned for Certificate */
  result: Certificate;
};

/** The input data for creating an instance of Colors */
export type CreateColorsDataInput = {
  background?: InputMaybe<Scalars['Color']['input']>;
  text?: InputMaybe<Scalars['Color']['input']>;
};

/** The input data for creating an instance of ContactPoint */
export type CreateContactPointDataInput = {
  period?: InputMaybe<CreatePeriodDataInput>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  system?: InputMaybe<ContactPointSystem>;
  use?: InputMaybe<ContactPointUse>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of ContractType */
export type CreateContractTypeDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of ContractType */
export type CreateContractTypeInput = {
  /** The actual data of ContractType */
  data: CreateContractTypeDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of ContractType */
export type CreateContractTypeOutput = CreateContractTypeResult | ValidateContractTypeResult;

/** The result data structure of creating an instance of ContractType */
export type CreateContractTypeResult = {
  __typename?: 'CreateContractTypeResult';
  /** The actual data returned for ContractType */
  result: ContractType;
};

export type CreateConversationInput = {
  participantIds: Array<Scalars['UUID']['input']>;
};

/** The input data for creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeDataInput = {
  apiVersion: Scalars['Int']['input'];
  configuration?: InputMaybe<Scalars['Object']['input']>;
  content?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
};

/** Data structure to create a new instance of CurriculumVitae */
export type CreateCurriculumVitaeInput = {
  /** The actual data of CurriculumVitae */
  data: CreateCurriculumVitaeDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeOutput = CreateCurriculumVitaeResult | ValidateCurriculumVitaeResult;

/** The result data structure of creating an instance of CurriculumVitae */
export type CreateCurriculumVitaeResult = {
  __typename?: 'CreateCurriculumVitaeResult';
  /** The actual data returned for CurriculumVitae */
  result: CurriculumVitae;
};

/** The input data for creating an instance of DateInstant */
export type CreateDateInstantDataInput = {
  date: Scalars['Date']['input'];
  precision: DatePrecision;
};

/** The input data for creating an instance of Deceased */
export type CreateDeceasedDataInput = {
  deceased?: InputMaybe<Scalars['Boolean']['input']>;
  deceasedDate?: InputMaybe<CreateDateInstantDataInput>;
};

export type CreateDegreeDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type CreateDegreeInput = {
  data: CreateDegreeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDegreeOutput = CreateDegreeResult | ValidateDegreeResult;

export type CreateDegreeResult = {
  __typename?: 'CreateDegreeResult';
  result: Degree;
};

/** The input data for creating an instance of Document */
export type CreateDocumentDataInput = {
  category?: InputMaybe<DocumentClassifier>;
  content: CreateFileDataInput;
  fileName?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<DocumentGroupRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input data for creating an instance of DocumentGroup */
export type CreateDocumentGroupDataInput = {
  name: Scalars['String']['input'];
};

/** Data structure to create a new instance of DocumentGroup */
export type CreateDocumentGroupInput = {
  /** The actual data of the document group */
  data: CreateDocumentGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

/** The result of creating an instance of document group */
export type CreateDocumentGroupOutput = CreateDocumentGroupResult | TooManyRecordsResult | ValidateDocumentGroupResult;

/** The result data structure of creating an instance of DocumentGroup */
export type CreateDocumentGroupResult = {
  __typename?: 'CreateDocumentGroupResult';
  /** The actual data returned for DocumentGroup */
  result: DocumentGroup;
};

/** Data structure to create a new instance of Document */
export type CreateDocumentInput = {
  /** The actual data of Document */
  data: CreateDocumentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Document */
export type CreateDocumentOutput = CreateDocumentResult | ValidateDocumentResult;

/** The result data structure of creating an instance of Document */
export type CreateDocumentResult = {
  __typename?: 'CreateDocumentResult';
  /** The actual data returned for Document */
  result: Document;
};

/** The input data for creating an instance of Education */
export type CreateEducationDataInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  degree?: InputMaybe<DegreeRelationInput>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  field: Scalars['String']['input'];
  institution?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
  startDate: CreateDateInstantDataInput;
};

/** Data structure to create a new instance of Education */
export type CreateEducationInput = {
  /** The actual data of Education */
  data: CreateEducationDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Education */
export type CreateEducationOutput = CreateEducationResult | ValidateEducationResult;

/** The result data structure of creating an instance of Education */
export type CreateEducationResult = {
  __typename?: 'CreateEducationResult';
  /** The actual data returned for Education */
  result: Education;
};

/** The input data for creating an instance of ElementWeight */
export type CreateElementWeightDataInput = {
  element?: InputMaybe<CreativityElement>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

/** The input data for creating an instance of Experience */
export type CreateExperienceDataInput = {
  activities?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<CountryRelationInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  industry?: InputMaybe<IndustryRelationInput>;
  jobTitle: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  person: PersonRelationInput;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
  startDate: CreateDateInstantDataInput;
};

/** Data structure to create a new instance of Experience */
export type CreateExperienceInput = {
  /** The actual data of Experience */
  data: CreateExperienceDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Experience */
export type CreateExperienceOutput = CreateExperienceResult | ValidateExperienceResult;

/** The result data structure of creating an instance of Experience */
export type CreateExperienceResult = {
  __typename?: 'CreateExperienceResult';
  /** The actual data returned for Experience */
  result: Experience;
};

/** The input data for creating an instance of Expertise */
export type CreateExpertiseDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  person: PersonRelationInput;
  position: Scalars['Int']['input'];
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
};

/** Data structure to create a new instance of Expertise */
export type CreateExpertiseInput = {
  /** The actual data of Expertise */
  data: CreateExpertiseDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Expertise */
export type CreateExpertiseOutput = CreateExpertiseResult | ValidateExpertiseResult;

/** The result data structure of creating an instance of Expertise */
export type CreateExpertiseResult = {
  __typename?: 'CreateExpertiseResult';
  /** The actual data returned for Expertise */
  result: Expertise;
};

/** The input data for creating an instance of ExtendedContactDetail */
export type CreateExtendedContactDetailDataInput = {
  address?: InputMaybe<AddressRelationInput>;
  name?: InputMaybe<Array<InputMaybe<CreateHumanNameDataInput>>>;
  organization?: InputMaybe<OrganizationRelationInput>;
  purpose?: InputMaybe<ExtendedContactDetailRelationInput>;
  telecom?: InputMaybe<Array<InputMaybe<CreateContactPointDataInput>>>;
};

/** Data structure to create a new instance of ExtendedContactDetail */
export type CreateExtendedContactDetailInput = {
  /** The actual data of ExtendedContactDetail */
  data: CreateExtendedContactDetailDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of ExtendedContactDetail */
export type CreateExtendedContactDetailOutput = CreateExtendedContactDetailResult | ValidateExtendedContactDetailResult;

/** The result data structure of creating an instance of ExtendedContactDetail */
export type CreateExtendedContactDetailResult = {
  __typename?: 'CreateExtendedContactDetailResult';
  /** The actual data returned for ExtendedContactDetail */
  result: ExtendedContactDetail;
};

/** The input data for creating an instance of File */
export type CreateFileDataInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of Gender */
export type CreateGenderDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of Gender */
export type CreateGenderInput = {
  /** The actual data of Gender */
  data: CreateGenderDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Gender */
export type CreateGenderOutput = CreateGenderResult | ValidateGenderResult;

/** The result data structure of creating an instance of Gender */
export type CreateGenderResult = {
  __typename?: 'CreateGenderResult';
  /** The actual data returned for Gender */
  result: Gender;
};

/** The input data for creating an instance of HumanName */
export type CreateHumanNameDataInput = {
  family?: InputMaybe<Scalars['String']['input']>;
  given?: InputMaybe<Array<Scalars['String']['input']>>;
  period?: InputMaybe<CreatePeriodDataInput>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  use: NameUse;
};

/** The input data for creating an instance of Industry */
export type CreateIndustryDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of Industry */
export type CreateIndustryInput = {
  /** The actual data of Industry */
  data: CreateIndustryDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Industry */
export type CreateIndustryOutput = CreateIndustryResult | ValidateIndustryResult;

/** The result data structure of creating an instance of Industry */
export type CreateIndustryResult = {
  __typename?: 'CreateIndustryResult';
  /** The actual data returned for Industry */
  result: Industry;
};

/** The input data for creating an instance of JobDepartment */
export type CreateJobDepartmentDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of JobDepartment */
export type CreateJobDepartmentInput = {
  /** The actual data of JobDepartment */
  data: CreateJobDepartmentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of JobDepartment */
export type CreateJobDepartmentOutput = CreateJobDepartmentResult | ValidateJobDepartmentResult;

/** The result data structure of creating an instance of JobDepartment */
export type CreateJobDepartmentResult = {
  __typename?: 'CreateJobDepartmentResult';
  /** The actual data returned for JobDepartment */
  result: JobDepartment;
};

/** The input data for creating an instance of JobLocation */
export type CreateJobLocationDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of JobLocation */
export type CreateJobLocationInput = {
  /** The actual data of JobLocation */
  data: CreateJobLocationDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of JobLocation */
export type CreateJobLocationOutput = CreateJobLocationResult | ValidateJobLocationResult;

/** The result data structure of creating an instance of JobLocation */
export type CreateJobLocationResult = {
  __typename?: 'CreateJobLocationResult';
  /** The actual data returned for JobLocation */
  result: JobLocation;
};

/** The input data for creating an instance of LanguageSkill */
export type CreateLanguageSkillDataInput = {
  cefr?: InputMaybe<CefrScale>;
  languageTag: Scalars['String']['input'];
  nativeSpeaker: Scalars['Boolean']['input'];
  person: PersonRelationInput;
  selfAssessed?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
};

/** Data structure to create a new instance of LanguageSkill */
export type CreateLanguageSkillInput = {
  /** The actual data of LanguageSkill */
  data: CreateLanguageSkillDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of LanguageSkill */
export type CreateLanguageSkillOutput = CreateLanguageSkillResult | ValidateLanguageSkillResult;

/** The result data structure of creating an instance of LanguageSkill */
export type CreateLanguageSkillResult = {
  __typename?: 'CreateLanguageSkillResult';
  /** The actual data returned for LanguageSkill */
  result: LanguageSkill;
};

/** The input data for creating an instance of LocalizedText */
export type CreateLocalizedTextDataInput = {
  english?: InputMaybe<Scalars['String']['input']>;
  german?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of MaritalStatus */
export type CreateMaritalStatusDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of MaritalStatus */
export type CreateMaritalStatusInput = {
  /** The actual data of MaritalStatus */
  data: CreateMaritalStatusDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MaritalStatus */
export type CreateMaritalStatusOutput = CreateMaritalStatusResult | ValidateMaritalStatusResult;

/** The result data structure of creating an instance of MaritalStatus */
export type CreateMaritalStatusResult = {
  __typename?: 'CreateMaritalStatusResult';
  /** The actual data returned for MaritalStatus */
  result: MaritalStatus;
};

/** The input data for creating an instance of MatchAccess */
export type CreateMatchAccessDataInput = {
  design: AccessLevel;
  discover: AccessLevel;
  match: AccessLevel;
  person: PersonRelationInput;
  prepare: AccessLevel;
};

/** The input data for creating an instance of MatchCandidate */
export type CreateMatchCandidateDataInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<MatchRelationInput>;
  person?: InputMaybe<PersonRelationInput>;
};

/** Data structure to create a new instance of MatchCandidate */
export type CreateMatchCandidateInput = {
  /** The actual data of MatchCandidate */
  data: CreateMatchCandidateDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MatchCandidate */
export type CreateMatchCandidateOutput = CreateMatchCandidateResult | ValidateMatchCandidateResult;

/** The result data structure of creating an instance of MatchCandidate */
export type CreateMatchCandidateResult = {
  __typename?: 'CreateMatchCandidateResult';
  /** The actual data returned for MatchCandidate */
  result: MatchCandidate;
};

/** The input data for creating multiple instances of MatchCandidate */
export type CreateMatchCandidatesDataInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  person?: InputMaybe<PersonRelationInput>;
};

/** Data structure to create a multiple instances of MatchCandidate */
export type CreateMatchCandidatesInput = {
  /** The actual data of MatchCandidate */
  data: Array<CreateMatchCandidatesDataInput>;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<MatchRelationInput>;
};

export type CreateMatchCandidatesOutput = {
  __typename?: 'CreateMatchCandidatesOutput';
  match?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type CreateMatchCandidatesOutput */
export type CreateMatchCandidatesOutputFilterInput = {
  and?: InputMaybe<Array<CreateMatchCandidatesOutputFilterInput>>;
  not?: InputMaybe<CreateMatchCandidatesOutputFilterInput>;
  or?: InputMaybe<Array<CreateMatchCandidatesOutputFilterInput>>;
};

/** The input data for creating an instance of Match */
export type CreateMatchDataInput = {
  access?: InputMaybe<Array<CreateMatchAccessDataInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<Scalars['Object']['input']>;
  matchMode?: InputMaybe<MatchMode>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedItem?: InputMaybe<SharedItemRelationInput>;
};

/** Data structure to create a new instance of Match */
export type CreateMatchInput = {
  /** The actual data of Match */
  data: CreateMatchDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Match */
export type CreateMatchOutput = CreateMatchResult | ValidateMatchResult;

/** The result data structure of creating an instance of Match */
export type CreateMatchResult = {
  __typename?: 'CreateMatchResult';
  /** The actual data returned for Match */
  result: Match;
};

/** The input data for creating an instance of MatchResult */
export type CreateMatchResultDataInput = {
  candidateCount?: InputMaybe<Scalars['Int']['input']>;
  design?: InputMaybe<Scalars['Object']['input']>;
  matchId: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<CreateMatchResultTeamDataInput>>;
};

/** Data structure to create a new instance of MatchResult */
export type CreateMatchResultInput = {
  /** The actual data of MatchResult */
  data: CreateMatchResultDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of MatchResult */
export type CreateMatchResultOutput = CreateMatchResultResult | ValidateMatchResultResult;

/** The result data structure of creating an instance of MatchResult */
export type CreateMatchResultResult = {
  __typename?: 'CreateMatchResultResult';
  /** The actual data returned for MatchResult */
  result: MatchResult;
};

/** The input data for creating an instance of MatchResultTeam */
export type CreateMatchResultTeamDataInput = {
  persons?: InputMaybe<Array<InputMaybe<PersonRelationInput>>>;
  result?: InputMaybe<Scalars['Object']['input']>;
};

/** The input data for creating an instance of Organization */
export type CreateOrganizationDataInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<Array<InputMaybe<ExtendedContactDetailRelationInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partOf?: InputMaybe<OrganizationRelationInput>;
  type?: InputMaybe<OrganizationType>;
};

/** Data structure to create a new instance of Organization */
export type CreateOrganizationInput = {
  /** The actual data of Organization */
  data: CreateOrganizationDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of Organization */
export type CreateOrganizationOutput = CreateOrganizationResult | ValidateOrganizationResult;

/** The result data structure of creating an instance of Organization */
export type CreateOrganizationResult = {
  __typename?: 'CreateOrganizationResult';
  /** The actual data returned for Organization */
  result: Organization;
};

/** The input data for creating an instance of Period */
export type CreatePeriodDataInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** The input data for creating an instance of Person */
export type CreatePersonDataInput = {
  administrativeGender?: InputMaybe<AdministrativeGender>;
  alternativeAvatar?: InputMaybe<CreateFileDataInput>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<CreateFileDataInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  childCount?: InputMaybe<Scalars['Int']['input']>;
  citizenships?: InputMaybe<Array<InputMaybe<CountryRelationInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<ContractTypeRelationInput>;
  country?: InputMaybe<CountryRelationInput>;
  countryState?: InputMaybe<CountryStateRelationInput>;
  currentActivity?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  currentTasks?: InputMaybe<Scalars['String']['input']>;
  deceased?: InputMaybe<CreateDeceasedDataInput>;
  drivingLicence?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailPrimary: Scalars['String']['input'];
  gender?: InputMaybe<GenderRelationInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  jobDepartment?: InputMaybe<JobDepartmentRelationInput>;
  jobLocation?: InputMaybe<JobLocationRelationInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatusRelationInput>;
  miscellaneous?: InputMaybe<Scalars['String']['input']>;
  name: CreateHumanNameDataInput;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  sharedAttributes?: InputMaybe<CreatePersonSharedAttributesDataInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workingTimeModel?: InputMaybe<WorkingTimeModelRelationInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** The input data for creating an instance of PersonGroup */
export type CreatePersonGroupDataInput = {
  name: Scalars['String']['input'];
};

/** Data structure to create a new instance of PersonGroup */
export type CreatePersonGroupInput = {
  /** The actual data of the document group */
  data: CreatePersonGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePersonGroupOutput = CreatePersonGroupResult | TooManyRecordsResult | ValidatePersonGroupResult;

/** The result data structure of creating an instance of PersonGroup */
export type CreatePersonGroupResult = {
  __typename?: 'CreatePersonGroupResult';
  /** The actual data returned for PersonGroup */
  result: PersonGroup;
};

/** Data structure to create a new instance of Person */
export type CreatePersonInput = {
  /** The actual data of Person */
  data: CreatePersonDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Must match the subject Id from Keycloak */
  person: Scalars['String']['input'];
};

/** The result of creating an instance of Person */
export type CreatePersonOutput = CreatePersonResult | ValidatePersonResult;

/** The result data structure of creating an instance of Person */
export type CreatePersonResult = {
  __typename?: 'CreatePersonResult';
  /** The actual data returned for Person */
  result: Person;
};

/** The input data for creating an instance of PersonSharedAttributes */
export type CreatePersonSharedAttributesDataInput = {
  sharedAge?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedApartmentNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedBio?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedBirthdate?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedChildCount?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCitizenships?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCity?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedContractType?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCountry?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentActivity?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentEmployer?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedCurrentTasks?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedDriversLicense?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedEmail?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedGender?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedHouseNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedMaritalStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedMiscellaneous?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedNationality?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedProfession?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedState?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedStreet?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedWebsite?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedWorkingTimeModel?: InputMaybe<Array<Scalars['String']['input']>>;
  sharedZipCode?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input data for creating an instance of PinGroup */
export type CreatePinGroupDataInput = {
  name: Scalars['String']['input'];
  pinType: PinType;
};

/** Data structure to create a new instance of PersonGroup */
export type CreatePinGroupInput = {
  /** The actual data of the pin group */
  data: CreatePinGroupDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the person the group belongs to */
  person?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePinGroupOutput = CreatePinGroupResult | TooManyRecordsResult | ValidatePinGroupResult;

/** The result data structure of creating an instance of PinGroup */
export type CreatePinGroupResult = {
  __typename?: 'CreatePinGroupResult';
  /** The actual data returned for PinGroup */
  result: PinGroup;
};

/** The input data for creating an instance of SelfAssessment */
export type CreateSelfAssessmentDataInput = {
  questions?: InputMaybe<Array<SelfAssessmentStatementRelationInput>>;
};

/** Data structure to create a new instance of SelfAssessment */
export type CreateSelfAssessmentInput = {
  /** The actual data of SelfAssessment */
  data: CreateSelfAssessmentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of SelfAssessment */
export type CreateSelfAssessmentOutput = CreateSelfAssessmentResult | ValidateSelfAssessmentResult;

/** The result data structure of creating an instance of SelfAssessment */
export type CreateSelfAssessmentResult = {
  __typename?: 'CreateSelfAssessmentResult';
  /** The actual data returned for SelfAssessment */
  result: SelfAssessment;
};

/** The input data for creating an instance of SharedItemComment */
export type CreateSharedItemCommentDataInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<PersonRelationInput>;
  sharedItem?: InputMaybe<SharedItemRelationInput>;
  sharedItemId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Data structure to create a new instance of SharedItemComment */
export type CreateSharedItemCommentInput = {
  /** The actual data of SharedItemComment */
  data: CreateSharedItemCommentDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of SharedItemComment */
export type CreateSharedItemCommentOutput = CreateSharedItemCommentResult | ValidateSharedItemCommentResult;

/** The result data structure of creating an instance of SharedItemComment */
export type CreateSharedItemCommentResult = {
  __typename?: 'CreateSharedItemCommentResult';
  /** The actual data returned for SharedItemComment */
  result: SharedItemComment;
};

/** The input data for creating an instance of SharedItem */
export type CreateSharedItemDataInput = {
  darkMode?: InputMaybe<CreateColorsDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<CreateFileDataInput>>;
  filesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  images?: InputMaybe<Array<CreateFileDataInput>>;
  imagesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  itemType?: InputMaybe<SharedItemType>;
  lightMode?: InputMaybe<CreateColorsDataInput>;
  mainImage?: InputMaybe<CreateFileDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Data structure to create a new instance of SharedItem */
export type CreateSharedItemInput = {
  /** The actual data of SharedItem */
  data: CreateSharedItemDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of SharedItem */
export type CreateSharedItemOutput = CreateSharedItemResult | ValidateSharedItemResult;

/** The result data structure of creating an instance of SharedItem */
export type CreateSharedItemResult = {
  __typename?: 'CreateSharedItemResult';
  /** The actual data returned for SharedItem */
  result: SharedItem;
};

/** The input data for creating an instance of TeamProfile */
export type CreateTeamProfileDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  weights: Array<CreateElementWeightDataInput>;
};

/** Data structure to create a new instance of TeamProfile */
export type CreateTeamProfileInput = {
  /** The actual data of TeamProfile */
  data: CreateTeamProfileDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of TeamProfile */
export type CreateTeamProfileOutput = CreateTeamProfileResult | ValidateTeamProfileResult;

/** The result data structure of creating an instance of TeamProfile */
export type CreateTeamProfileResult = {
  __typename?: 'CreateTeamProfileResult';
  /** The actual data returned for TeamProfile */
  result: TeamProfile;
};

/** The input data for creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

/** Data structure to create a new instance of WorkingTimeModel */
export type CreateWorkingTimeModelInput = {
  /** The actual data of WorkingTimeModel */
  data: CreateWorkingTimeModelDataInput;
  /** If true, only the validation is performed but the instance will not be created */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The result of creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelOutput = CreateWorkingTimeModelResult | ValidateWorkingTimeModelResult;

/** The result data structure of creating an instance of WorkingTimeModel */
export type CreateWorkingTimeModelResult = {
  __typename?: 'CreateWorkingTimeModelResult';
  /** The actual data returned for WorkingTimeModel */
  result: WorkingTimeModel;
};

export enum CreativityCategory {
  CognitiveIntelligence = 'COGNITIVE_INTELLIGENCE',
  EmotionalIntelligence = 'EMOTIONAL_INTELLIGENCE',
  FictionalIntelligence = 'FICTIONAL_INTELLIGENCE',
  IdentityCore = 'IDENTITY_CORE',
  MolecularIntelligence = 'MOLECULAR_INTELLIGENCE'
}

/**
 * enum MaritalStatus {
 * ANNULLED,
 * DIVORCED,
 * INTERLOCUTORY
 * LEGALLY_SEPARATED
 * MARRIED
 * COMMON_LAW
 * POLYGAMOUS
 * DOMESTIC_PARTNER
 * UNMARRIED
 * NEVER_MARRIED
 * WIDOWED
 * UNKNOWN
 * }
 */
export enum CreativityElement {
  Abstraction = 'ABSTRACTION',
  Adaption = 'ADAPTION',
  Aggression = 'AGGRESSION',
  Alertness = 'ALERTNESS',
  Altruism = 'ALTRUISM',
  Angst = 'ANGST',
  Audio = 'AUDIO',
  Autonomy = 'AUTONOMY',
  Balance = 'BALANCE',
  Beauty = 'BEAUTY',
  Biorhythm = 'BIORHYTHM',
  Candor = 'CANDOR',
  Charisma = 'CHARISMA',
  Composition = 'COMPOSITION',
  Concentration = 'CONCENTRATION',
  Cooperation = 'COOPERATION',
  Coordination = 'COORDINATION',
  Courage = 'COURAGE',
  Curiosity = 'CURIOSITY',
  Diligence = 'DILIGENCE',
  Disgust = 'DISGUST',
  Dolor = 'DOLOR',
  Doubt = 'DOUBT',
  Empathy = 'EMPATHY',
  Expression = 'EXPRESSION',
  Fairness = 'FAIRNESS',
  Faith = 'FAITH',
  Fidelity = 'FIDELITY',
  FlightMotion = 'FLIGHT_MOTION',
  Gender = 'GENDER',
  Greed = 'GREED',
  Grief = 'GRIEF',
  Habit = 'HABIT',
  Homeostasis = 'HOMEOSTASIS',
  Honesty = 'HONESTY',
  Hope = 'HOPE',
  Hormones = 'HORMONES',
  Humor = 'HUMOR',
  Ignorance = 'IGNORANCE',
  Imagination = 'IMAGINATION',
  Immunity = 'IMMUNITY',
  Improvisation = 'IMPROVISATION',
  Infatuation = 'INFATUATION',
  Inspiration = 'INSPIRATION',
  Intention = 'INTENTION',
  Introversion = 'INTROVERSION',
  Intuition = 'INTUITION',
  Joy = 'JOY',
  Language = 'LANGUAGE',
  Love = 'LOVE',
  Lust = 'LUST',
  Memory = 'MEMORY',
  Metabolism = 'METABOLISM',
  Mindfulness = 'MINDFULNESS',
  Modesty = 'MODESTY',
  Motorics = 'MOTORICS',
  Objectiation = 'OBJECTIATION',
  Olfaction = 'OLFACTION',
  Opposition = 'OPPOSITION',
  Orientation = 'ORIENTATION',
  Passion = 'PASSION',
  Patience = 'PATIENCE',
  Perception = 'PERCEPTION',
  Perseverance = 'PERSEVERANCE',
  Reflexes = 'REFLEXES',
  Respiration = 'RESPIRATION',
  Responsibility = 'RESPONSIBILITY',
  Satisfaction = 'SATISFACTION',
  SelfAwareness = 'SELF_AWARENESS',
  Sensitivity = 'SENSITIVITY',
  Skillfulness = 'SKILLFULNESS',
  Sleep = 'SLEEP',
  Spontaneity = 'SPONTANEITY',
  Strategy = 'STRATEGY',
  Taste = 'TASTE',
  Temper = 'TEMPER',
  Tenderness = 'TENDERNESS',
  Tolerance = 'TOLERANCE',
  Touch = 'TOUCH',
  Vision = 'VISION',
  Willpower = 'WILLPOWER',
  Wisdom = 'WISDOM'
}

export type CreativitySkills = {
  __typename?: 'CreativitySkills';
  ableToAbstract?: Maybe<Scalars['SkillRating']['output']>;
  agile?: Maybe<Scalars['SkillRating']['output']>;
  imaginative?: Maybe<Scalars['SkillRating']['output']>;
  multicultural?: Maybe<Scalars['SkillRating']['output']>;
  nonConformist?: Maybe<Scalars['SkillRating']['output']>;
  resourceful?: Maybe<Scalars['SkillRating']['output']>;
};

/** The filterable fields of type CreativitySkills */
export type CreativitySkillsFilterInput = {
  and?: InputMaybe<Array<CreativitySkillsFilterInput>>;
  not?: InputMaybe<CreativitySkillsFilterInput>;
  or?: InputMaybe<Array<CreativitySkillsFilterInput>>;
};

export type CurriculumVitae = Node & {
  __typename?: 'CurriculumVitae';
  apiVersion: Scalars['Int']['output'];
  configuration?: Maybe<Scalars['Object']['output']>;
  content?: Maybe<Scalars['Object']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person: Person;
};

export type CurriculumVitaeConnection = {
  __typename?: 'CurriculumVitaeConnection';
  edges: Array<CurriculumVitaeEdge>;
  nodes: Array<CurriculumVitae>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CurriculumVitaeEdge = {
  __typename?: 'CurriculumVitaeEdge';
  cursor: Scalars['String']['output'];
  node: CurriculumVitae;
};

/** The filterable fields of type CurriculumVitae */
export type CurriculumVitaeFilterInput = {
  and?: InputMaybe<Array<CurriculumVitaeFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CurriculumVitaeFilterInput>;
  or?: InputMaybe<Array<CurriculumVitaeFilterInput>>;
};

/** The parameters for requesting multiple instances of CurriculumVitae. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type CurriculumVitaeQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<CurriculumVitaeSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<CurriculumVitaeFilterInput>;
};

export type CurriculumVitaeSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CvBatchImportResult = {
  __typename?: 'CvBatchImportResult';
  results: Array<CvFileResult>;
};

/** The filterable fields of type CvBatchImportResult */
export type CvBatchImportResultFilterInput = {
  and?: InputMaybe<Array<CvBatchImportResultFilterInput>>;
  not?: InputMaybe<CvBatchImportResultFilterInput>;
  or?: InputMaybe<Array<CvBatchImportResultFilterInput>>;
};

/** One document in an admin batch CV import. */
export type CvFileInput = {
  file: Scalars['Binary']['input'];
  fileName: Scalars['String']['input'];
};

/** Per-file result of importCvBatch. */
export type CvFileResult = {
  __typename?: 'CvFileResult';
  /** Resulting person's primary email — the scanned address, or a generated cv-import+<id>@smycles.invalid when the CV had none; null on FAILED. */
  email?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  /** Resulting person's given name, for a display label; null on FAILED or when unknown. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Resulting person's family name; null on FAILED or when unknown. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** How the person was matched (e.g. "primary_email"); null when created or failed. */
  matchedBy?: Maybe<Scalars['String']['output']>;
  /** Error reason (FAILED) or non-fatal warnings (e.g. an unresolved gender), joined; null when clean. */
  message?: Maybe<Scalars['String']['output']>;
  outcome: CvImportOutcome;
  /** The created/updated person; null when outcome is FAILED. */
  personId?: Maybe<Scalars['ID']['output']>;
};

/** The filterable fields of type CvFileResult */
export type CvFileResultFilterInput = {
  and?: InputMaybe<Array<CvFileResultFilterInput>>;
  not?: InputMaybe<CvFileResultFilterInput>;
  or?: InputMaybe<Array<CvFileResultFilterInput>>;
};

/** What happened to a single CV in a batch import. */
export enum CvImportOutcome {
  /** No unambiguous match; a new candidate Person was created. */
  Created = 'CREATED',
  /** Extraction or persistence failed for this file; nothing was written. */
  Failed = 'FAILED',
  /** The CV matched an existing person by primary email; missing fields/collections were filled. */
  Updated = 'UPDATED'
}

export type DailyQuotaExceeded = {
  __typename?: 'DailyQuotaExceeded';
  limit?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type DailyQuotaExceeded */
export type DailyQuotaExceededFilterInput = {
  and?: InputMaybe<Array<DailyQuotaExceededFilterInput>>;
  not?: InputMaybe<DailyQuotaExceededFilterInput>;
  or?: InputMaybe<Array<DailyQuotaExceededFilterInput>>;
};

export type DateInstant = {
  __typename?: 'DateInstant';
  date: Scalars['Date']['output'];
  precision: DatePrecision;
};

/** The filterable fields of type DateInstant */
export type DateInstantFilterInput = {
  and?: InputMaybe<Array<DateInstantFilterInput>>;
  not?: InputMaybe<DateInstantFilterInput>;
  or?: InputMaybe<Array<DateInstantFilterInput>>;
};

export enum DatePrecision {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

/** Filtering for fields of type Date */
export type DateTimeFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<DateTimeFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<DateTimeFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<DateTimeFilterInput>>;
};

export type DateTimeInstant = {
  __typename?: 'DateTimeInstant';
  dateTime?: Maybe<Scalars['DateTime']['output']>;
  precision?: Maybe<DateTimePrecision>;
};

/** The filterable fields of type DateTimeInstant */
export type DateTimeInstantFilterInput = {
  and?: InputMaybe<Array<DateTimeInstantFilterInput>>;
  not?: InputMaybe<DateTimeInstantFilterInput>;
  or?: InputMaybe<Array<DateTimeInstantFilterInput>>;
};

export enum DateTimePrecision {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Precise = 'PRECISE',
  Second = 'SECOND',
  Year = 'YEAR'
}

export type Deceased = {
  __typename?: 'Deceased';
  deceased?: Maybe<Scalars['Boolean']['output']>;
  deceasedDate?: Maybe<DateInstant>;
};

/** The filterable fields of type Deceased */
export type DeceasedFilterInput = {
  and?: InputMaybe<Array<DeceasedFilterInput>>;
  not?: InputMaybe<DeceasedFilterInput>;
  or?: InputMaybe<Array<DeceasedFilterInput>>;
};

export type Degree = Node & {
  __typename?: 'Degree';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DegreeRelationInput = {
  id: Scalars['ID']['input'];
};

export type DegreesResult = {
  __typename?: 'DegreesResult';
  degrees: Array<Degree>;
};

/** Data structure for deleting an instance of Address */
export type DeleteAddressInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Address */
export type DeleteAddressOutput = {
  __typename?: 'DeleteAddressOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Certificate */
export type DeleteCertificateInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Certificate */
export type DeleteCertificateOutput = {
  __typename?: 'DeleteCertificateOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of ContractType */
export type DeleteContractTypeInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of ContractType */
export type DeleteContractTypeOutput = {
  __typename?: 'DeleteContractTypeOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of CurriculumVitae */
export type DeleteCurriculumVitaeInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of CurriculumVitae */
export type DeleteCurriculumVitaeOutput = {
  __typename?: 'DeleteCurriculumVitaeOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

export type DeleteDegreeInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DeleteDegreeOutput = {
  __typename?: 'DeleteDegreeOutput';
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of DocumentGroup */
export type DeleteDocumentGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of DocumentGroup */
export type DeleteDocumentGroupOutput = {
  __typename?: 'DeleteDocumentGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Document */
export type DeleteDocumentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Document */
export type DeleteDocumentOutput = {
  __typename?: 'DeleteDocumentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Education */
export type DeleteEducationInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Education */
export type DeleteEducationOutput = {
  __typename?: 'DeleteEducationOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Experience */
export type DeleteExperienceInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Experience */
export type DeleteExperienceOutput = {
  __typename?: 'DeleteExperienceOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Expertise */
export type DeleteExpertiseInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Expertise */
export type DeleteExpertiseOutput = {
  __typename?: 'DeleteExpertiseOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of ExtendedContactDetail */
export type DeleteExtendedContactDetailInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of ExtendedContactDetail */
export type DeleteExtendedContactDetailOutput = {
  __typename?: 'DeleteExtendedContactDetailOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Gender */
export type DeleteGenderInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Gender */
export type DeleteGenderOutput = {
  __typename?: 'DeleteGenderOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Industry */
export type DeleteIndustryInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Industry */
export type DeleteIndustryOutput = {
  __typename?: 'DeleteIndustryOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of JobDepartment */
export type DeleteJobDepartmentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of JobDepartment */
export type DeleteJobDepartmentOutput = {
  __typename?: 'DeleteJobDepartmentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of JobLocation */
export type DeleteJobLocationInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of JobLocation */
export type DeleteJobLocationOutput = {
  __typename?: 'DeleteJobLocationOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of LanguageSkill */
export type DeleteLanguageSkillInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of LanguageSkill */
export type DeleteLanguageSkillOutput = {
  __typename?: 'DeleteLanguageSkillOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MaritalStatus */
export type DeleteMaritalStatusInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MaritalStatus */
export type DeleteMaritalStatusOutput = {
  __typename?: 'DeleteMaritalStatusOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MatchCandidate */
export type DeleteMatchCandidateInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MatchCandidate */
export type DeleteMatchCandidateOutput = {
  __typename?: 'DeleteMatchCandidateOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

export type DeleteMatchCandidatesInput = {
  candidates: Array<Scalars['UUID']['input']>;
  match?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeleteMatchCandidatesOutput = DeleteMatchCandidatesResult;

export type DeleteMatchCandidatesResult = {
  __typename?: 'DeleteMatchCandidatesResult';
  candidatesRemoved: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type DeleteMatchCandidatesResult */
export type DeleteMatchCandidatesResultFilterInput = {
  and?: InputMaybe<Array<DeleteMatchCandidatesResultFilterInput>>;
  not?: InputMaybe<DeleteMatchCandidatesResultFilterInput>;
  or?: InputMaybe<Array<DeleteMatchCandidatesResultFilterInput>>;
};

/** Data structure for deleting an instance of Match */
export type DeleteMatchInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Match */
export type DeleteMatchOutput = {
  __typename?: 'DeleteMatchOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of MatchResult */
export type DeleteMatchResultInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of MatchResult */
export type DeleteMatchResultOutput = {
  __typename?: 'DeleteMatchResultOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Organization */
export type DeleteOrganizationInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Organization */
export type DeleteOrganizationOutput = {
  __typename?: 'DeleteOrganizationOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of PersonGroup */
export type DeletePersonGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of PersonGroup */
export type DeletePersonGroupOutput = {
  __typename?: 'DeletePersonGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of Person */
export type DeletePersonInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of Person */
export type DeletePersonOutput = {
  __typename?: 'DeletePersonOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of PinGroup */
export type DeletePinGroupInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of PinGroup */
export type DeletePinGroupOutput = {
  __typename?: 'DeletePinGroupOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of SelfAssessment */
export type DeleteSelfAssessmentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of SelfAssessment */
export type DeleteSelfAssessmentOutput = {
  __typename?: 'DeleteSelfAssessmentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of SharedItemComment */
export type DeleteSharedItemCommentInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of SharedItemComment */
export type DeleteSharedItemCommentOutput = {
  __typename?: 'DeleteSharedItemCommentOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of SharedItem */
export type DeleteSharedItemInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of SharedItem */
export type DeleteSharedItemOutput = {
  __typename?: 'DeleteSharedItemOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of TeamProfile */
export type DeleteTeamProfileInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of TeamProfile */
export type DeleteTeamProfileOutput = {
  __typename?: 'DeleteTeamProfileOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

/** Data structure for deleting an instance of WorkingTimeModel */
export type DeleteWorkingTimeModelInput = {
  /** If true, only the validation is performed but the instance will not be deleted */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the instance to delete */
  id: Scalars['ID']['input'];
};

/** The result of deleting an instance of WorkingTimeModel */
export type DeleteWorkingTimeModelOutput = {
  __typename?: 'DeleteWorkingTimeModelOutput';
  /** The id of the instance that was deleted */
  id: Scalars['ID']['output'];
};

export type DetachProjectDocumentInput = {
  backdropFileId: Scalars['UUID']['input'];
  matchId: Scalars['UUID']['input'];
};

export type DetachProjectDocumentOutput = DetachProjectDocumentResult;

export type DetachProjectDocumentResult = {
  __typename?: 'DetachProjectDocumentResult';
  match: Match;
};

/** The filterable fields of type DetachProjectDocumentResult */
export type DetachProjectDocumentResultFilterInput = {
  and?: InputMaybe<Array<DetachProjectDocumentResultFilterInput>>;
  not?: InputMaybe<DetachProjectDocumentResultFilterInput>;
  or?: InputMaybe<Array<DetachProjectDocumentResultFilterInput>>;
};

/** The platform of a mobile device for push notifications. */
export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type Document = Node & SharableEntity & {
  __typename?: 'Document';
  category?: Maybe<DocumentClassifier>;
  content: File;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  group?: Maybe<DocumentGroup>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person: Person;
  powersExtractedAt?: Maybe<Scalars['DateTime']['output']>;
  preview?: Maybe<File>;
  sharedWith?: Maybe<Array<Audience>>;
  skillsExtractedAt?: Maybe<Scalars['DateTime']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};


export type DocumentPreviewArgs = {
  profile: Scalars['String']['input'];
};

export enum DocumentClassifier {
  CurriculumVitae = 'CURRICULUM_VITAE'
}

export type DocumentClassifierFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<DocumentClassifierFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<DocumentClassifier>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<DocumentClassifier>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<DocumentClassifier>;
  /** Negates the predicate */
  not?: InputMaybe<DocumentClassifierFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<DocumentClassifierFilterInput>>;
};

export type DocumentConnection = {
  __typename?: 'DocumentConnection';
  edges: Array<DocumentEdge>;
  nodes: Array<Document>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DocumentEdge = {
  __typename?: 'DocumentEdge';
  cursor: Scalars['String']['output'];
  node: Document;
};

/** The filterable fields of type Document */
export type DocumentFilterInput = {
  and?: InputMaybe<Array<DocumentFilterInput>>;
  category?: InputMaybe<DocumentClassifierFilterInput>;
  fileName?: InputMaybe<StringFilterInput>;
  group?: InputMaybe<DocumentGroupFilterInput>;
  hasGroup?: InputMaybe<BooleanFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DocumentFilterInput>;
  or?: InputMaybe<Array<DocumentFilterInput>>;
  tags?: InputMaybe<StringListFilterInput>;
};

export type DocumentGroup = Category & Node & {
  __typename?: 'DocumentGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type DocumentGroup */
export type DocumentGroupFilterInput = {
  and?: InputMaybe<Array<DocumentGroupFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<DocumentGroupFilterInput>;
  or?: InputMaybe<Array<DocumentGroupFilterInput>>;
};

export type DocumentGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentGroupOutput = DocumentGroupResult;

/** Contains information for linking 'DocumentGroup' to other entities */
export type DocumentGroupRelationInput = {
  /** The identifier of 'DocumentGroup' */
  id: Scalars['ID']['input'];
};

export type DocumentGroupResult = {
  __typename?: 'DocumentGroupResult';
  documentGroups: Array<DocumentGroup>;
};

/** The filterable fields of type DocumentGroupResult */
export type DocumentGroupResultFilterInput = {
  and?: InputMaybe<Array<DocumentGroupResultFilterInput>>;
  not?: InputMaybe<DocumentGroupResultFilterInput>;
  or?: InputMaybe<Array<DocumentGroupResultFilterInput>>;
};

export type DocumentGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

/** The parameters for requesting multiple instances of Document. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type DocumentQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<DocumentSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<DocumentFilterInput>;
};

export type DocumentSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

/** Realtime event of a background documents-extraction job (powers + skills). */
export type DocumentsExtractionEvent = {
  __typename?: 'DocumentsExtractionEvent';
  jobId: Scalars['UUID']['output'];
  /** Human-readable detail, e.g. the failure reason or the stage that started. */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * Final pipeline result. Set on COMPLETED, and on FAILED when the pipeline itself produced
   * a result (per-document errors, counters); null when the job failed before running.
   */
  result?: Maybe<ProcessDocumentsResult>;
  type: ExtractionEventType;
};

/** The filterable fields of type DocumentsExtractionEvent */
export type DocumentsExtractionEventFilterInput = {
  and?: InputMaybe<Array<DocumentsExtractionEventFilterInput>>;
  not?: InputMaybe<DocumentsExtractionEventFilterInput>;
  or?: InputMaybe<Array<DocumentsExtractionEventFilterInput>>;
};

export type Education = Node & SharableEntity & {
  __typename?: 'Education';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  degree?: Maybe<Degree>;
  endDate?: Maybe<DateInstant>;
  field: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institution?: Maybe<Scalars['String']['output']>;
  person: Person;
  sharedWith?: Maybe<Array<Audience>>;
  startDate: DateInstant;
};

/** The filterable fields of type Education */
export type EducationFilterInput = {
  and?: InputMaybe<Array<EducationFilterInput>>;
  not?: InputMaybe<EducationFilterInput>;
  or?: InputMaybe<Array<EducationFilterInput>>;
};

export type ElementEvaluationResult = {
  __typename?: 'ElementEvaluationResult';
  answeredQuestionCount: Scalars['Int']['output'];
  element: CreativityElement;
  lastEvaluationOn?: Maybe<Scalars['Date']['output']>;
  questionCount: Scalars['Int']['output'];
  result?: Maybe<Scalars['Int']['output']>;
  resultText?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type ElementEvaluationResult */
export type ElementEvaluationResultFilterInput = {
  and?: InputMaybe<Array<ElementEvaluationResultFilterInput>>;
  not?: InputMaybe<ElementEvaluationResultFilterInput>;
  or?: InputMaybe<Array<ElementEvaluationResultFilterInput>>;
};

export enum ElementGroup {
  Communication = 'COMMUNICATION',
  FutureOrientation = 'FUTURE_ORIENTATION',
  Inventiveness = 'INVENTIVENESS',
  Resilience = 'RESILIENCE',
  ResultOrientation = 'RESULT_ORIENTATION',
  TeamSpirit = 'TEAM_SPIRIT'
}

export type ElementWeight = {
  __typename?: 'ElementWeight';
  element?: Maybe<CreativityElement>;
  weight?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type ElementWeight */
export type ElementWeightFilterInput = {
  and?: InputMaybe<Array<ElementWeightFilterInput>>;
  not?: InputMaybe<ElementWeightFilterInput>;
  or?: InputMaybe<Array<ElementWeightFilterInput>>;
};

export enum EvidencePolarity {
  Contra = 'CONTRA',
  Pro = 'PRO'
}

export enum EvidenceStrength {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type Experience = Node & SharableEntity & {
  __typename?: 'Experience';
  activities?: Maybe<Array<Scalars['String']['output']>>;
  country?: Maybe<Country>;
  department?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<DateInstant>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Industry>;
  jobTitle: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  person: Person;
  sharedWith?: Maybe<Array<Audience>>;
  startDate: DateInstant;
};

/** The filterable fields of type Experience */
export type ExperienceFilterInput = {
  and?: InputMaybe<Array<ExperienceFilterInput>>;
  industry?: InputMaybe<IndustryFilterInput>;
  not?: InputMaybe<ExperienceFilterInput>;
  or?: InputMaybe<Array<ExperienceFilterInput>>;
};

/** Filtering options for a list of elements with type Experience */
export type ExperienceListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<ExperienceFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<ExperienceFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<ExperienceFilterInput>;
};

export type ExperienceSkills = {
  __typename?: 'ExperienceSkills';
  digitallySavvy?: Maybe<Scalars['SkillRating']['output']>;
  experiencedInMarketing?: Maybe<Scalars['SkillRating']['output']>;
  experiencedInProduction?: Maybe<Scalars['SkillRating']['output']>;
  experiencedInProjects?: Maybe<Scalars['SkillRating']['output']>;
  experiencedInSales?: Maybe<Scalars['SkillRating']['output']>;
  experiencedInTeaching?: Maybe<Scalars['SkillRating']['output']>;
  industrySavvy?: Maybe<Scalars['SkillRating']['output']>;
  researchOriented?: Maybe<Scalars['SkillRating']['output']>;
  technologySavvy?: Maybe<Scalars['SkillRating']['output']>;
};

/** The filterable fields of type ExperienceSkills */
export type ExperienceSkillsFilterInput = {
  and?: InputMaybe<Array<ExperienceSkillsFilterInput>>;
  not?: InputMaybe<ExperienceSkillsFilterInput>;
  or?: InputMaybe<Array<ExperienceSkillsFilterInput>>;
};

export type Expertise = Node & SharableEntity & {
  __typename?: 'Expertise';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  person: Person;
  position: Scalars['Int']['output'];
  sharedWith?: Maybe<Array<Audience>>;
};

/** The filterable fields of type Expertise */
export type ExpertiseFilterInput = {
  and?: InputMaybe<Array<ExpertiseFilterInput>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ExpertiseFilterInput>;
  or?: InputMaybe<Array<ExpertiseFilterInput>>;
};

/** Filtering options for a list of elements with type Expertise */
export type ExpertiseListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<ExpertiseFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<ExpertiseFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<ExpertiseFilterInput>;
};

export type ExtendedContactDetail = Node & {
  __typename?: 'ExtendedContactDetail';
  address?: Maybe<Address>;
  id: Scalars['ID']['output'];
  name?: Maybe<Array<Maybe<HumanName>>>;
  organization?: Maybe<Organization>;
  purpose?: Maybe<ExtendedContactDetail>;
  telecom?: Maybe<Array<Maybe<ContactPoint>>>;
};

export type ExtendedContactDetailConnection = {
  __typename?: 'ExtendedContactDetailConnection';
  edges: Array<ExtendedContactDetailEdge>;
  nodes: Array<ExtendedContactDetail>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExtendedContactDetailEdge = {
  __typename?: 'ExtendedContactDetailEdge';
  cursor: Scalars['String']['output'];
  node: ExtendedContactDetail;
};

/** The filterable fields of type ExtendedContactDetail */
export type ExtendedContactDetailFilterInput = {
  and?: InputMaybe<Array<ExtendedContactDetailFilterInput>>;
  not?: InputMaybe<ExtendedContactDetailFilterInput>;
  or?: InputMaybe<Array<ExtendedContactDetailFilterInput>>;
};

/** The parameters for requesting multiple instances of ExtendedContactDetail. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type ExtendedContactDetailQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains information for linking 'ExtendedContactDetail' to other entities */
export type ExtendedContactDetailRelationInput = {
  /** The identifier of 'ExtendedContactDetail' */
  id: Scalars['ID']['input'];
};

/** Type of a realtime event emitted for a background documents-extraction job. */
export enum ExtractionEventType {
  /** Terminal: the job finished; result is present. */
  Completed = 'COMPLETED',
  /** Terminal: the job failed; message carries the reason. */
  Failed = 'FAILED',
  /** Coarse progress signal; message says which stage started. */
  Progress = 'PROGRESS',
  /** Snapshot only: the job is still queued and has not started running. */
  Queued = 'QUEUED',
  /** The job started running (per-person extraction lock acquired). */
  Started = 'STARTED'
}

/** Handle for a background extraction job started via startDocumentsExtraction. */
export type ExtractionJob = {
  __typename?: 'ExtractionJob';
  id: Scalars['UUID']['output'];
  status: ExtractionJobStatus;
};

/** The filterable fields of type ExtractionJob */
export type ExtractionJobFilterInput = {
  and?: InputMaybe<Array<ExtractionJobFilterInput>>;
  not?: InputMaybe<ExtractionJobFilterInput>;
  or?: InputMaybe<Array<ExtractionJobFilterInput>>;
};

/** Lifecycle status of a background documents-extraction job. */
export enum ExtractionJobStatus {
  /** Terminal: the job finished; the result is available. */
  Completed = 'COMPLETED',
  /** Terminal: the job failed; the message carries the reason. */
  Failed = 'FAILED',
  /** The job was accepted and has not started running yet (e.g. waiting for the per-person extraction lock). */
  Queued = 'QUEUED',
  /** The job is currently extracting. */
  Running = 'RUNNING'
}

export enum FavoritesListType {
  Animal = 'ANIMAL',
  Art = 'ART',
  Book = 'BOOK',
  Celebrity = 'CELEBRITY',
  Food = 'FOOD',
  Game = 'GAME',
  Hobby = 'HOBBY',
  Humor = 'HUMOR',
  Movie = 'MOVIE',
  Music = 'MUSIC',
  Nature = 'NATURE',
  Plant = 'PLANT',
  Restaurant = 'RESTAURANT',
  Series = 'SERIES',
  Travel = 'TRAVEL',
  Trouble = 'TROUBLE',
  UserSpecific = 'USER_SPECIFIC'
}

export type File = {
  __typename?: 'File';
  content?: Maybe<Scalars['Binary']['output']>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type File */
export type FileFilterInput = {
  and?: InputMaybe<Array<FileFilterInput>>;
  not?: InputMaybe<FileFilterInput>;
  or?: InputMaybe<Array<FileFilterInput>>;
};

export type FloatFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<FloatFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['Float']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['Float']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<FloatFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<FloatFilterInput>>;
};

export type FutureOrientationSkills = {
  __typename?: 'FutureOrientationSkills';
  ableToLearn?: Maybe<Scalars['SkillRating']['output']>;
  adaptable?: Maybe<Scalars['SkillRating']['output']>;
  entrepreneurial?: Maybe<Scalars['SkillRating']['output']>;
  foresighted?: Maybe<Scalars['SkillRating']['output']>;
  innovative?: Maybe<Scalars['SkillRating']['output']>;
  methodical?: Maybe<Scalars['SkillRating']['output']>;
  openMinded?: Maybe<Scalars['SkillRating']['output']>;
  patient?: Maybe<Scalars['SkillRating']['output']>;
  problemAware?: Maybe<Scalars['SkillRating']['output']>;
  strategic?: Maybe<Scalars['SkillRating']['output']>;
  timeSensitive?: Maybe<Scalars['SkillRating']['output']>;
  valueOriented?: Maybe<Scalars['SkillRating']['output']>;
  visionary?: Maybe<Scalars['SkillRating']['output']>;
};

/** The filterable fields of type FutureOrientationSkills */
export type FutureOrientationSkillsFilterInput = {
  and?: InputMaybe<Array<FutureOrientationSkillsFilterInput>>;
  not?: InputMaybe<FutureOrientationSkillsFilterInput>;
  or?: InputMaybe<Array<FutureOrientationSkillsFilterInput>>;
};

export type Gender = Node & {
  __typename?: 'Gender';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Gender */
export type GenderFilterInput = {
  and?: InputMaybe<Array<GenderFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<GenderFilterInput>;
  or?: InputMaybe<Array<GenderFilterInput>>;
};

/** Contains information for linking 'Gender' to other entities */
export type GenderRelationInput = {
  /** The identifier of 'Gender' */
  id: Scalars['ID']['input'];
};

export type GenderSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type GendersResult = {
  __typename?: 'GendersResult';
  genders: Array<Gender>;
};

/** The filterable fields of type GendersResult */
export type GendersResultFilterInput = {
  and?: InputMaybe<Array<GendersResultFilterInput>>;
  not?: InputMaybe<GendersResultFilterInput>;
  or?: InputMaybe<Array<GendersResultFilterInput>>;
};

export type GenerateAiRequirementsInput = {
  /**
   * When true, the proposed conditions are returned on the (unpersisted) Match.design so the client can
   * diff/accept them; the match is left unchanged. Defaults to false (generate and persist).
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  matchId: Scalars['UUID']['input'];
};

export type GenerateAiRequirementsOutput = GenerateAiRequirementsResult;

export type GenerateAiRequirementsResult = {
  __typename?: 'GenerateAIRequirementsResult';
  match: Match;
};

/** The filterable fields of type GenerateAIRequirementsResult */
export type GenerateAiRequirementsResultFilterInput = {
  and?: InputMaybe<Array<GenerateAiRequirementsResultFilterInput>>;
  not?: InputMaybe<GenerateAiRequirementsResultFilterInput>;
  or?: InputMaybe<Array<GenerateAiRequirementsResultFilterInput>>;
};

export type GenerateTransientMatchResultInput = {
  matchId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GlobalSearchInput = {
  /** Optional filter to restrict results to specific entity types. */
  entityTypes?: InputMaybe<Array<SearchEntityType>>;
  /** Optional structured Person filter (same type as persons(where)). Intersected with the full-text results by person_id before paging. Mutually exclusive with sharedItemFilter. */
  personFilter?: InputMaybe<PersonFilterInput>;
  /** Full-text query (PostgreSQL websearch syntax). Optional: when null/blank, results are filter/entityType-only with rank 0 and a stable label/entity-id order. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Optional structured SharedItem filter (same type as sharedItems(where)). Intersected with the full-text results by shared_item id before paging. Mutually exclusive with personFilter. */
  sharedItemFilter?: InputMaybe<SharedItemFilterInput>;
  /** Number of rows to skip (offset-based pagination). Defaults to 0. */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of results to return. Defaults to 50. */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalSearchOutput = {
  __typename?: 'GlobalSearchOutput';
  /** True if more results exist beyond the current page. */
  hasNextPage: Scalars['Boolean']['output'];
  results: Array<GlobalSearchResult>;
};

/** The filterable fields of type GlobalSearchOutput */
export type GlobalSearchOutputFilterInput = {
  and?: InputMaybe<Array<GlobalSearchOutputFilterInput>>;
  not?: InputMaybe<GlobalSearchOutputFilterInput>;
  or?: InputMaybe<Array<GlobalSearchOutputFilterInput>>;
};

export type GlobalSearchResult = {
  __typename?: 'GlobalSearchResult';
  entityId: Scalars['ID']['output'];
  entityType: SearchEntityType;
  /** Human-readable display label for this result. */
  label?: Maybe<Scalars['String']['output']>;
  /** The person who owns this entity. Null for match and shared_item. */
  personId?: Maybe<Scalars['ID']['output']>;
  /** Relevance score from full-text search ranking. */
  rank: Scalars['Float']['output'];
};

/** The filterable fields of type GlobalSearchResult */
export type GlobalSearchResultFilterInput = {
  and?: InputMaybe<Array<GlobalSearchResultFilterInput>>;
  not?: InputMaybe<GlobalSearchResultFilterInput>;
  or?: InputMaybe<Array<GlobalSearchResultFilterInput>>;
};

export type GrowElement = {
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type GrowElement */
export type GrowElementFilterInput = {
  and?: InputMaybe<Array<GrowElementFilterInput>>;
  not?: InputMaybe<GrowElementFilterInput>;
  or?: InputMaybe<Array<GrowElementFilterInput>>;
};

export type GrowRanking = {
  __typename?: 'GrowRanking';
  score: Scalars['Int']['output'];
  selfAssessmentCompleted: Scalars['Boolean']['output'];
  userRank: UserRank;
};

/** The filterable fields of type GrowRanking */
export type GrowRankingFilterInput = {
  and?: InputMaybe<Array<GrowRankingFilterInput>>;
  not?: InputMaybe<GrowRankingFilterInput>;
  or?: InputMaybe<Array<GrowRankingFilterInput>>;
};

export type GrowResource = {
  __typename?: 'GrowResource';
  audio?: Maybe<Array<AudioElement>>;
  element?: Maybe<CreativityElement>;
  text?: Maybe<Array<TextElement>>;
  videos?: Maybe<Array<VideoElement>>;
};

/** The filterable fields of type GrowResource */
export type GrowResourceFilterInput = {
  and?: InputMaybe<Array<GrowResourceFilterInput>>;
  not?: InputMaybe<GrowResourceFilterInput>;
  or?: InputMaybe<Array<GrowResourceFilterInput>>;
};

export type GrowResourceQueryInput = {
  element: CreativityElement;
};

export type HeartbeatConversationPresenceInput = {
  conversationId: Scalars['UUID']['input'];
  online?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HumanName = {
  __typename?: 'HumanName';
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Scalars['String']['output']>>;
  period?: Maybe<Period>;
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  use: NameUse;
};

/** The filterable fields of type HumanName */
export type HumanNameFilterInput = {
  and?: InputMaybe<Array<HumanNameFilterInput>>;
  family?: InputMaybe<StringFilterInput>;
  given?: InputMaybe<StringListFilterInput>;
  not?: InputMaybe<HumanNameFilterInput>;
  or?: InputMaybe<Array<HumanNameFilterInput>>;
};

export type HumanNameSortInput = {
  family?: InputMaybe<SortOrder>;
  given?: InputMaybe<SortOrder>;
};

export type IdFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<IdFilterInput>>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['UUID']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<IdFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<IdFilterInput>>;
};

/** How a single preview item differs between existing genesis data and incoming LinkedIn data. */
export enum ImportDiffAction {
  /** Target is empty / has no matching row; the LinkedIn value would be added. Default resolution: USE_LINKEDIN. */
  Add = 'ADD',
  /** Target and LinkedIn differ; the user must choose. Default resolution: KEEP_EXISTING. */
  Conflict = 'CONFLICT',
  /** Target and LinkedIn agree; nothing to decide. */
  Unchanged = 'UNCHANGED'
}

export type IndustriesResult = {
  __typename?: 'IndustriesResult';
  industries: Array<Industry>;
};

/** The filterable fields of type IndustriesResult */
export type IndustriesResultFilterInput = {
  and?: InputMaybe<Array<IndustriesResultFilterInput>>;
  not?: InputMaybe<IndustriesResultFilterInput>;
  or?: InputMaybe<Array<IndustriesResultFilterInput>>;
};

export type Industry = Node & {
  __typename?: 'Industry';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type Industry */
export type IndustryFilterInput = {
  and?: InputMaybe<Array<IndustryFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<IndustryFilterInput>;
  or?: InputMaybe<Array<IndustryFilterInput>>;
};

/** Contains information for linking 'Industry' to other entities */
export type IndustryRelationInput = {
  /** The identifier of 'Industry' */
  id: Scalars['ID']['input'];
};

export type IndustrySortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<IntFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  or?: InputMaybe<Array<IntFilterInput>>;
};

export type JobDepartment = Node & {
  __typename?: 'JobDepartment';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type JobDepartment */
export type JobDepartmentFilterInput = {
  and?: InputMaybe<Array<JobDepartmentFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<JobDepartmentFilterInput>;
  or?: InputMaybe<Array<JobDepartmentFilterInput>>;
};

/** Contains information for linking 'JobDepartment' to other entities */
export type JobDepartmentRelationInput = {
  /** The identifier of 'JobDepartment' */
  id: Scalars['ID']['input'];
};

export type JobDepartmentSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type JobDepartmentsResult = {
  __typename?: 'JobDepartmentsResult';
  jobDepartments: Array<JobDepartment>;
};

/** The filterable fields of type JobDepartmentsResult */
export type JobDepartmentsResultFilterInput = {
  and?: InputMaybe<Array<JobDepartmentsResultFilterInput>>;
  not?: InputMaybe<JobDepartmentsResultFilterInput>;
  or?: InputMaybe<Array<JobDepartmentsResultFilterInput>>;
};

export type JobLocation = Node & {
  __typename?: 'JobLocation';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type JobLocation */
export type JobLocationFilterInput = {
  and?: InputMaybe<Array<JobLocationFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<JobLocationFilterInput>;
  or?: InputMaybe<Array<JobLocationFilterInput>>;
};

/** Contains information for linking 'JobLocation' to other entities */
export type JobLocationRelationInput = {
  /** The identifier of 'JobLocation' */
  id: Scalars['ID']['input'];
};

export type JobLocationSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type JobLocationsResult = {
  __typename?: 'JobLocationsResult';
  jobLocations: Array<JobLocation>;
};

/** The filterable fields of type JobLocationsResult */
export type JobLocationsResultFilterInput = {
  and?: InputMaybe<Array<JobLocationsResultFilterInput>>;
  not?: InputMaybe<JobLocationsResultFilterInput>;
  or?: InputMaybe<Array<JobLocationsResultFilterInput>>;
};

export type LanguageSkill = Node & {
  __typename?: 'LanguageSkill';
  cefr?: Maybe<CefrScale>;
  id: Scalars['ID']['output'];
  languageTag: Scalars['String']['output'];
  nativeSpeaker: Scalars['Boolean']['output'];
  person: Person;
  selfAssessed?: Maybe<Scalars['Boolean']['output']>;
  sharedWith?: Maybe<Array<Audience>>;
};

export type LanguageSkillConnection = {
  __typename?: 'LanguageSkillConnection';
  edges: Array<LanguageSkillEdge>;
  nodes: Array<LanguageSkill>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LanguageSkillEdge = {
  __typename?: 'LanguageSkillEdge';
  cursor: Scalars['String']['output'];
  node: LanguageSkill;
};

/** The filterable fields of type LanguageSkill */
export type LanguageSkillFilterInput = {
  and?: InputMaybe<Array<LanguageSkillFilterInput>>;
  cefr?: InputMaybe<CefrScaleFilterInput>;
  languageTag?: InputMaybe<StringFilterInput>;
  nativeSpeaker?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<LanguageSkillFilterInput>;
  or?: InputMaybe<Array<LanguageSkillFilterInput>>;
};

/** Filtering options for a list of elements with type LanguageSkill */
export type LanguageSkillListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<LanguageSkillFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<LanguageSkillFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<LanguageSkillFilterInput>;
};

/** The parameters for requesting multiple instances of LanguageSkill. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type LanguageSkillQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<LanguageSkillFilterInput>;
};

/**
 * Payload for the LinkedIn onboarding import mutation. Each client (Vaadin,
 * Android, iOS, Compose) runs its own LinkedIn OAuth flow — confidential-client
 * with PKCE for discovery, public-client PKCE for mobile — and forwards the
 * resulting {@code accessToken} here. The backend uses the token as a Bearer
 * credential to fetch the member's DMA snapshot, maps it to a
 * {@code BulkImportPersonInput}, and persists everything in a single
 * transaction via the internal bulk-import path. OAuth state (PKCE verifier,
 * nonce, client_secret) stays entirely on the client that initiated the flow.
 *
 * The optional {@code scope} field lets callers restrict the import to specific
 * collections / Person scalar fields. When omitted, every part of the DMA
 * snapshot is mapped.
 */
export type LinkedInImportInput = {
  accessToken: Scalars['String']['input'];
  scope?: InputMaybe<LinkedInImportScope>;
};

/**
 * Per-collection and per-Person-field scope flags for the LinkedIn import.
 * Each flag controls whether genesis maps and writes that portion of the
 * DMA snapshot. A null or missing flag is treated as {@code true} (import),
 * preserving backwards compatibility with clients that haven't been updated
 * to send a scope. Discovery uses these flags to skip collections/fields it
 * knows are already populated in the user's profile — saving the per-row
 * mapping work and aligning with the "only-if-empty" merge policy in
 * {@code BulkImportPersonService}.
 */
export type LinkedInImportScope = {
  importBio?: InputMaybe<Scalars['Boolean']['input']>;
  importCertificates?: InputMaybe<Scalars['Boolean']['input']>;
  importCurrentEmployer?: InputMaybe<Scalars['Boolean']['input']>;
  importEducations?: InputMaybe<Scalars['Boolean']['input']>;
  importExperiences?: InputMaybe<Scalars['Boolean']['input']>;
  importExpertises?: InputMaybe<Scalars['Boolean']['input']>;
  importJobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  importLanguageSkills?: InputMaybe<Scalars['Boolean']['input']>;
  importProfession?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalizedText = {
  __typename?: 'LocalizedText';
  english?: Maybe<Scalars['String']['output']>;
  german?: Maybe<Scalars['String']['output']>;
  localized?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type LocalizedText */
export type LocalizedTextFilterInput = {
  and?: InputMaybe<Array<LocalizedTextFilterInput>>;
  english?: InputMaybe<StringFilterInput>;
  german?: InputMaybe<StringFilterInput>;
  localized?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<LocalizedTextFilterInput>;
  or?: InputMaybe<Array<LocalizedTextFilterInput>>;
};

export type LocalizedTextSortInput = {
  english?: InputMaybe<SortOrder>;
  german?: InputMaybe<SortOrder>;
  localized?: InputMaybe<SortOrder>;
};

export type MaritalStatus = Node & {
  __typename?: 'MaritalStatus';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type MaritalStatus */
export type MaritalStatusFilterInput = {
  and?: InputMaybe<Array<MaritalStatusFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MaritalStatusFilterInput>;
  or?: InputMaybe<Array<MaritalStatusFilterInput>>;
};

/** Contains information for linking 'MaritalStatus' to other entities */
export type MaritalStatusRelationInput = {
  /** The identifier of 'MaritalStatus' */
  id: Scalars['ID']['input'];
};

export type MaritalStatusSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type MaritalStatusesResult = {
  __typename?: 'MaritalStatusesResult';
  maritalStatuses: Array<MaritalStatus>;
};

/** The filterable fields of type MaritalStatusesResult */
export type MaritalStatusesResultFilterInput = {
  and?: InputMaybe<Array<MaritalStatusesResultFilterInput>>;
  not?: InputMaybe<MaritalStatusesResultFilterInput>;
  or?: InputMaybe<Array<MaritalStatusesResultFilterInput>>;
};

export type MarkConversationReadInput = {
  conversationId: Scalars['UUID']['input'];
  lastReadMessageId: Scalars['UUID']['input'];
};

export type Match = Node & {
  __typename?: 'Match';
  access?: Maybe<Array<MatchAccess>>;
  candidateCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  design?: Maybe<Scalars['Object']['output']>;
  id: Scalars['ID']['output'];
  matchMode?: Maybe<MatchMode>;
  name?: Maybe<Scalars['String']['output']>;
  sharedItem?: Maybe<SharedItem>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Person>;
};

export type MatchAccess = {
  __typename?: 'MatchAccess';
  design: AccessLevel;
  discover: AccessLevel;
  match: AccessLevel;
  person: Person;
  prepare: AccessLevel;
};

/** The filterable fields of type MatchAccess */
export type MatchAccessFilterInput = {
  and?: InputMaybe<Array<MatchAccessFilterInput>>;
  not?: InputMaybe<MatchAccessFilterInput>;
  or?: InputMaybe<Array<MatchAccessFilterInput>>;
};

export type MatchCandidate = Node & {
  __typename?: 'MatchCandidate';
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<Match>;
  matchId?: Maybe<Scalars['ID']['output']>;
  person?: Maybe<Person>;
};

export type MatchCandidateConnection = {
  __typename?: 'MatchCandidateConnection';
  edges: Array<MatchCandidateEdge>;
  nodes: Array<MatchCandidate>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchCandidateEdge = {
  __typename?: 'MatchCandidateEdge';
  cursor: Scalars['String']['output'];
  node: MatchCandidate;
};

/** The filterable fields of type MatchCandidate */
export type MatchCandidateFilterInput = {
  and?: InputMaybe<Array<MatchCandidateFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  locked?: InputMaybe<BooleanFilterInput>;
  matchId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<MatchCandidateFilterInput>;
  or?: InputMaybe<Array<MatchCandidateFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
};

/** The parameters for requesting multiple instances of MatchCandidate. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchCandidateQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchCandidateSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchCandidateFilterInput>;
};

export type MatchCandidateSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  formattedName?: InputMaybe<SortOrder>;
};

export type MatchConnection = {
  __typename?: 'MatchConnection';
  edges: Array<MatchEdge>;
  nodes: Array<Match>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchEdge = {
  __typename?: 'MatchEdge';
  cursor: Scalars['String']['output'];
  node: Match;
};

/** The filterable fields of type Match */
export type MatchFilterInput = {
  and?: InputMaybe<Array<MatchFilterInput>>;
  description?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MatchFilterInput>;
  or?: InputMaybe<Array<MatchFilterInput>>;
};

/**
 * Match mode, chosen at creation and immutable thereafter. Drives the solver's assessOnly:
 * ASSESS and RANK -> assessOnly=true, OPTIMIZE -> false. RANK is the renamed former APPLY token.
 */
export enum MatchMode {
  Assess = 'ASSESS',
  Optimize = 'OPTIMIZE',
  Rank = 'RANK'
}

/** The parameters for requesting multiple instances of Match. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchFilterInput>;
};

/** Contains information for linking 'Match' to other entities */
export type MatchRelationInput = {
  /** The identifier of 'Match' */
  id: Scalars['ID']['input'];
};

export type MatchResult = Node & {
  __typename?: 'MatchResult';
  candidateCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Person>;
  design?: Maybe<Scalars['Object']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<MatchResultTeam>>;
};

export type MatchResultConnection = {
  __typename?: 'MatchResultConnection';
  edges: Array<MatchResultEdge>;
  nodes: Array<MatchResult>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MatchResultEdge = {
  __typename?: 'MatchResultEdge';
  cursor: Scalars['String']['output'];
  node: MatchResult;
};

/** The filterable fields of type MatchResult */
export type MatchResultFilterInput = {
  and?: InputMaybe<Array<MatchResultFilterInput>>;
  matchId?: InputMaybe<UuidFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MatchResultFilterInput>;
  notes?: InputMaybe<StringFilterInput>;
  or?: InputMaybe<Array<MatchResultFilterInput>>;
};

/** The parameters for requesting multiple instances of MatchResult. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type MatchResultQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<MatchResultSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<MatchResultFilterInput>;
};

export type MatchResultSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type MatchResultTeam = {
  __typename?: 'MatchResultTeam';
  persons?: Maybe<Array<Maybe<Person>>>;
  result?: Maybe<Scalars['Object']['output']>;
  teamId: Scalars['UUID']['output'];
};

/** The filterable fields of type MatchResultTeam */
export type MatchResultTeamFilterInput = {
  and?: InputMaybe<Array<MatchResultTeamFilterInput>>;
  not?: InputMaybe<MatchResultTeamFilterInput>;
  or?: InputMaybe<Array<MatchResultTeamFilterInput>>;
};

export type MatchSortInput = {
  createdAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Executes a notification action, such as accepting or rejecting a contact request. */
  actOnNotification: Notification;
  addContacts?: Maybe<AddContactsOutput>;
  addPins?: Maybe<AddPinsOutput>;
  /**
   * Uploads inline file content to backdrop server-side and appends one entry per file to
   * MatchDesign.project.documents. The uploaded blob is owned by the match owner regardless of
   * who invokes this mutation. Not deduplicated: identical bytes uploaded twice produce two
   * entries with distinct backdropFileIds. Caller needs design-write access on the match.
   */
  attachProjectDocument: AttachProjectDocumentOutput;
  /**
   * Bulk-imports a person's Experience / Education / LanguageSkill / Certificate /
   * Expertise collections plus an optional personDetail fragment in a single
   * transaction. Per-collection merge policy: only populate collections that are
   * currently empty for the target person; non-empty collections are left
   * untouched and their name is returned in `skipped`. Used by provider-specific
   * importers (LinkedIn, vCard, CSV, …) to populate a profile in one round-trip
   * with atomic rollback on any server-side failure.
   */
  bulkImportPerson: BulkImportPersonResult;
  /** Creates a new address instance */
  createAddress: CreateAddressOutput;
  /** Creates a new certificate instance */
  createCertificate: CreateCertificateOutput;
  /** Creates a new contracttype instance */
  createContractType: CreateContractTypeOutput;
  createConversation: Conversation;
  /** Creates a new curriculumvitae instance */
  createCurriculumVitae: CreateCurriculumVitaeOutput;
  createDegree: CreateDegreeOutput;
  /** Creates a new document instance */
  createDocument: CreateDocumentOutput;
  /** Creates a new documentgroup instance */
  createDocumentGroup: CreateDocumentGroupOutput;
  /** Creates a new education instance */
  createEducation: CreateEducationOutput;
  /** Creates a new experience instance */
  createExperience: CreateExperienceOutput;
  /** Creates a new expertise instance */
  createExpertise: CreateExpertiseOutput;
  /** Creates a new extendedcontactdetail instance */
  createExtendedContactDetail: CreateExtendedContactDetailOutput;
  /** Creates a new gender instance */
  createGender: CreateGenderOutput;
  /** Creates a new industry instance */
  createIndustry: CreateIndustryOutput;
  /** Creates a new jobdepartment instance */
  createJobDepartment: CreateJobDepartmentOutput;
  /** Creates a new joblocation instance */
  createJobLocation: CreateJobLocationOutput;
  /** Creates a new languageskill instance */
  createLanguageSkill: CreateLanguageSkillOutput;
  /** Creates a new maritalstatus instance */
  createMaritalStatus: CreateMaritalStatusOutput;
  /** Creates a new match instance */
  createMatch: CreateMatchOutput;
  /** Creates a new matchcandidate instance */
  createMatchCandidate: CreateMatchCandidateOutput;
  createMatchCandidates?: Maybe<CreateMatchCandidatesOutput>;
  /** Creates a new matchresult instance */
  createMatchResult: CreateMatchResultOutput;
  /** Creates a new organization instance */
  createOrganization: CreateOrganizationOutput;
  /** Creates a new person instance */
  createPerson: CreatePersonOutput;
  /** Creates a new persongroup instance */
  createPersonGroup: CreatePersonGroupOutput;
  /** Creates a new pingroup instance */
  createPinGroup: CreatePinGroupOutput;
  /** Creates a new selfassessment instance */
  createSelfAssessment: CreateSelfAssessmentOutput;
  /** Creates a new shareditem instance */
  createSharedItem: CreateSharedItemOutput;
  /** Creates a new shareditemcomment instance */
  createSharedItemComment: CreateSharedItemCommentOutput;
  /** Creates a new teamprofile instance */
  createTeamProfile: CreateTeamProfileOutput;
  /** Creates a new workingtimemodel instance */
  createWorkingTimeModel: CreateWorkingTimeModelOutput;
  /** Deletes existing instances of address */
  deleteAddress: DeleteAddressOutput;
  /** Deletes existing instances of certificate */
  deleteCertificate: DeleteCertificateOutput;
  /** Deletes existing instances of contracttype */
  deleteContractType: DeleteContractTypeOutput;
  deleteConversation: Scalars['Boolean']['output'];
  /** Deletes existing instances of curriculumvitae */
  deleteCurriculumVitae: DeleteCurriculumVitaeOutput;
  deleteDegree: DeleteDegreeOutput;
  /** Deletes existing instances of document */
  deleteDocument: DeleteDocumentOutput;
  /** Deletes existing instances of documentgroup */
  deleteDocumentGroup: DeleteDocumentGroupOutput;
  /** Deletes existing instances of education */
  deleteEducation: DeleteEducationOutput;
  /** Deletes existing instances of experience */
  deleteExperience: DeleteExperienceOutput;
  /** Deletes existing instances of expertise */
  deleteExpertise: DeleteExpertiseOutput;
  /** Deletes existing instances of extendedcontactdetail */
  deleteExtendedContactDetail: DeleteExtendedContactDetailOutput;
  /** Deletes existing instances of gender */
  deleteGender: DeleteGenderOutput;
  /** Deletes existing instances of industry */
  deleteIndustry: DeleteIndustryOutput;
  /** Deletes existing instances of jobdepartment */
  deleteJobDepartment: DeleteJobDepartmentOutput;
  /** Deletes existing instances of joblocation */
  deleteJobLocation: DeleteJobLocationOutput;
  /** Deletes existing instances of languageskill */
  deleteLanguageSkill: DeleteLanguageSkillOutput;
  /** Deletes existing instances of maritalstatus */
  deleteMaritalStatus: DeleteMaritalStatusOutput;
  /** Deletes existing instances of match */
  deleteMatch: DeleteMatchOutput;
  /** Deletes existing instances of matchcandidate */
  deleteMatchCandidate: DeleteMatchCandidateOutput;
  deleteMatchCandidates?: Maybe<DeleteMatchCandidatesOutput>;
  /** Deletes existing instances of matchresult */
  deleteMatchResult: DeleteMatchResultOutput;
  /** Deletes a notification from the current user's inbox. */
  deleteNotification: Notification;
  /** Deletes existing instances of organization */
  deleteOrganization: DeleteOrganizationOutput;
  /** Deletes existing instances of person */
  deletePerson: DeletePersonOutput;
  /** Deletes existing instances of persongroup */
  deletePersonGroup: DeletePersonGroupOutput;
  /** Deletes existing instances of pingroup */
  deletePinGroup: DeletePinGroupOutput;
  /** Hard-deletes a questionnaire tree if no results exist for it; otherwise marks it as DELETED. Returns true if hard-deleted, false if soft-deleted. */
  deleteQuestionnaire: Scalars['Boolean']['output'];
  /** Deletes existing instances of selfassessment */
  deleteSelfAssessment: DeleteSelfAssessmentOutput;
  /** Deletes existing instances of shareditem */
  deleteSharedItem: DeleteSharedItemOutput;
  /** Deletes existing instances of shareditemcomment */
  deleteSharedItemComment: DeleteSharedItemCommentOutput;
  /** Deletes existing instances of teamprofile */
  deleteTeamProfile: DeleteTeamProfileOutput;
  /** Deletes existing instances of workingtimemodel */
  deleteWorkingTimeModel: DeleteWorkingTimeModelOutput;
  /**
   * Removes a document from a match's Project.documents by backdropFileId. No-op if absent.
   * Triggers deletion of the backdrop blob as a fire-and-forget side effect. Caller needs
   * design-write access on the match.
   */
  detachProjectDocument: DetachProjectDocumentOutput;
  /** Extract a profile from a single uploaded document (CV, LinkedIn export, application form, biography, …). Returns the same two-sided ProfileImportPreview as previewLinkedInImport — a per-field / per-row diff against the caller's existing Person. The mutation persists nothing; the frontend reviews the diff and applies accepted changes via the ordinary updatePerson / createExperience / … mutations. */
  extractProfileFromDocument: ProfileImportPreview;
  generateAIRequirements?: Maybe<GenerateAiRequirementsOutput>;
  /** Run the team-matching solver for the given match and persist the result as an unsaved draft (kept:false), replacing any prior draft for this (match, user). Not idempotent — the solve runs once and writes. */
  generateTransientMatchResult?: Maybe<MatchResult>;
  heartbeatConversationPresence: PresenceIndicator;
  /** Admin-only (requires the write:any:person authority). Extracts each uploaded CV and persists it — updating the person matched by primary email (filling only empty fields/collections) or creating a new candidate Person when there is no unambiguous match. Returns a per-file outcome; a failed file never aborts the others. */
  importCvBatch: CvBatchImportResult;
  /**
   * Imports the authenticated user's LinkedIn profile. The backend exchanges the
   * OAuth authorization code for an access token, fetches the DMA snapshot from
   * LinkedIn, maps it, and persists everything in a single transaction using
   * the same merge policy as bulkImportPerson. Returns the aggregated import
   * result so callers can surface per-collection skipped / warnings to the user.
   */
  importLinkedInProfile: BulkImportPersonResult;
  markConversationRead: ConversationReadReceipt;
  /** Marks a notification as read. */
  markNotificationRead: Notification;
  /**
   * Computes a non-destructive preview of a LinkedIn import for the authenticated user:
   * fetches the full DMA snapshot, maps it, and diffs it against existing data per field
   * and per collection row. Nothing is written and no server-side state is kept. The client
   * reviews and edits the returned proposals, then persists the accepted ones through the
   * ordinary profile mutations (updatePerson, createExperience, …) — the same write path as
   * manual editing. Re-run before saving to keep a retry idempotent: already-saved rows come
   * back UNCHANGED (matched by natural key).
   */
  previewLinkedInImport: ProfileImportPreview;
  /**
   * Synchronous variant of the powers/skills extraction: holds the HTTP request open for the
   * full pipeline duration (minutes). Superseded by startDocumentsExtraction +
   * documentsExtractionEvents; kept until all clients have migrated.
   */
  processDocuments?: Maybe<ProcessDocumentsOutput>;
  rateSharedItem?: Maybe<RateSharedItemOutput>;
  /** Registers a device token for push notifications. Overwrites if the token already exists for another user. */
  registerDeviceToken: Scalars['Boolean']['output'];
  removeContacts?: Maybe<RemoveContactsOutput>;
  removePins?: Maybe<RemovePinsOutput>;
  /** Creates a contact-request notification for another user. */
  requestContact: Notification;
  /** Creates contact-request notifications for multiple users. */
  requestContacts: Array<Notification>;
  /** Upserts a questionnaire and its questions + answer choices. Null UUIDs mean create; existing UUIDs update in place. Rows in the DB that are not in the payload are left untouched. */
  saveQuestionnaire: SaveQuestionnaireOutput;
  /** Persists the current user's chosen answer for one or more questionnaire questions. For each item, replaces any prior answer the user gave to the same question (delete-then-insert). */
  saveQuestionnaireResults: Scalars['Boolean']['output'];
  saveSelfAssessmentResults: Scalars['Boolean']['output'];
  sendChatMessage: ChatMessage;
  setConversationTyping: TypingIndicator;
  /**
   * Sets a match's notes (aiCopilotText) by merging only that field into the existing MatchDesign
   * server-side — every other design field is preserved. Pass null to clear the notes. Caller needs
   * design-write access on the match.
   */
  setMatchNotes: SetMatchNotesOutput;
  /**
   * Sets a match's team size (and optionally team count) by merging only those fields into the
   * existing MatchDesign server-side — every other design field (conditions, project, notes) is
   * preserved. Intent-scoped alternative to updateMatch(design)'s whole-blob replace. Caller needs
   * design-write access on the match.
   */
  setMatchTeamSize: SetMatchTeamSizeOutput;
  signUpSharedProject?: Maybe<SignUpSharedProjectOutput>;
  /**
   * Starts the powers/skills extraction as a detached background job and returns immediately
   * with a QUEUED ExtractionJob. Progress and the final result are delivered via the
   * documentsExtractionEvents subscription; an EXTRACTION_COMPLETED / EXTRACTION_FAILED
   * notification fires on the terminal transition as the durable fallback for closed tabs.
   * Pipeline semantics (per-person lock, per-document evidence skip, sequential
   * powers → skills) are identical to processDocuments.
   */
  startDocumentsExtraction: ExtractionJob;
  /**
   * Copies a share item's Project text fields (name, short-description, description) into the
   * target match's MatchDesign.project (name, shortDescription, description) and sets
   * Match.sharedItem. Destructive overwrite of those text fields — UI must confirm with the
   * user. Existing MatchDesign.project.documents are preserved (documents are owned by
   * attach/detach, not by takeover). Share item documents are not copied in v1.
   */
  takeOverSharedItem: TakeOverSharedItemOutput;
  /** Removes a device token. Called on logout. */
  unregisterDeviceToken: Scalars['Boolean']['output'];
  /** Updates an existing address instance */
  updateAddress: UpdateAddressOutput;
  /** Updates an existing certificate instance */
  updateCertificate: UpdateCertificateOutput;
  /** Updates an existing contracttype instance */
  updateContractType: UpdateContractTypeOutput;
  /** Updates an existing curriculumvitae instance */
  updateCurriculumVitae: UpdateCurriculumVitaeOutput;
  updateDegree: UpdateDegreeOutput;
  /** Updates an existing document instance */
  updateDocument: UpdateDocumentOutput;
  /** Updates an existing documentgroup instance */
  updateDocumentGroup: UpdateDocumentGroupOutput;
  /** Updates an existing education instance */
  updateEducation: UpdateEducationOutput;
  /** Updates an existing experience instance */
  updateExperience: UpdateExperienceOutput;
  /** Updates an existing expertise instance */
  updateExpertise: UpdateExpertiseOutput;
  /** Updates an existing extendedcontactdetail instance */
  updateExtendedContactDetail: UpdateExtendedContactDetailOutput;
  /** Updates an existing gender instance */
  updateGender: UpdateGenderOutput;
  /** Updates an existing industry instance */
  updateIndustry: UpdateIndustryOutput;
  /** Updates an existing jobdepartment instance */
  updateJobDepartment: UpdateJobDepartmentOutput;
  /** Updates an existing joblocation instance */
  updateJobLocation: UpdateJobLocationOutput;
  /** Updates an existing languageskill instance */
  updateLanguageSkill: UpdateLanguageSkillOutput;
  /** Updates an existing maritalstatus instance */
  updateMaritalStatus: UpdateMaritalStatusOutput;
  /** Updates an existing match instance */
  updateMatch: UpdateMatchOutput;
  /** Updates an existing matchcandidate instance */
  updateMatchCandidate: UpdateMatchCandidateOutput;
  /** Updates an existing matchresult instance */
  updateMatchResult: UpdateMatchResultOutput;
  /** Updates an existing organization instance */
  updateOrganization: UpdateOrganizationOutput;
  /** Updates an existing person instance */
  updatePerson: UpdatePersonOutput;
  /** Updates an existing persongroup instance */
  updatePersonGroup: UpdatePersonGroupOutput;
  /** Updates an existing pingroup instance */
  updatePinGroup: UpdatePinGroupOutput;
  /** Updates an existing selfassessment instance */
  updateSelfAssessment: UpdateSelfAssessmentOutput;
  updateSettings?: Maybe<Scalars['Boolean']['output']>;
  /** Updates an existing shareditem instance */
  updateSharedItem: UpdateSharedItemOutput;
  /** Updates an existing shareditemcomment instance */
  updateSharedItemComment: UpdateSharedItemCommentOutput;
  updateSystemSettings: Scalars['Boolean']['output'];
  /** Updates an existing teamprofile instance */
  updateTeamProfile: UpdateTeamProfileOutput;
  /** Updates an existing workingtimemodel instance */
  updateWorkingTimeModel: UpdateWorkingTimeModelOutput;
  viewSharedItem?: Maybe<ViewSharedItemOutput>;
  viewUserProfile?: Maybe<ViewUserProfileOutput>;
  watchSharedItem?: Maybe<WatchSharedItemOutput>;
};


export type MutationActOnNotificationArgs = {
  input: ActOnNotificationInput;
};


export type MutationAddContactsArgs = {
  input: AddContactsInput;
};


export type MutationAddPinsArgs = {
  input: AddPinsInput;
};


export type MutationAttachProjectDocumentArgs = {
  input: AttachProjectDocumentInput;
};


export type MutationBulkImportPersonArgs = {
  input: BulkImportPersonInput;
};


export type MutationCreateAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateCertificateArgs = {
  input: CreateCertificateInput;
};


export type MutationCreateContractTypeArgs = {
  input: CreateContractTypeInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


export type MutationCreateCurriculumVitaeArgs = {
  input: CreateCurriculumVitaeInput;
};


export type MutationCreateDegreeArgs = {
  input: CreateDegreeInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateDocumentGroupArgs = {
  input: CreateDocumentGroupInput;
};


export type MutationCreateEducationArgs = {
  input: CreateEducationInput;
};


export type MutationCreateExperienceArgs = {
  input: CreateExperienceInput;
};


export type MutationCreateExpertiseArgs = {
  input: CreateExpertiseInput;
};


export type MutationCreateExtendedContactDetailArgs = {
  input: CreateExtendedContactDetailInput;
};


export type MutationCreateGenderArgs = {
  input: CreateGenderInput;
};


export type MutationCreateIndustryArgs = {
  input: CreateIndustryInput;
};


export type MutationCreateJobDepartmentArgs = {
  input: CreateJobDepartmentInput;
};


export type MutationCreateJobLocationArgs = {
  input: CreateJobLocationInput;
};


export type MutationCreateLanguageSkillArgs = {
  input: CreateLanguageSkillInput;
};


export type MutationCreateMaritalStatusArgs = {
  input: CreateMaritalStatusInput;
};


export type MutationCreateMatchArgs = {
  input: CreateMatchInput;
};


export type MutationCreateMatchCandidateArgs = {
  input: CreateMatchCandidateInput;
};


export type MutationCreateMatchCandidatesArgs = {
  input?: InputMaybe<CreateMatchCandidatesInput>;
};


export type MutationCreateMatchResultArgs = {
  input: CreateMatchResultInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePersonGroupArgs = {
  input: CreatePersonGroupInput;
};


export type MutationCreatePinGroupArgs = {
  input: CreatePinGroupInput;
};


export type MutationCreateSelfAssessmentArgs = {
  input: CreateSelfAssessmentInput;
};


export type MutationCreateSharedItemArgs = {
  input: CreateSharedItemInput;
};


export type MutationCreateSharedItemCommentArgs = {
  input: CreateSharedItemCommentInput;
};


export type MutationCreateTeamProfileArgs = {
  input: CreateTeamProfileInput;
};


export type MutationCreateWorkingTimeModelArgs = {
  input: CreateWorkingTimeModelInput;
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput;
};


export type MutationDeleteCertificateArgs = {
  input: DeleteCertificateInput;
};


export type MutationDeleteContractTypeArgs = {
  input: DeleteContractTypeInput;
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type MutationDeleteCurriculumVitaeArgs = {
  input: DeleteCurriculumVitaeInput;
};


export type MutationDeleteDegreeArgs = {
  input: DeleteDegreeInput;
};


export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};


export type MutationDeleteDocumentGroupArgs = {
  input: DeleteDocumentGroupInput;
};


export type MutationDeleteEducationArgs = {
  input: DeleteEducationInput;
};


export type MutationDeleteExperienceArgs = {
  input: DeleteExperienceInput;
};


export type MutationDeleteExpertiseArgs = {
  input: DeleteExpertiseInput;
};


export type MutationDeleteExtendedContactDetailArgs = {
  input: DeleteExtendedContactDetailInput;
};


export type MutationDeleteGenderArgs = {
  input: DeleteGenderInput;
};


export type MutationDeleteIndustryArgs = {
  input: DeleteIndustryInput;
};


export type MutationDeleteJobDepartmentArgs = {
  input: DeleteJobDepartmentInput;
};


export type MutationDeleteJobLocationArgs = {
  input: DeleteJobLocationInput;
};


export type MutationDeleteLanguageSkillArgs = {
  input: DeleteLanguageSkillInput;
};


export type MutationDeleteMaritalStatusArgs = {
  input: DeleteMaritalStatusInput;
};


export type MutationDeleteMatchArgs = {
  input: DeleteMatchInput;
};


export type MutationDeleteMatchCandidateArgs = {
  input: DeleteMatchCandidateInput;
};


export type MutationDeleteMatchCandidatesArgs = {
  input: DeleteMatchCandidatesInput;
};


export type MutationDeleteMatchResultArgs = {
  input: DeleteMatchResultInput;
};


export type MutationDeleteNotificationArgs = {
  notificationId: Scalars['UUID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeletePersonArgs = {
  input: DeletePersonInput;
};


export type MutationDeletePersonGroupArgs = {
  input: DeletePersonGroupInput;
};


export type MutationDeletePinGroupArgs = {
  input: DeletePinGroupInput;
};


export type MutationDeleteQuestionnaireArgs = {
  questionnaireId: Scalars['UUID']['input'];
};


export type MutationDeleteSelfAssessmentArgs = {
  input: DeleteSelfAssessmentInput;
};


export type MutationDeleteSharedItemArgs = {
  input: DeleteSharedItemInput;
};


export type MutationDeleteSharedItemCommentArgs = {
  input: DeleteSharedItemCommentInput;
};


export type MutationDeleteTeamProfileArgs = {
  input: DeleteTeamProfileInput;
};


export type MutationDeleteWorkingTimeModelArgs = {
  input: DeleteWorkingTimeModelInput;
};


export type MutationDetachProjectDocumentArgs = {
  input: DetachProjectDocumentInput;
};


export type MutationExtractProfileFromDocumentArgs = {
  file: Scalars['Binary']['input'];
  fileName: Scalars['String']['input'];
};


export type MutationGenerateAiRequirementsArgs = {
  input: GenerateAiRequirementsInput;
};


export type MutationGenerateTransientMatchResultArgs = {
  input?: InputMaybe<GenerateTransientMatchResultInput>;
};


export type MutationHeartbeatConversationPresenceArgs = {
  input: HeartbeatConversationPresenceInput;
};


export type MutationImportCvBatchArgs = {
  files: Array<CvFileInput>;
  importPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationImportLinkedInProfileArgs = {
  input: LinkedInImportInput;
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput;
};


export type MutationMarkNotificationReadArgs = {
  notificationId: Scalars['UUID']['input'];
};


export type MutationPreviewLinkedInImportArgs = {
  input: LinkedInImportInput;
};


export type MutationProcessDocumentsArgs = {
  input: ProcessDocumentsInput;
};


export type MutationRateSharedItemArgs = {
  input: RateSharedItemInput;
};


export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};


export type MutationRemoveContactsArgs = {
  input: RemoveContactsInput;
};


export type MutationRemovePinsArgs = {
  input: RemovePinsInput;
};


export type MutationRequestContactArgs = {
  contactId: Scalars['UUID']['input'];
  justification?: InputMaybe<Scalars['String']['input']>;
  personGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationRequestContactsArgs = {
  contactIds: Array<Scalars['UUID']['input']>;
  justification?: InputMaybe<Scalars['String']['input']>;
  personGroupIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationSaveQuestionnaireArgs = {
  input: SaveQuestionnaireInput;
};


export type MutationSaveQuestionnaireResultsArgs = {
  input: SaveQuestionnaireResultsInput;
};


export type MutationSaveSelfAssessmentResultsArgs = {
  input: SaveSelfAssessmentResultsInput;
};


export type MutationSendChatMessageArgs = {
  input: SendChatMessageInput;
};


export type MutationSetConversationTypingArgs = {
  input: SetConversationTypingInput;
};


export type MutationSetMatchNotesArgs = {
  input: SetMatchNotesInput;
};


export type MutationSetMatchTeamSizeArgs = {
  input: SetMatchTeamSizeInput;
};


export type MutationSignUpSharedProjectArgs = {
  input?: InputMaybe<SignUpSharedProjectInput>;
};


export type MutationStartDocumentsExtractionArgs = {
  input: ProcessDocumentsInput;
};


export type MutationTakeOverSharedItemArgs = {
  input: TakeOverSharedItemInput;
};


export type MutationUnregisterDeviceTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateAddressArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAddressInput;
};


export type MutationUpdateCertificateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCertificateInput;
};


export type MutationUpdateContractTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateContractTypeInput;
};


export type MutationUpdateCurriculumVitaeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCurriculumVitaeInput;
};


export type MutationUpdateDegreeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDegreeInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentInput;
};


export type MutationUpdateDocumentGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentGroupInput;
};


export type MutationUpdateEducationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEducationInput;
};


export type MutationUpdateExperienceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExperienceInput;
};


export type MutationUpdateExpertiseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExpertiseInput;
};


export type MutationUpdateExtendedContactDetailArgs = {
  id: Scalars['ID']['input'];
  input: UpdateExtendedContactDetailInput;
};


export type MutationUpdateGenderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGenderInput;
};


export type MutationUpdateIndustryArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIndustryInput;
};


export type MutationUpdateJobDepartmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobDepartmentInput;
};


export type MutationUpdateJobLocationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateJobLocationInput;
};


export type MutationUpdateLanguageSkillArgs = {
  id: Scalars['ID']['input'];
  input: UpdateLanguageSkillInput;
};


export type MutationUpdateMaritalStatusArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMaritalStatusInput;
};


export type MutationUpdateMatchArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchInput;
};


export type MutationUpdateMatchCandidateArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchCandidateInput;
};


export type MutationUpdateMatchResultArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMatchResultInput;
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdatePersonArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePersonInput;
};


export type MutationUpdatePersonGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePersonGroupInput;
};


export type MutationUpdatePinGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePinGroupInput;
};


export type MutationUpdateSelfAssessmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSelfAssessmentInput;
};


export type MutationUpdateSettingsArgs = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  settings?: InputMaybe<Scalars['Object']['input']>;
};


export type MutationUpdateSharedItemArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSharedItemInput;
};


export type MutationUpdateSharedItemCommentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSharedItemCommentInput;
};


export type MutationUpdateSystemSettingsArgs = {
  input: SystemSettingsInput;
};


export type MutationUpdateTeamProfileArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTeamProfileInput;
};


export type MutationUpdateWorkingTimeModelArgs = {
  id: Scalars['ID']['input'];
  input: UpdateWorkingTimeModelInput;
};


export type MutationViewSharedItemArgs = {
  input?: InputMaybe<ViewSharedItemInput>;
};


export type MutationViewUserProfileArgs = {
  input?: InputMaybe<ViewUserProfileInput>;
};


export type MutationWatchSharedItemArgs = {
  input?: InputMaybe<WatchSharedItemInput>;
};

/** The filterable fields of type Mutation */
export type MutationFilterInput = {
  and?: InputMaybe<Array<MutationFilterInput>>;
  not?: InputMaybe<MutationFilterInput>;
  or?: InputMaybe<Array<MutationFilterInput>>;
};

export type MyPowersDevStatsInput = {
  amount: Scalars['Int']['input'];
};

export enum NameUse {
  Anonymous = 'ANONYMOUS',
  Maiden = 'MAIDEN',
  Nickname = 'NICKNAME',
  Official = 'OFFICIAL',
  Old = 'OLD',
  Temp = 'TEMP',
  Usual = 'USUAL'
}

export type Node = {
  id: Scalars['ID']['output'];
};

/** The filterable fields of type Node */
export type NodeFilterInput = {
  and?: InputMaybe<Array<NodeFilterInput>>;
  not?: InputMaybe<NodeFilterInput>;
  or?: InputMaybe<Array<NodeFilterInput>>;
};

/** A user-scoped inbox item delivered by the notification subsystem. */
export type Notification = Node & {
  __typename?: 'Notification';
  /** Actions currently associated with the notification. */
  actions: Array<NotificationAction>;
  /** Localized body text for the notification. */
  body: LocalizedText;
  /** When the notification was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User who triggered the notification, if applicable. */
  createdBy?: Maybe<Person>;
  /** Optional client route or deep link for navigation. */
  deepLink?: Maybe<Scalars['String']['output']>;
  /** Optional domain entity referenced by the notification. */
  entityId?: Maybe<Scalars['UUID']['output']>;
  /** When the notification expires automatically. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** When the user marked the notification as read. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current lifecycle state of the notification. */
  state: NotificationState;
  /** Localized title for the notification. */
  title: LocalizedText;
  /** The category of the notification. */
  type: NotificationType;
};

/** An action rendered together with a notification. */
export type NotificationAction = {
  __typename?: 'NotificationAction';
  /** Localized label shown for the action in the UI. */
  label: LocalizedText;
  /** Whether the action can still be executed. */
  status: NotificationActionStatus;
  /** The action to perform. */
  type: NotificationActionType;
};

/** The filterable fields of type NotificationAction */
export type NotificationActionFilterInput = {
  and?: InputMaybe<Array<NotificationActionFilterInput>>;
  not?: InputMaybe<NotificationActionFilterInput>;
  or?: InputMaybe<Array<NotificationActionFilterInput>>;
};

/** Availability state of a notification action. */
export enum NotificationActionStatus {
  /** The action is currently available to the user. */
  Available = 'AVAILABLE',
  /** The action was executed. */
  Completed = 'COMPLETED',
  /** The action can no longer be executed. */
  Unavailable = 'UNAVAILABLE'
}

/** Action that can be performed from an actionable notification. */
export enum NotificationActionType {
  /** Accept the incoming contact request. */
  AcceptContactRequest = 'ACCEPT_CONTACT_REQUEST',
  /** Reject the incoming contact request. */
  RejectContactRequest = 'REJECT_CONTACT_REQUEST',
  /** View the post related to this notification */
  ViewPostContent = 'VIEW_POST_CONTENT',
  /** View the project related to this notification */
  ViewProjectContent = 'VIEW_PROJECT_CONTENT'
}

/** Realtime wrapper around a notification change event. */
export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  /** The current notification snapshot after the change. */
  notification: Notification;
  /** The affected notification id. */
  notificationId: Scalars['UUID']['output'];
  /** The kind of notification change. */
  type: NotificationEventType;
};

/** The filterable fields of type NotificationEvent */
export type NotificationEventFilterInput = {
  and?: InputMaybe<Array<NotificationEventFilterInput>>;
  not?: InputMaybe<NotificationEventFilterInput>;
  or?: InputMaybe<Array<NotificationEventFilterInput>>;
};

/** Type of realtime change emitted for a notification. */
export enum NotificationEventType {
  /** A notification action was executed. */
  Actioned = 'ACTIONED',
  /** A new notification was created. */
  Created = 'CREATED',
  /** A notification was deleted from the inbox. */
  Deleted = 'DELETED',
  /** A notification expired. */
  Expired = 'EXPIRED',
  /** A notification was marked as read. */
  Read = 'READ'
}

/** The filterable fields of type Notification */
export type NotificationFilterInput = {
  and?: InputMaybe<Array<NotificationFilterInput>>;
  not?: InputMaybe<NotificationFilterInput>;
  or?: InputMaybe<Array<NotificationFilterInput>>;
};

/** Lifecycle state of a notification in the user's inbox. */
export enum NotificationState {
  /** A user action was executed for this notification. */
  Actioned = 'ACTIONED',
  /** The notification is visible and may still be actionable. */
  Active = 'ACTIVE',
  /** The notification was removed from the user's inbox. */
  Deleted = 'DELETED',
  /** The notification expired automatically and is no longer shown by default. */
  Expired = 'EXPIRED'
}

/** Domain-specific category of a notification. */
export enum NotificationType {
  /** Another user wants to add the current user as a contact. */
  ContactRequest = 'CONTACT_REQUEST',
  /** A previously sent contact request was accepted. */
  ContactRequestAccepted = 'CONTACT_REQUEST_ACCEPTED',
  /** A background documents extraction (powers/skills) finished successfully. */
  ExtractionCompleted = 'EXTRACTION_COMPLETED',
  /** A background documents extraction (powers/skills) failed. */
  ExtractionFailed = 'EXTRACTION_FAILED',
  /** A background documents extraction (powers/skills) was accepted and is running in the background. */
  ExtractionStarted = 'EXTRACTION_STARTED',
  /** A time-bounded maintenance or downtime notice. */
  MaintenanceWindow = 'MAINTENANCE_WINDOW',
  /** A post was published that might be of interest to the current user. */
  PostPublished = 'POST_PUBLISHED',
  /** A project was published that might be of interest to the current user. */
  ProjectPublished = 'PROJECT_PUBLISHED',
  /** The UI is outdated and need to be refreshed */
  SystemUpdate = 'SYSTEM_UPDATE'
}

/** Pagination and filtering options for the notification inbox query. */
export type NotificationsInput = {
  /** Return notifications created before this notification id. */
  afterNotificationId?: InputMaybe<Scalars['UUID']['input']>;
  /** If true, include expired notifications in the result. */
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Notification types this client understands. Notifications of other types are filtered out
   * of the result. When absent or empty, only the six original types
   * (CONTACT_REQUEST … SYSTEM_UPDATE) are returned, so clients built against an older schema
   * never receive enum values they cannot deserialize. Clients should pass the full set of
   * types they support.
   */
  supportedTypes?: InputMaybe<Array<NotificationType>>;
  /** Maximum number of notifications to return. */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** If true, only unread notifications are returned. */
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NumberOfPinsOutput = NumberOfPinsResult;

export type NumberOfPinsResult = {
  __typename?: 'NumberOfPinsResult';
  pinnedPersons?: Maybe<Scalars['Int']['output']>;
  pinnedPosts?: Maybe<Scalars['Int']['output']>;
  pinnedProjects?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type NumberOfPinsResult */
export type NumberOfPinsResultFilterInput = {
  and?: InputMaybe<Array<NumberOfPinsResultFilterInput>>;
  not?: InputMaybe<NumberOfPinsResultFilterInput>;
  or?: InputMaybe<Array<NumberOfPinsResultFilterInput>>;
};

export type Organization = Node & {
  __typename?: 'Organization';
  active?: Maybe<Scalars['Boolean']['output']>;
  alias?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contact?: Maybe<Array<Maybe<ExtendedContactDetail>>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<Organization>;
  type?: Maybe<OrganizationType>;
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  nodes: Array<Organization>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: Organization;
};

/** The filterable fields of type Organization */
export type OrganizationFilterInput = {
  and?: InputMaybe<Array<OrganizationFilterInput>>;
  not?: InputMaybe<OrganizationFilterInput>;
  or?: InputMaybe<Array<OrganizationFilterInput>>;
};

/** The parameters for requesting multiple instances of Organization. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type OrganizationQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Contains information for linking 'Organization' to other entities */
export type OrganizationRelationInput = {
  /** The identifier of 'Organization' */
  id: Scalars['ID']['input'];
};

export enum OrganizationType {
  BusinessOrCorporation = 'BUSINESS_OR_CORPORATION',
  CommunityGroup = 'COMMUNITY_GROUP',
  EducationalInstitute = 'EDUCATIONAL_INSTITUTE',
  Government = 'GOVERNMENT',
  Network = 'NETWORK',
  OrganizationalTeam = 'ORGANIZATIONAL_TEAM',
  Other = 'OTHER',
  RelegiousInstitution = 'RELEGIOUS_INSTITUTION'
}

/** Provides additional information for paged data. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the current page's last item. To be used when fetching the next page. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** True if there is at least one more page available, otherwise false */
  hasNextPage: Scalars['Boolean']['output'];
  /** True if the is a previous page available, otherwise false */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The cursor of the current page's first item. To be used when fetching the previous page. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Period = {
  __typename?: 'Period';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

/** The filterable fields of type Period */
export type PeriodFilterInput = {
  and?: InputMaybe<Array<PeriodFilterInput>>;
  not?: InputMaybe<PeriodFilterInput>;
  or?: InputMaybe<Array<PeriodFilterInput>>;
};

export type Person = Node & {
  __typename?: 'Person';
  administrativeGender?: Maybe<AdministrativeGender>;
  ageInYears?: Maybe<Scalars['Int']['output']>;
  alternativeAvatar?: Maybe<File>;
  apartment?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<File>;
  bio?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['Date']['output']>;
  certifications?: Maybe<Array<Certificate>>;
  childCount?: Maybe<Scalars['Int']['output']>;
  citizenships?: Maybe<Array<Country>>;
  city?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<ContractType>;
  country?: Maybe<Country>;
  countryState?: Maybe<CountryState>;
  currentActivity?: Maybe<Scalars['String']['output']>;
  currentEmployer?: Maybe<Scalars['String']['output']>;
  currentTasks?: Maybe<Scalars['String']['output']>;
  deceased?: Maybe<Deceased>;
  drivingLicence?: Maybe<Scalars['String']['output']>;
  educations?: Maybe<Array<Education>>;
  email?: Maybe<Scalars['String']['output']>;
  emailPrimary: Scalars['String']['output'];
  experiences?: Maybe<Array<Experience>>;
  expertises?: Maybe<Array<Expertise>>;
  formattedName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isContact?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  jobDepartment?: Maybe<JobDepartment>;
  jobLocation?: Maybe<JobLocation>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  languageSkills?: Maybe<Array<LanguageSkill>>;
  maritalStatus?: Maybe<MaritalStatus>;
  miscellaneous?: Maybe<Scalars['String']['output']>;
  name: HumanName;
  nationality?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  sharedAttributes?: Maybe<PersonSharedAttributes>;
  street?: Maybe<Scalars['String']['output']>;
  userRank?: Maybe<UserRank>;
  website?: Maybe<Scalars['String']['output']>;
  workingTimeModel?: Maybe<WorkingTimeModel>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type PersonAlternativeAvatarArgs = {
  profile: Scalars['String']['input'];
};


export type PersonAvatarArgs = {
  profile: Scalars['String']['input'];
  useAlternative: Scalars['Boolean']['input'];
};

export type PersonConnection = {
  __typename?: 'PersonConnection';
  edges: Array<PersonEdge>;
  nodes: Array<Person>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * Preview diff for one person_detail scalar field. `existingValue` is the current
 * genesis value (null if empty), `incomingValue` is what the import proposes (null if
 * the source has nothing). `key` is the field name (e.g. "bio"). A blank/absent
 * `incomingValue` is never offered as a destructive replace. `additive` is true for a
 * set-membership field (e.g. citizenship) where the incoming value is the merged
 * superset rather than a replacement — the client shows an "adds to" note, not a
 * destructive "replaces your value" warning.
 */
export type PersonDetailFieldDiff = {
  __typename?: 'PersonDetailFieldDiff';
  action: ImportDiffAction;
  additive: Scalars['Boolean']['output'];
  existingValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  incomingValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
};

/** The filterable fields of type PersonDetailFieldDiff */
export type PersonDetailFieldDiffFilterInput = {
  and?: InputMaybe<Array<PersonDetailFieldDiffFilterInput>>;
  not?: InputMaybe<PersonDetailFieldDiffFilterInput>;
  or?: InputMaybe<Array<PersonDetailFieldDiffFilterInput>>;
};

export type PersonEdge = {
  __typename?: 'PersonEdge';
  cursor: Scalars['String']['output'];
  node: Person;
};

/** The filterable fields of type Person */
export type PersonFilterInput = {
  ageInYears?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<PersonFilterInput>>;
  childCount?: InputMaybe<IntFilterInput>;
  citizenships?: InputMaybe<CountryListFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  contractType?: InputMaybe<ContractTypeFilterInput>;
  country?: InputMaybe<CountryFilterInput>;
  countryState?: InputMaybe<CountryStateFilterInput>;
  experiences?: InputMaybe<ExperienceListFilterInput>;
  expertises?: InputMaybe<ExpertiseListFilterInput>;
  formattedName?: InputMaybe<StringFilterInput>;
  gender?: InputMaybe<GenderFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isContact?: InputMaybe<BooleanFilterInput>;
  isInAnyPersonGroup?: InputMaybe<BooleanFilterInput>;
  isInAnyPinGroup?: InputMaybe<BooleanFilterInput>;
  isPinned?: InputMaybe<BooleanFilterInput>;
  jobDepartment?: InputMaybe<JobDepartmentFilterInput>;
  jobLocation?: InputMaybe<JobLocationFilterInput>;
  jobTitle?: InputMaybe<StringFilterInput>;
  languageSkills?: InputMaybe<LanguageSkillListFilterInput>;
  maritalStatus?: InputMaybe<MaritalStatusFilterInput>;
  name?: InputMaybe<HumanNameFilterInput>;
  nationality?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PersonFilterInput>;
  or?: InputMaybe<Array<PersonFilterInput>>;
  personGroupId?: InputMaybe<UuidFilterInput>;
  pinGroupId?: InputMaybe<UuidFilterInput>;
  workingTimeModel?: InputMaybe<WorkingTimeModelFilterInput>;
};

export type PersonGroup = Category & Node & {
  __typename?: 'PersonGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

/** The filterable fields of type PersonGroup */
export type PersonGroupFilterInput = {
  and?: InputMaybe<Array<PersonGroupFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PersonGroupFilterInput>;
  or?: InputMaybe<Array<PersonGroupFilterInput>>;
};

export type PersonGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
};

export type PersonGroupMembershipInput = {
  personId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PersonGroupMembershipOutput = PersonGroupMembershipResult;

export type PersonGroupMembershipResult = {
  __typename?: 'PersonGroupMembershipResult';
  personGroups: Array<PersonGroup>;
};

/** The filterable fields of type PersonGroupMembershipResult */
export type PersonGroupMembershipResultFilterInput = {
  and?: InputMaybe<Array<PersonGroupMembershipResultFilterInput>>;
  not?: InputMaybe<PersonGroupMembershipResultFilterInput>;
  or?: InputMaybe<Array<PersonGroupMembershipResultFilterInput>>;
};

export type PersonGroupOutput = PersonGroupResult;

export type PersonGroupRecipient = Node & Recipient & {
  __typename?: 'PersonGroupRecipient';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type PersonGroupRecipient */
export type PersonGroupRecipientFilterInput = {
  and?: InputMaybe<Array<PersonGroupRecipientFilterInput>>;
  not?: InputMaybe<PersonGroupRecipientFilterInput>;
  or?: InputMaybe<Array<PersonGroupRecipientFilterInput>>;
};

export type PersonGroupResult = {
  __typename?: 'PersonGroupResult';
  personGroups: Array<PersonGroup>;
};

/** The filterable fields of type PersonGroupResult */
export type PersonGroupResultFilterInput = {
  and?: InputMaybe<Array<PersonGroupResultFilterInput>>;
  not?: InputMaybe<PersonGroupResultFilterInput>;
  or?: InputMaybe<Array<PersonGroupResultFilterInput>>;
};

export type PersonGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

export type PersonLean = {
  __typename?: 'PersonLean';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type PersonLean */
export type PersonLeanFilterInput = {
  and?: InputMaybe<Array<PersonLeanFilterInput>>;
  not?: InputMaybe<PersonLeanFilterInput>;
  or?: InputMaybe<Array<PersonLeanFilterInput>>;
};

/** The parameters for requesting multiple instances of Person. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type PersonQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<PersonSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<PersonFilterInput>;
};

export type PersonRecipient = Node & Recipient & {
  __typename?: 'PersonRecipient';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  personName?: Maybe<HumanName>;
  thumbnail?: Maybe<File>;
};


export type PersonRecipientThumbnailArgs = {
  profile: Scalars['String']['input'];
  useAlternative: Scalars['Boolean']['input'];
};

/** The filterable fields of type PersonRecipient */
export type PersonRecipientFilterInput = {
  and?: InputMaybe<Array<PersonRecipientFilterInput>>;
  not?: InputMaybe<PersonRecipientFilterInput>;
  or?: InputMaybe<Array<PersonRecipientFilterInput>>;
};

/** Contains information for linking 'Person' to other entities */
export type PersonRelationInput = {
  /** The identifier of 'Person' */
  id: Scalars['ID']['input'];
};

export type PersonSharedAttributes = {
  __typename?: 'PersonSharedAttributes';
  sharedAge?: Maybe<Array<Scalars['String']['output']>>;
  sharedApartmentNumber?: Maybe<Array<Scalars['String']['output']>>;
  sharedBio?: Maybe<Array<Scalars['String']['output']>>;
  sharedBirthdate?: Maybe<Array<Scalars['String']['output']>>;
  sharedChildCount?: Maybe<Array<Scalars['String']['output']>>;
  sharedCitizenships?: Maybe<Array<Scalars['String']['output']>>;
  sharedCity?: Maybe<Array<Scalars['String']['output']>>;
  sharedContractType?: Maybe<Array<Scalars['String']['output']>>;
  sharedCountry?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentActivity?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentEmployer?: Maybe<Array<Scalars['String']['output']>>;
  sharedCurrentTasks?: Maybe<Array<Scalars['String']['output']>>;
  sharedDriversLicense?: Maybe<Array<Scalars['String']['output']>>;
  sharedEmail?: Maybe<Array<Scalars['String']['output']>>;
  sharedGender?: Maybe<Array<Scalars['String']['output']>>;
  sharedHouseNumber?: Maybe<Array<Scalars['String']['output']>>;
  sharedMaritalStatus?: Maybe<Array<Scalars['String']['output']>>;
  sharedMiscellaneous?: Maybe<Array<Scalars['String']['output']>>;
  sharedNationality?: Maybe<Array<Scalars['String']['output']>>;
  sharedPhone?: Maybe<Array<Scalars['String']['output']>>;
  sharedProfession?: Maybe<Array<Scalars['String']['output']>>;
  sharedState?: Maybe<Array<Scalars['String']['output']>>;
  sharedStreet?: Maybe<Array<Scalars['String']['output']>>;
  sharedWebsite?: Maybe<Array<Scalars['String']['output']>>;
  sharedWorkingTimeModel?: Maybe<Array<Scalars['String']['output']>>;
  sharedZipCode?: Maybe<Array<Scalars['String']['output']>>;
};

/** The filterable fields of type PersonSharedAttributes */
export type PersonSharedAttributesFilterInput = {
  and?: InputMaybe<Array<PersonSharedAttributesFilterInput>>;
  not?: InputMaybe<PersonSharedAttributesFilterInput>;
  or?: InputMaybe<Array<PersonSharedAttributesFilterInput>>;
};

export type PersonSortInput = {
  contactSince?: InputMaybe<SortOrder>;
  formattedName?: InputMaybe<SortOrder>;
  name?: InputMaybe<HumanNameSortInput>;
};

export type PersonWithDate = {
  __typename?: 'PersonWithDate';
  dateTime: Scalars['DateTime']['output'];
  person: Person;
};

/** The filterable fields of type PersonWithDate */
export type PersonWithDateFilterInput = {
  and?: InputMaybe<Array<PersonWithDateFilterInput>>;
  not?: InputMaybe<PersonWithDateFilterInput>;
  or?: InputMaybe<Array<PersonWithDateFilterInput>>;
};

export type PinGroup = Category & Node & {
  __typename?: 'PinGroup';
  id: Scalars['ID']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pinType: PinType;
};

/** The filterable fields of type PinGroup */
export type PinGroupFilterInput = {
  and?: InputMaybe<Array<PinGroupFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<PinGroupFilterInput>;
  or?: InputMaybe<Array<PinGroupFilterInput>>;
};

export type PinGroupInput = {
  person?: InputMaybe<Scalars['String']['input']>;
  pinTypes?: InputMaybe<Array<PinType>>;
};

export type PinGroupMembershipInput = {
  personId?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PinGroupMembershipOutput = PinGroupMembershipResult;

export type PinGroupMembershipResult = {
  __typename?: 'PinGroupMembershipResult';
  pinGroups: Array<PinGroup>;
};

/** The filterable fields of type PinGroupMembershipResult */
export type PinGroupMembershipResultFilterInput = {
  and?: InputMaybe<Array<PinGroupMembershipResultFilterInput>>;
  not?: InputMaybe<PinGroupMembershipResultFilterInput>;
  or?: InputMaybe<Array<PinGroupMembershipResultFilterInput>>;
};

export type PinGroupOutput = PinGroupResult;

export type PinGroupResult = {
  __typename?: 'PinGroupResult';
  pinGroups: Array<PinGroup>;
};

/** The filterable fields of type PinGroupResult */
export type PinGroupResultFilterInput = {
  and?: InputMaybe<Array<PinGroupResultFilterInput>>;
  not?: InputMaybe<PinGroupResultFilterInput>;
  or?: InputMaybe<Array<PinGroupResultFilterInput>>;
};

export type PinGroupSortInput = {
  name?: InputMaybe<SortOrder>;
};

export enum PinType {
  Person = 'PERSON',
  Post = 'POST',
  Project = 'PROJECT'
}

export type PipelineExtractionResult = {
  __typename?: 'PipelineExtractionResult';
  errored: Scalars['Int']['output'];
  processed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/** The filterable fields of type PipelineExtractionResult */
export type PipelineExtractionResultFilterInput = {
  and?: InputMaybe<Array<PipelineExtractionResultFilterInput>>;
  not?: InputMaybe<PipelineExtractionResultFilterInput>;
  or?: InputMaybe<Array<PipelineExtractionResultFilterInput>>;
};

export type PlayableGrowElement = {
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type PlayableGrowElement */
export type PlayableGrowElementFilterInput = {
  and?: InputMaybe<Array<PlayableGrowElementFilterInput>>;
  not?: InputMaybe<PlayableGrowElementFilterInput>;
  or?: InputMaybe<Array<PlayableGrowElementFilterInput>>;
};

export type PowersDevStat = {
  __typename?: 'PowersDevStat';
  currentValue: Scalars['Int']['output'];
  element: CreativityElement;
  person?: Maybe<PersonLean>;
  previousValue: Scalars['Int']['output'];
};

/** The filterable fields of type PowersDevStat */
export type PowersDevStatFilterInput = {
  and?: InputMaybe<Array<PowersDevStatFilterInput>>;
  not?: InputMaybe<PowersDevStatFilterInput>;
  or?: InputMaybe<Array<PowersDevStatFilterInput>>;
};

export type PresenceIndicator = {
  __typename?: 'PresenceIndicator';
  conversationId: Scalars['UUID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  observedAt: Scalars['DateTime']['output'];
  online: Scalars['Boolean']['output'];
  personId: Scalars['UUID']['output'];
};

/** The filterable fields of type PresenceIndicator */
export type PresenceIndicatorFilterInput = {
  and?: InputMaybe<Array<PresenceIndicatorFilterInput>>;
  not?: InputMaybe<PresenceIndicatorFilterInput>;
  or?: InputMaybe<Array<PresenceIndicatorFilterInput>>;
};

export type ProcessDocumentInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  documentId?: InputMaybe<Scalars['UUID']['input']>;
  fileName: Scalars['String']['input'];
};

export type ProcessDocumentsInput = {
  documents: Array<ProcessDocumentInput>;
  extractPowers: Scalars['Boolean']['input'];
  extractProfile: Scalars['Boolean']['input'];
  extractSkills: Scalars['Boolean']['input'];
};

export type ProcessDocumentsOutput = ProcessDocumentsResult;

export type ProcessDocumentsResult = {
  __typename?: 'ProcessDocumentsResult';
  documents: Array<ProcessedDocumentResult>;
  message?: Maybe<Scalars['String']['output']>;
  powers?: Maybe<PipelineExtractionResult>;
  skills?: Maybe<PipelineExtractionResult>;
  status: Scalars['String']['output'];
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** The filterable fields of type ProcessDocumentsResult */
export type ProcessDocumentsResultFilterInput = {
  and?: InputMaybe<Array<ProcessDocumentsResultFilterInput>>;
  not?: InputMaybe<ProcessDocumentsResultFilterInput>;
  or?: InputMaybe<Array<ProcessDocumentsResultFilterInput>>;
};

export type ProcessedDocumentResult = {
  __typename?: 'ProcessedDocumentResult';
  documentId?: Maybe<Scalars['UUID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  ref: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** The filterable fields of type ProcessedDocumentResult */
export type ProcessedDocumentResultFilterInput = {
  and?: InputMaybe<Array<ProcessedDocumentResultFilterInput>>;
  not?: InputMaybe<ProcessedDocumentResultFilterInput>;
  or?: InputMaybe<Array<ProcessedDocumentResultFilterInput>>;
};

/**
 * Non-destructive preview of a profile import — nothing is written. The importer fetches
 * and maps the source (LinkedIn) data, diffs it against the caller's existing profile, and
 * returns the per-field / per-row diff. The client reviews and edits the proposals, then
 * persists the accepted ones through the ordinary profile mutations (updatePerson,
 * createExperience, …) — the same write path as manual editing. Genesis holds no import
 * state between preview and save.
 */
export type ProfileImportPreview = {
  __typename?: 'ProfileImportPreview';
  certificates: CollectionDiff;
  educations: CollectionDiff;
  experiences: CollectionDiff;
  expertises: CollectionDiff;
  languageSkills: CollectionDiff;
  personDetail: Array<PersonDetailFieldDiff>;
  warnings: Array<Scalars['String']['output']>;
};

/** The filterable fields of type ProfileImportPreview */
export type ProfileImportPreviewFilterInput = {
  and?: InputMaybe<Array<ProfileImportPreviewFilterInput>>;
  not?: InputMaybe<ProfileImportPreviewFilterInput>;
  or?: InputMaybe<Array<ProfileImportPreviewFilterInput>>;
};

export type QnrAnswerChoiceSaveInput = {
  answer: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  qnrAnswerChoiceId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<QuestionnaireStatus>;
  weight: Scalars['Int']['input'];
};

export type QnrQuestionSaveInput = {
  answerChoices: Array<QnrAnswerChoiceSaveInput>;
  creativityElement: CreativityElement;
  position: Scalars['Int']['input'];
  qnrQuestionId?: InputMaybe<Scalars['UUID']['input']>;
  question: Scalars['String']['input'];
  status?: InputMaybe<QuestionnaireStatus>;
};

export type Query = {
  __typename?: 'Query';
  /** Returns ACTIVE questionnaires whose creativity_element equals the given value, each carrying a per-row flag indicating whether the current user has answered every ACTIVE question of that questionnaire. */
  activeQuestionnairesByElement: Array<QuestionnaireResult>;
  /** Returns ACTIVE questionnaires that have no creativity_element set, each carrying a per-row flag indicating whether the current user has answered every ACTIVE question of that questionnaire. */
  activeQuestionnairesWithoutElement: Array<QuestionnaireResult>;
  address?: Maybe<Address>;
  addresses: AddressConnection;
  contactPowersDevStats: Array<PowersDevStat>;
  contactsWithHighestScore: Array<ContactWithGrowScore>;
  contractTypes: ContractTypesResult;
  conversation?: Maybe<Conversation>;
  conversationMessages: Array<ChatMessage>;
  conversationPresence: Array<PresenceIndicator>;
  conversationReadReceipts: Array<ConversationReadReceipt>;
  conversations: Array<Conversation>;
  countries: CountriesResult;
  countryState?: Maybe<CountryState>;
  countryStatesByCountry: CountryStatesByCountryResult;
  curriculumVitae?: Maybe<CurriculumVitae>;
  curriculumVitaes: CurriculumVitaeConnection;
  defaultCandidateAssessmentPrompt: Scalars['String']['output'];
  degrees: DegreesResult;
  document?: Maybe<Document>;
  documentGroup?: Maybe<DocumentGroup>;
  documentGroups: DocumentGroupOutput;
  documents: DocumentConnection;
  extendedContactDetail?: Maybe<ExtendedContactDetail>;
  extendedContactDetails: ExtendedContactDetailConnection;
  /**
   * Returns the current status of a documents-extraction job started by the caller. Serves as
   * the polling fallback when the events subscription is unavailable, or when a job was
   * interrupted (e.g. by a deployment) and never emitted its terminal event. Job state is
   * retained for ~24 hours after the last transition; older jobs report as not found.
   */
  extractionJob: ExtractionJob;
  genders: GendersResult;
  /** Full-text search across all indexed entity types with audience-based visibility filtering. */
  globalSearch: GlobalSearchOutput;
  growRanking: GrowRanking;
  growResource?: Maybe<GrowResource>;
  industries: IndustriesResult;
  jobDepartments: JobDepartmentsResult;
  jobLocations: JobLocationsResult;
  languageSkill?: Maybe<LanguageSkill>;
  languageSkills: LanguageSkillConnection;
  maritalStatuses: MaritalStatusesResult;
  match?: Maybe<Match>;
  matchCandidate?: Maybe<MatchCandidate>;
  matchCandidates: MatchCandidateConnection;
  matchResult?: Maybe<MatchResult>;
  matchResults: MatchResultConnection;
  matches: MatchConnection;
  myAvatar?: Maybe<File>;
  myContactCount: Scalars['Int']['output'];
  myPowersDevStats: Array<PowersDevStat>;
  myself: Person;
  /** Returns the current user's notifications ordered from newest to oldest. */
  notifications: Array<Notification>;
  numberOfPinnedItems: NumberOfPinsOutput;
  organization?: Maybe<Organization>;
  organizations: OrganizationConnection;
  person?: Maybe<Person>;
  personGroup?: Maybe<PersonGroup>;
  personGroupMemberships?: Maybe<PersonGroupMembershipOutput>;
  personGroups: PersonGroupOutput;
  persons: PersonConnection;
  pinGroup?: Maybe<PinGroup>;
  pinGroupMemberships?: Maybe<PinGroupMembershipOutput>;
  pinGroups: PinGroupOutput;
  powersEvaluationResults: Array<ElementEvaluationResult>;
  questionnaireQuestions: Array<QuestionnaireQuestion>;
  questionnaires: Array<Questionnaire>;
  recentInterestedInitiatives: Array<SharedItemWithDate>;
  recentProfileVisitors: Array<PersonWithDate>;
  recentSharedItemsCreatedByUser: Array<SharedItemWithDate>;
  recentlyReadSharedItems: Array<SharedItemWithDate>;
  recipients?: Maybe<Array<Recipient>>;
  selfAssessment?: Maybe<SelfAssessment>;
  selfAssessmentResult: ElementEvaluationResult;
  selfAssessmentResults: Array<ElementEvaluationResult>;
  selfAssessmentStatements: Array<SelfAssessmentStatement>;
  settings: Settings;
  sharedItem?: Maybe<SharedItem>;
  sharedItemComment?: Maybe<SharedItemComment>;
  sharedItemComments: SharedItemCommentConnection;
  sharedItemRating?: Maybe<SharedItemRating>;
  sharedItemRatings: SharedItemRatingConnection;
  sharedItemSignUps: PersonConnection;
  sharedItems: SharedItemConnection;
  smartAnalysisResults: Array<SmartAnalysisResult>;
  /** Suggests activity descriptions for a given job position. Does not read the caller's profile. See ADR-0003. */
  suggestActivityDescriptions: SuggestionResult;
  /** Suggests skill (Expertise.description) values for the caller, informed by their profile. See ADR-0003. */
  suggestExpertiseDescriptions: SuggestionResult;
  /** Suggests a profile summary (Person.bio) for the caller, informed by their profile. Returns a single-paragraph suggestion in `suggestions[0]`. */
  suggestProfileSummary: SuggestionResult;
  systemSettings?: Maybe<SystemSettings>;
  teamProfile?: Maybe<TeamProfile>;
  teamProfiles: TeamProfileConnection;
  topElementsForContacts: Array<ContactTopElements>;
  unreadChatMessageCount: Scalars['Int']['output'];
  /** Returns the unread notification count for the current user, restricted to the types the client declares (see SupportedNotificationTypesInput). */
  unreadNotificationCount: Scalars['Int']['output'];
  usedDocumentTags?: Maybe<UsedDocumentTagsOutput>;
  workingTimeModels: WorkingTimeModelsResult;
};


export type QueryActiveQuestionnairesByElementArgs = {
  input: ActiveQuestionnairesByElementInput;
};


export type QueryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAddressesArgs = {
  input: AddressQueryInput;
};


export type QueryContactPowersDevStatsArgs = {
  input: ContactPowersDevStatsInput;
};


export type QueryContactsWithHighestScoreArgs = {
  input: ContactsWithHighestScoreInput;
};


export type QueryConversationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryConversationMessagesArgs = {
  input: ConversationMessagesInput;
};


export type QueryConversationPresenceArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type QueryConversationReadReceiptsArgs = {
  conversationId: Scalars['UUID']['input'];
};


export type QueryCountryStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCountryStatesByCountryArgs = {
  input?: InputMaybe<CountryStatesByCountryInput>;
};


export type QueryCurriculumVitaeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCurriculumVitaesArgs = {
  input: CurriculumVitaeQueryInput;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentGroupsArgs = {
  input?: InputMaybe<DocumentGroupInput>;
};


export type QueryDocumentsArgs = {
  input: DocumentQueryInput;
};


export type QueryExtendedContactDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExtendedContactDetailsArgs = {
  input: ExtendedContactDetailQueryInput;
};


export type QueryExtractionJobArgs = {
  jobId: Scalars['UUID']['input'];
};


export type QueryGlobalSearchArgs = {
  input: GlobalSearchInput;
};


export type QueryGrowResourceArgs = {
  input: GrowResourceQueryInput;
};


export type QueryLanguageSkillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLanguageSkillsArgs = {
  input: LanguageSkillQueryInput;
};


export type QueryMatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchCandidatesArgs = {
  input: MatchCandidateQueryInput;
};


export type QueryMatchResultArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMatchResultsArgs = {
  input: MatchResultQueryInput;
};


export type QueryMatchesArgs = {
  input: MatchQueryInput;
};


export type QueryMyPowersDevStatsArgs = {
  input: MyPowersDevStatsInput;
};


export type QueryNotificationsArgs = {
  input?: InputMaybe<NotificationsInput>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  input: OrganizationQueryInput;
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonGroupMembershipsArgs = {
  input?: InputMaybe<PersonGroupMembershipInput>;
};


export type QueryPersonGroupsArgs = {
  input?: InputMaybe<PersonGroupInput>;
};


export type QueryPersonsArgs = {
  input: PersonQueryInput;
};


export type QueryPinGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPinGroupMembershipsArgs = {
  input?: InputMaybe<PinGroupMembershipInput>;
};


export type QueryPinGroupsArgs = {
  input?: InputMaybe<PinGroupInput>;
};


export type QueryQuestionnaireQuestionsArgs = {
  questionnaireId: Scalars['UUID']['input'];
};


export type QueryQuestionnairesArgs = {
  input?: InputMaybe<QuestionnairesInput>;
};


export type QueryRecentInterestedInitiativesArgs = {
  input: RecentInterestedInitiativesInput;
};


export type QueryRecentProfileVisitorsArgs = {
  limit: Scalars['Int']['input'];
};


export type QueryRecentSharedItemsCreatedByUserArgs = {
  input: RecentSharedItemsCreatedByUserInput;
};


export type QueryRecentlyReadSharedItemsArgs = {
  input: RecentlyReadSharedItemsInput;
};


export type QueryRecipientsArgs = {
  input: RecipientQueryInput;
};


export type QuerySelfAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySelfAssessmentResultArgs = {
  input: SelfAssessmentResultsQueryInput;
};


export type QuerySelfAssessmentStatementsArgs = {
  input: SelfAssessmentStatementsInput;
};


export type QuerySettingsArgs = {
  person?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySharedItemArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharedItemCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharedItemCommentsArgs = {
  input: SharedItemCommentQueryInput;
};


export type QuerySharedItemRatingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySharedItemRatingsArgs = {
  input: SharedItemRatingQueryInput;
};


export type QuerySharedItemSignUpsArgs = {
  input?: InputMaybe<SharedItemSignUpQueryInput>;
};


export type QuerySharedItemsArgs = {
  input: SharedItemQueryInput;
};


export type QuerySuggestActivityDescriptionsArgs = {
  input: SuggestActivityDescriptionsInput;
};


export type QuerySuggestExpertiseDescriptionsArgs = {
  input: SuggestExpertiseDescriptionsInput;
};


export type QuerySuggestProfileSummaryArgs = {
  input: SuggestProfileSummaryInput;
};


export type QueryTeamProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamProfilesArgs = {
  input: TeamProfileQueryInput;
};


export type QueryTopElementsForContactsArgs = {
  input: ContactTopElementsInput;
};


export type QueryUnreadChatMessageCountArgs = {
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryUnreadNotificationCountArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type QueryUsedDocumentTagsArgs = {
  input?: InputMaybe<UsedDocumentTagsInput>;
};

/** The filterable fields of type Query */
export type QueryFilterInput = {
  and?: InputMaybe<Array<QueryFilterInput>>;
  not?: InputMaybe<QueryFilterInput>;
  or?: InputMaybe<Array<QueryFilterInput>>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  creativityElement?: Maybe<CreativityElement>;
  instructions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  questionnaireId: Scalars['UUID']['output'];
  status: QuestionnaireStatus;
};

export type QuestionnaireAnswerChoice = {
  __typename?: 'QuestionnaireAnswerChoice';
  answer: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  qnrAnswerChoiceId: Scalars['UUID']['output'];
  status: QuestionnaireStatus;
  weight: Scalars['Int']['output'];
};

/** The filterable fields of type QuestionnaireAnswerChoice */
export type QuestionnaireAnswerChoiceFilterInput = {
  and?: InputMaybe<Array<QuestionnaireAnswerChoiceFilterInput>>;
  not?: InputMaybe<QuestionnaireAnswerChoiceFilterInput>;
  or?: InputMaybe<Array<QuestionnaireAnswerChoiceFilterInput>>;
};

/** The filterable fields of type Questionnaire */
export type QuestionnaireFilterInput = {
  and?: InputMaybe<Array<QuestionnaireFilterInput>>;
  not?: InputMaybe<QuestionnaireFilterInput>;
  or?: InputMaybe<Array<QuestionnaireFilterInput>>;
};

export type QuestionnaireQuestion = {
  __typename?: 'QuestionnaireQuestion';
  answerChoices: Array<QuestionnaireAnswerChoice>;
  creativityElement: CreativityElement;
  position: Scalars['Int']['output'];
  qnrQuestionId: Scalars['UUID']['output'];
  question: Scalars['String']['output'];
  status: QuestionnaireStatus;
};

/** The filterable fields of type QuestionnaireQuestion */
export type QuestionnaireQuestionFilterInput = {
  and?: InputMaybe<Array<QuestionnaireQuestionFilterInput>>;
  not?: InputMaybe<QuestionnaireQuestionFilterInput>;
  or?: InputMaybe<Array<QuestionnaireQuestionFilterInput>>;
};

export type QuestionnaireResult = {
  __typename?: 'QuestionnaireResult';
  /** True when every ACTIVE question (and its ACTIVE answer choices) of this questionnaire has a qnr_result for the current user. Vacuously true if the questionnaire has no ACTIVE questions. */
  answered: Scalars['Boolean']['output'];
  questionnaire: Questionnaire;
};

/** The filterable fields of type QuestionnaireResult */
export type QuestionnaireResultFilterInput = {
  and?: InputMaybe<Array<QuestionnaireResultFilterInput>>;
  not?: InputMaybe<QuestionnaireResultFilterInput>;
  or?: InputMaybe<Array<QuestionnaireResultFilterInput>>;
};

export type QuestionnaireSaveInput = {
  creativityElement?: InputMaybe<CreativityElement>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  questionnaireId?: InputMaybe<Scalars['UUID']['input']>;
  status: QuestionnaireStatus;
};

export enum QuestionnaireStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type QuestionnairesInput = {
  status?: InputMaybe<QuestionnaireStatus>;
};

export type RateSharedItemInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  fiveStarRating?: InputMaybe<Scalars['Float']['input']>;
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
};

export type RateSharedItemOutput = RateSharedItemResult;

export type RateSharedItemResult = {
  __typename?: 'RateSharedItemResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type RateSharedItemResult */
export type RateSharedItemResultFilterInput = {
  and?: InputMaybe<Array<RateSharedItemResultFilterInput>>;
  not?: InputMaybe<RateSharedItemResultFilterInput>;
  or?: InputMaybe<Array<RateSharedItemResultFilterInput>>;
};

export type RecentInterestedInitiativesInput = {
  limit: Scalars['Int']['input'];
};

export type RecentSharedItemsCreatedByUserInput = {
  limit: Scalars['Int']['input'];
};

export type RecentlyReadSharedItemsInput = {
  limit: Scalars['Int']['input'];
};

export type Recipient = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RecipientFilterInput = {
  and?: InputMaybe<Array<RecipientFilterInput>>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<RecipientFilterInput>;
  or?: InputMaybe<Array<RecipientFilterInput>>;
};

export type RecipientQueryInput = {
  order?: InputMaybe<RecipientSortInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipientFilterInput>;
};

export type RecipientSortInput = {
  name?: InputMaybe<SortOrder>;
};

export type RegisterDeviceTokenInput = {
  platform: DevicePlatform;
  token: Scalars['String']['input'];
};

export type RemoveContactsInput = {
  contacts: Array<Scalars['UUID']['input']>;
  person?: InputMaybe<Scalars['UUID']['input']>;
};

export type RemoveContactsOutput = RemoveContactsResult;

export type RemoveContactsResult = {
  __typename?: 'RemoveContactsResult';
  contactsRemoved: Array<Scalars['UUID']['output']>;
};

/** The filterable fields of type RemoveContactsResult */
export type RemoveContactsResultFilterInput = {
  and?: InputMaybe<Array<RemoveContactsResultFilterInput>>;
  not?: InputMaybe<RemoveContactsResultFilterInput>;
  or?: InputMaybe<Array<RemoveContactsResultFilterInput>>;
};

export type RemovePinsInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  persons?: InputMaybe<Array<Scalars['UUID']['input']>>;
  sharedItems?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type RemovePinsOutput = RemovePinsResult;

export type RemovePinsResult = {
  __typename?: 'RemovePinsResult';
  personsUnpinned?: Maybe<Array<Scalars['UUID']['output']>>;
  sharedItemsUnpinned?: Maybe<Array<Scalars['UUID']['output']>>;
};

/** The filterable fields of type RemovePinsResult */
export type RemovePinsResultFilterInput = {
  and?: InputMaybe<Array<RemovePinsResultFilterInput>>;
  not?: InputMaybe<RemovePinsResultFilterInput>;
  or?: InputMaybe<Array<RemovePinsResultFilterInput>>;
};

export type ResilienceSkills = {
  __typename?: 'ResilienceSkills';
  debateProof?: Maybe<Scalars['SkillRating']['output']>;
  fearless?: Maybe<Scalars['SkillRating']['output']>;
  flexible?: Maybe<Scalars['SkillRating']['output']>;
  independent?: Maybe<Scalars['SkillRating']['output']>;
  mobile?: Maybe<Scalars['SkillRating']['output']>;
  resilient?: Maybe<Scalars['SkillRating']['output']>;
  selfAssured?: Maybe<Scalars['SkillRating']['output']>;
  selfOrganized?: Maybe<Scalars['SkillRating']['output']>;
  selfReflective?: Maybe<Scalars['SkillRating']['output']>;
  steadfast?: Maybe<Scalars['SkillRating']['output']>;
  versatile?: Maybe<Scalars['SkillRating']['output']>;
};

/** The filterable fields of type ResilienceSkills */
export type ResilienceSkillsFilterInput = {
  and?: InputMaybe<Array<ResilienceSkillsFilterInput>>;
  not?: InputMaybe<ResilienceSkillsFilterInput>;
  or?: InputMaybe<Array<ResilienceSkillsFilterInput>>;
};

export type ResultOrientationSkills = {
  __typename?: 'ResultOrientationSkills';
  analytical?: Maybe<Scalars['SkillRating']['output']>;
  assertive?: Maybe<Scalars['SkillRating']['output']>;
  conscientious?: Maybe<Scalars['SkillRating']['output']>;
  consistent?: Maybe<Scalars['SkillRating']['output']>;
  customerOriented?: Maybe<Scalars['SkillRating']['output']>;
  decisive?: Maybe<Scalars['SkillRating']['output']>;
  evaluative?: Maybe<Scalars['SkillRating']['output']>;
  focused?: Maybe<Scalars['SkillRating']['output']>;
  reliable?: Maybe<Scalars['SkillRating']['output']>;
  responsible?: Maybe<Scalars['SkillRating']['output']>;
  selfInitiated?: Maybe<Scalars['SkillRating']['output']>;
  strongInLeadership?: Maybe<Scalars['SkillRating']['output']>;
  tidy?: Maybe<Scalars['SkillRating']['output']>;
};

/** The filterable fields of type ResultOrientationSkills */
export type ResultOrientationSkillsFilterInput = {
  and?: InputMaybe<Array<ResultOrientationSkillsFilterInput>>;
  not?: InputMaybe<ResultOrientationSkillsFilterInput>;
  or?: InputMaybe<Array<ResultOrientationSkillsFilterInput>>;
};

/**
 * Preview diff for one field of a collection row. `existingValue` / `incomingValue` are
 * MACHINE values (ISO `YYYY[-MM]` for MONTH, a CEFR enum name or `NATIVE` for CEFR, plain
 * text for TEXT) so the client can both render and edit them; the client localizes labels
 * and formats values. `editable` is false for fields the import can show but not accept an
 * edit for (e.g. a language tag).
 */
export type RowFieldDiff = {
  __typename?: 'RowFieldDiff';
  editable: Scalars['Boolean']['output'];
  existingValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  incomingValue?: Maybe<Scalars['String']['output']>;
  kind: RowFieldKind;
};

/** The filterable fields of type RowFieldDiff */
export type RowFieldDiffFilterInput = {
  and?: InputMaybe<Array<RowFieldDiffFilterInput>>;
  not?: InputMaybe<RowFieldDiffFilterInput>;
  or?: InputMaybe<Array<RowFieldDiffFilterInput>>;
};

/**
 * The input kind of one collection-row field — tells the client how to render and edit
 * it. TEXT = free text; MONTH = a year-or-month date carried as `YYYY` or `YYYY-MM`
 * (blank end date = ongoing / "present"); CEFR = a language proficiency level
 * (`A1`..`C2`, or `NATIVE`).
 */
export enum RowFieldKind {
  Cefr = 'CEFR',
  Month = 'MONTH',
  Text = 'TEXT'
}

export type SaveQuestionnaireInput = {
  questionnaire: QuestionnaireSaveInput;
  questions: Array<QnrQuestionSaveInput>;
};

export type SaveQuestionnaireOutput = {
  __typename?: 'SaveQuestionnaireOutput';
  questionnaire: Questionnaire;
  questions: Array<QuestionnaireQuestion>;
};

/** The filterable fields of type SaveQuestionnaireOutput */
export type SaveQuestionnaireOutputFilterInput = {
  and?: InputMaybe<Array<SaveQuestionnaireOutputFilterInput>>;
  not?: InputMaybe<SaveQuestionnaireOutputFilterInput>;
  or?: InputMaybe<Array<SaveQuestionnaireOutputFilterInput>>;
};

export type SaveQuestionnaireResultItem = {
  qnrAnswerChoiceId: Scalars['UUID']['input'];
  timeTakenMs?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveQuestionnaireResultsInput = {
  results: Array<SaveQuestionnaireResultItem>;
};

export type SaveSelfAssessmentResultItem = {
  questionId: Scalars['UUID']['input'];
  scorePercent: Scalars['Int']['input'];
};

export type SaveSelfAssessmentResultsInput = {
  results: Array<SaveSelfAssessmentResultItem>;
};

export enum SearchEntityType {
  Certificate = 'CERTIFICATE',
  Document = 'DOCUMENT',
  Education = 'EDUCATION',
  Experience = 'EXPERIENCE',
  Expertise = 'EXPERTISE',
  Match = 'MATCH',
  Person = 'PERSON',
  SharedItemPost = 'SHARED_ITEM_POST',
  SharedItemProject = 'SHARED_ITEM_PROJECT'
}

export type SelfAssessment = Node & {
  __typename?: 'SelfAssessment';
  id: Scalars['ID']['output'];
  questions: Array<SelfAssessmentStatement>;
};

/** The filterable fields of type SelfAssessment */
export type SelfAssessmentFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentFilterInput>>;
  not?: InputMaybe<SelfAssessmentFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentFilterInput>>;
};

export type SelfAssessmentResult = Node & {
  __typename?: 'SelfAssessmentResult';
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  question?: Maybe<SelfAssessmentStatement>;
  scorePercent?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type SelfAssessmentResult */
export type SelfAssessmentResultFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentResultFilterInput>>;
  not?: InputMaybe<SelfAssessmentResultFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentResultFilterInput>>;
};

export type SelfAssessmentResultsQueryInput = {
  element: CreativityElement;
};

export type SelfAssessmentStatement = Node & {
  __typename?: 'SelfAssessmentStatement';
  content: LocalizedText;
  element: CreativityElement;
  id: Scalars['ID']['output'];
  invertResult: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
};

/** The filterable fields of type SelfAssessmentStatement */
export type SelfAssessmentStatementFilterInput = {
  and?: InputMaybe<Array<SelfAssessmentStatementFilterInput>>;
  not?: InputMaybe<SelfAssessmentStatementFilterInput>;
  or?: InputMaybe<Array<SelfAssessmentStatementFilterInput>>;
};

/** Contains information for linking 'SelfAssessmentStatement' to other entities */
export type SelfAssessmentStatementRelationInput = {
  /** The identifier of 'SelfAssessmentStatement' */
  id: Scalars['ID']['input'];
};

export type SelfAssessmentStatementsInput = {
  element: CreativityElement;
};

export type SendChatMessageInput = {
  content: Scalars['String']['input'];
  conversationId: Scalars['UUID']['input'];
};

export type SetConversationTypingInput = {
  conversationId: Scalars['UUID']['input'];
  typing: Scalars['Boolean']['input'];
};

export type SetMatchNotesInput = {
  aiCopilotText?: InputMaybe<Scalars['String']['input']>;
  matchId: Scalars['UUID']['input'];
};

export type SetMatchNotesOutput = SetMatchNotesResult;

export type SetMatchNotesResult = {
  __typename?: 'SetMatchNotesResult';
  match: Match;
};

/** The filterable fields of type SetMatchNotesResult */
export type SetMatchNotesResultFilterInput = {
  and?: InputMaybe<Array<SetMatchNotesResultFilterInput>>;
  not?: InputMaybe<SetMatchNotesResultFilterInput>;
  or?: InputMaybe<Array<SetMatchNotesResultFilterInput>>;
};

export type SetMatchTeamSizeInput = {
  matchId: Scalars['UUID']['input'];
  teamCount?: InputMaybe<Scalars['Int']['input']>;
  teamSize: Scalars['Int']['input'];
};

export type SetMatchTeamSizeOutput = SetMatchTeamSizeResult;

export type SetMatchTeamSizeResult = {
  __typename?: 'SetMatchTeamSizeResult';
  match: Match;
};

/** The filterable fields of type SetMatchTeamSizeResult */
export type SetMatchTeamSizeResultFilterInput = {
  and?: InputMaybe<Array<SetMatchTeamSizeResultFilterInput>>;
  not?: InputMaybe<SetMatchTeamSizeResultFilterInput>;
  or?: InputMaybe<Array<SetMatchTeamSizeResultFilterInput>>;
};

export type Settings = {
  __typename?: 'Settings';
  settings?: Maybe<Scalars['Object']['output']>;
};

/** The filterable fields of type Settings */
export type SettingsFilterInput = {
  and?: InputMaybe<Array<SettingsFilterInput>>;
  not?: InputMaybe<SettingsFilterInput>;
  or?: InputMaybe<Array<SettingsFilterInput>>;
};

export type SharableEntity = {
  sharedWith?: Maybe<Array<Audience>>;
};

/** The filterable fields of type SharableEntity */
export type SharableEntityFilterInput = {
  and?: InputMaybe<Array<SharableEntityFilterInput>>;
  not?: InputMaybe<SharableEntityFilterInput>;
  or?: InputMaybe<Array<SharableEntityFilterInput>>;
};

export type SharedItem = Node & SharableEntity & {
  __typename?: 'SharedItem';
  commented?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Person>;
  darkMode?: Maybe<Colors>;
  description?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<File>>;
  filesToDelete?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<File>>;
  imagesToDelete?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  itemType?: Maybe<SharedItemType>;
  lightMode?: Maybe<Colors>;
  mainImage?: Maybe<File>;
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['Boolean']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  publishedOn?: Maybe<Scalars['DateTime']['output']>;
  rated?: Maybe<Scalars['Boolean']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratings?: Maybe<Scalars['Int']['output']>;
  sharedWith?: Maybe<Array<Audience>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  signUps?: Maybe<Scalars['Int']['output']>;
  signedUp?: Maybe<Scalars['Boolean']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  watches?: Maybe<Scalars['Int']['output']>;
};


export type SharedItemMainImageArgs = {
  profile?: InputMaybe<Scalars['String']['input']>;
};

export type SharedItemComment = Node & {
  __typename?: 'SharedItemComment';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  postedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedItem?: Maybe<SharedItem>;
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

export type SharedItemCommentConnection = {
  __typename?: 'SharedItemCommentConnection';
  edges: Array<SharedItemCommentEdge>;
  nodes: Array<SharedItemComment>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemCommentEdge = {
  __typename?: 'SharedItemCommentEdge';
  cursor: Scalars['String']['output'];
  node: SharedItemComment;
};

/** The filterable fields of type SharedItemComment */
export type SharedItemCommentFilterInput = {
  and?: InputMaybe<Array<SharedItemCommentFilterInput>>;
  content?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<SharedItemCommentFilterInput>;
  or?: InputMaybe<Array<SharedItemCommentFilterInput>>;
  person?: InputMaybe<PersonFilterInput>;
  sharedItem?: InputMaybe<SharedItemFilterInput>;
  sharedItemId?: InputMaybe<UuidFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItemComment. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemCommentQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemCommentSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemCommentFilterInput>;
};

export type SharedItemCommentSortInput = {
  postedAt?: InputMaybe<SortOrder>;
};

export type SharedItemConnection = {
  __typename?: 'SharedItemConnection';
  edges: Array<SharedItemEdge>;
  nodes: Array<SharedItem>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemEdge = {
  __typename?: 'SharedItemEdge';
  cursor: Scalars['String']['output'];
  node: SharedItem;
};

/** The filterable fields of type SharedItem */
export type SharedItemFilterInput = {
  and?: InputMaybe<Array<SharedItemFilterInput>>;
  commented?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  isInAnyPinGroup?: InputMaybe<BooleanFilterInput>;
  itemType?: InputMaybe<SharedItemTypeFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<SharedItemFilterInput>;
  or?: InputMaybe<Array<SharedItemFilterInput>>;
  owner?: InputMaybe<BooleanFilterInput>;
  pinGroupId?: InputMaybe<UuidFilterInput>;
  pinned?: InputMaybe<BooleanFilterInput>;
  rated?: InputMaybe<BooleanFilterInput>;
  shortDescription?: InputMaybe<StringFilterInput>;
  signedUp?: InputMaybe<BooleanFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItem. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemFilterInput>;
};

export type SharedItemRating = {
  __typename?: 'SharedItemRating';
  comment?: Maybe<Scalars['String']['output']>;
  fiveStarRating?: Maybe<Scalars['Float']['output']>;
  person?: Maybe<Person>;
  ratedAt?: Maybe<Scalars['DateTime']['output']>;
  sharedItem?: Maybe<SharedItem>;
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

export type SharedItemRatingConnection = {
  __typename?: 'SharedItemRatingConnection';
  edges: Array<SharedItemRatingEdge>;
  nodes: Array<SharedItemRating>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SharedItemRatingEdge = {
  __typename?: 'SharedItemRatingEdge';
  cursor: Scalars['String']['output'];
  node: SharedItemRating;
};

/** The filterable fields of type SharedItemRating */
export type SharedItemRatingFilterInput = {
  and?: InputMaybe<Array<SharedItemRatingFilterInput>>;
  comment?: InputMaybe<StringFilterInput>;
  fiveStarRating?: InputMaybe<FloatFilterInput>;
  not?: InputMaybe<SharedItemRatingFilterInput>;
  or?: InputMaybe<Array<SharedItemRatingFilterInput>>;
  ratedAt?: InputMaybe<DateTimeFilterInput>;
  sharedItem?: InputMaybe<SharedItemFilterInput>;
  sharedItemId?: InputMaybe<UuidFilterInput>;
};

/** The parameters for requesting multiple instances of SharedItemRating. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type SharedItemRatingQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<SharedItemRatingSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<SharedItemRatingFilterInput>;
};

export type SharedItemRatingSortInput = {
  comment?: InputMaybe<SortOrder>;
  fiveStarRating?: InputMaybe<SortOrder>;
  ratedAt?: InputMaybe<SortOrder>;
};

/** Contains information for linking 'SharedItem' to other entities */
export type SharedItemRelationInput = {
  /** The identifier of 'SharedItem' */
  id: Scalars['ID']['input'];
};

export type SharedItemSignUpQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type SharedItemSortInput = {
  createdBy?: InputMaybe<PersonSortInput>;
  description?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  publishedOn?: InputMaybe<SortOrder>;
  rating?: InputMaybe<SortOrder>;
  shortDescription?: InputMaybe<SortOrder>;
};

export enum SharedItemType {
  Post = 'POST',
  Project = 'PROJECT'
}

export type SharedItemTypeFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<SharedItemTypeFilterInput>>;
  /** Checks if the field has a value or not */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<SharedItemType>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<SharedItemType>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<SharedItemType>;
  /** Negates the predicate */
  not?: InputMaybe<SharedItemTypeFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<SharedItemTypeFilterInput>>;
};

export type SharedItemWithDate = {
  __typename?: 'SharedItemWithDate';
  dateTime: Scalars['DateTime']['output'];
  sharedItem: SharedItem;
};

/** The filterable fields of type SharedItemWithDate */
export type SharedItemWithDateFilterInput = {
  and?: InputMaybe<Array<SharedItemWithDateFilterInput>>;
  not?: InputMaybe<SharedItemWithDateFilterInput>;
  or?: InputMaybe<Array<SharedItemWithDateFilterInput>>;
};

export type SignUpSharedProjectInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  signedUp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignUpSharedProjectOutput = SignUpSharedProjectResult;

export type SignUpSharedProjectResult = {
  __typename?: 'SignUpSharedProjectResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type SignUpSharedProjectResult */
export type SignUpSharedProjectResultFilterInput = {
  and?: InputMaybe<Array<SignUpSharedProjectResultFilterInput>>;
  not?: InputMaybe<SignUpSharedProjectResultFilterInput>;
  or?: InputMaybe<Array<SignUpSharedProjectResultFilterInput>>;
};

export type SkillSet = {
  __typename?: 'SkillSet';
  communication?: Maybe<CommunicationSkills>;
  creativity?: Maybe<CreativitySkills>;
  experience?: Maybe<ExperienceSkills>;
  futureOrientation?: Maybe<FutureOrientationSkills>;
  resilience?: Maybe<ResilienceSkills>;
  resultOrientation?: Maybe<ResultOrientationSkills>;
  teamSpirit?: Maybe<TeamSpiritSkills>;
};

/** The filterable fields of type SkillSet */
export type SkillSetFilterInput = {
  and?: InputMaybe<Array<SkillSetFilterInput>>;
  not?: InputMaybe<SkillSetFilterInput>;
  or?: InputMaybe<Array<SkillSetFilterInput>>;
};

export type SmartAnalysisEvidence = {
  __typename?: 'SmartAnalysisEvidence';
  /** Quelldokument in DOCUMENTS; nullable, falls Nachweise ihr Dokument ueberleben */
  documentId?: Maybe<Scalars['UUID']['output']>;
  documentName: Scalars['String']['output'];
  pageNumber: Scalars['Int']['output'];
  quote: Scalars['String']['output'];
  stance: EvidencePolarity;
  support: EvidenceStrength;
};

/** The filterable fields of type SmartAnalysisEvidence */
export type SmartAnalysisEvidenceFilterInput = {
  and?: InputMaybe<Array<SmartAnalysisEvidenceFilterInput>>;
  not?: InputMaybe<SmartAnalysisEvidenceFilterInput>;
  or?: InputMaybe<Array<SmartAnalysisEvidenceFilterInput>>;
};

export type SmartAnalysisResult = {
  __typename?: 'SmartAnalysisResult';
  confidence: Scalars['Float']['output'];
  element: CreativityElement;
  evidences: Array<SmartAnalysisEvidence>;
  rationale?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
};

/** The filterable fields of type SmartAnalysisResult */
export type SmartAnalysisResultFilterInput = {
  and?: InputMaybe<Array<SmartAnalysisResultFilterInput>>;
  not?: InputMaybe<SmartAnalysisResultFilterInput>;
  or?: InputMaybe<Array<SmartAnalysisResultFilterInput>>;
};

/** Defines the sorting order of a field. */
export enum SortOrder {
  /** Sort ascending, null values first */
  Asc = 'ASC',
  /** Sort descending, null values last */
  Desc = 'DESC'
}

/** Defines case-sensitivity for a string based filter. */
export enum StringFilterCaseSensitivity {
  /** Case insensitive comparisons (a == A) */
  CaseInsensitive = 'CASE_INSENSITIVE',
  /** Case sensitive comparisons (a != A) */
  CaseSensitive = 'CASE_SENSITIVE'
}

/** Filtering for fields of type String */
export type StringFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<StringFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if comparisons should be case-sensitive or not */
  caseSensitivity?: InputMaybe<StringFilterCaseSensitivity>;
  /** Checks if the field's value contains the given value */
  contains?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value ends with the given suffix */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is greater than or equal to the given value */
  ge?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is greater than to the given value */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Checks if the field's value is less than or equal to the given value */
  le?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is less than to the given value */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['String']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<StringFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<StringFilterInput>>;
  /** Checks if the field's value begins with the given prefix */
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Filtering options for a list of elements with type String */
export type StringListFilterInput = {
  /** All list items must match the predicate */
  all?: InputMaybe<StringFilterInput>;
  /** If true, there should exist at least list item */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** None of list items must match the predicate */
  none?: InputMaybe<StringFilterInput>;
  /** At least one of list items must match the predicate */
  some?: InputMaybe<StringFilterInput>;
};

export type Subscription = {
  __typename?: 'Subscription';
  conversationEvents: ConversationEvent;
  conversationLifecycleEvents: ConversationLifecycleEvent;
  /**
   * Streams lifecycle events of a documents-extraction job started via startDocumentsExtraction.
   * Emits a snapshot of the current job state first (QUEUED/STARTED, or the terminal event with
   * result for an already-finished job), then live events; the stream completes after a terminal
   * COMPLETED/FAILED event. Only the person who started the job may subscribe. Note: if the pod
   * executing the job dies, no terminal event is ever emitted — clients should pair the
   * subscription with a timeout and fall back to the extractionJob status query.
   */
  documentsExtractionEvents: DocumentsExtractionEvent;
  /**
   * Subscribes to realtime notification changes for the current user. Events for notification
   * types outside input.supportedTypes are filtered out; when the input is absent only the six
   * original types are delivered (see NotificationsInput.supportedTypes).
   */
  notificationEvents: NotificationEvent;
  unreadChatMessageCountUpdates: UnreadChatMessageCount;
  /** Subscribes to unread notification count changes for the current user. */
  unreadNotificationCountUpdates: UnreadNotificationCount;
};


export type SubscriptionConversationEventsArgs = {
  afterMessageId?: InputMaybe<Scalars['UUID']['input']>;
  conversationId: Scalars['UUID']['input'];
};


export type SubscriptionDocumentsExtractionEventsArgs = {
  jobId: Scalars['UUID']['input'];
};


export type SubscriptionNotificationEventsArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};


export type SubscriptionUnreadChatMessageCountUpdatesArgs = {
  conversationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type SubscriptionUnreadNotificationCountUpdatesArgs = {
  input?: InputMaybe<SupportedNotificationTypesInput>;
};

/** The filterable fields of type Subscription */
export type SubscriptionFilterInput = {
  and?: InputMaybe<Array<SubscriptionFilterInput>>;
  not?: InputMaybe<SubscriptionFilterInput>;
  or?: InputMaybe<Array<SubscriptionFilterInput>>;
};

export type SuggestActivityDescriptionsInput = {
  /** Optional department context. */
  department?: InputMaybe<Scalars['String']['input']>;
  /** Job title to generate activities for. */
  jobTitle: Scalars['String']['input'];
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the suggestions (free-text). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestExpertiseDescriptionsInput = {
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the suggestions (free-text). */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestProfileSummaryInput = {
  /** BCP-47 language tag identifying the response language (e.g., "en", "de"). */
  locale: Scalars['String']['input'];
  /** Optional focus area to bias the summary (free-text), e.g. "emphasize leadership". */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Result of a suggestion query. `suggestions` is empty for `EMPTY` and `UNAVAILABLE`. */
export type SuggestionResult = {
  __typename?: 'SuggestionResult';
  status: SuggestionStatus;
  suggestions: Array<Scalars['String']['output']>;
};

/** The filterable fields of type SuggestionResult */
export type SuggestionResultFilterInput = {
  and?: InputMaybe<Array<SuggestionResultFilterInput>>;
  not?: InputMaybe<SuggestionResultFilterInput>;
  or?: InputMaybe<Array<SuggestionResultFilterInput>>;
};

/**
 * Outcome of a model-gateway-backed suggestion call.
 *
 * - `OK`: model returned suggestions.
 * - `EMPTY`: model returned no suggestions (e.g., gibberish search).
 * - `UNAVAILABLE`: model-gateway, the model, or schema validation failed; suggestions is always empty.
 *
 * The client decides how to render each status; the server never raises a GraphQL error for a service failure.
 */
export enum SuggestionStatus {
  Empty = 'EMPTY',
  Ok = 'OK',
  Unavailable = 'UNAVAILABLE'
}

/**
 * Declares which notification types the calling client understands. Shared by the
 * notification queries and subscriptions for backward compatibility with clients built
 * against an older schema.
 */
export type SupportedNotificationTypesInput = {
  /**
   * Notification types this client understands. Notifications and events of other types are
   * filtered out, and counts only include declared types. When absent or empty, only the six
   * original types are considered (see NotificationsInput.supportedTypes for the rationale).
   */
  supportedTypes?: InputMaybe<Array<NotificationType>>;
};

export type SystemSettings = {
  __typename?: 'SystemSettings';
  accentColor?: Maybe<Scalars['String']['output']>;
  appName?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundImage?: Maybe<File>;
  candidateAssessmentPrompt?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<File>;
  surfaceColor?: Maybe<Scalars['String']['output']>;
};

export type SystemSettingsDataInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  appName?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundImage?: InputMaybe<SystemSettingsFileInput>;
  candidateAssessmentPrompt?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<SystemSettingsFileInput>;
  surfaceColor?: InputMaybe<Scalars['String']['input']>;
};

export type SystemSettingsFileInput = {
  content?: InputMaybe<Scalars['Binary']['input']>;
  fileExtension?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
};

/** The filterable fields of type SystemSettings */
export type SystemSettingsFilterInput = {
  and?: InputMaybe<Array<SystemSettingsFilterInput>>;
  not?: InputMaybe<SystemSettingsFilterInput>;
  or?: InputMaybe<Array<SystemSettingsFilterInput>>;
};

export type SystemSettingsInput = {
  data: SystemSettingsDataInput;
};

export type TakeOverSharedItemInput = {
  matchId: Scalars['UUID']['input'];
  sharedItemId: Scalars['UUID']['input'];
};

export type TakeOverSharedItemOutput = TakeOverSharedItemResult;

export type TakeOverSharedItemResult = {
  __typename?: 'TakeOverSharedItemResult';
  match: Match;
};

/** The filterable fields of type TakeOverSharedItemResult */
export type TakeOverSharedItemResultFilterInput = {
  and?: InputMaybe<Array<TakeOverSharedItemResultFilterInput>>;
  not?: InputMaybe<TakeOverSharedItemResultFilterInput>;
  or?: InputMaybe<Array<TakeOverSharedItemResultFilterInput>>;
};

export type TeamProfile = Node & {
  __typename?: 'TeamProfile';
  id: Scalars['ID']['output'];
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
  weights: Array<ElementWeight>;
};

export type TeamProfileConnection = {
  __typename?: 'TeamProfileConnection';
  edges: Array<TeamProfileEdge>;
  nodes: Array<TeamProfile>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TeamProfileEdge = {
  __typename?: 'TeamProfileEdge';
  cursor: Scalars['String']['output'];
  node: TeamProfile;
};

/** The filterable fields of type TeamProfile */
export type TeamProfileFilterInput = {
  and?: InputMaybe<Array<TeamProfileFilterInput>>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<TeamProfileFilterInput>;
  or?: InputMaybe<Array<TeamProfileFilterInput>>;
};

/** The parameters for requesting multiple instances of TeamProfile. Mixing fields of cursor-based and offset-based pagination will result in an error. */
export type TeamProfileQueryInput = {
  /** Cursor-based pagination: The immediate successor of this cursor will be the first entry of the requested page */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: The immediate predecessor of this cursor will be last entry of the requested page */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'after' */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor-based pagination: Number of rows to be returned. Use in conjunction with 'before' */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** The sorting order of the instances */
  order?: InputMaybe<TeamProfileSortInput>;
  /** Offset-based pagination: Number of rows to skip */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Offset-based pagination: Number of rows to be returned */
  take?: InputMaybe<Scalars['Int']['input']>;
  /** The filter to be applied */
  where?: InputMaybe<TeamProfileFilterInput>;
};

export type TeamProfileSortInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type TeamSpiritSkills = {
  __typename?: 'TeamSpiritSkills';
  ableToDelegate?: Maybe<Scalars['SkillRating']['output']>;
  appreciative?: Maybe<Scalars['SkillRating']['output']>;
  compromising?: Maybe<Scalars['SkillRating']['output']>;
  confidenceBuilding?: Maybe<Scalars['SkillRating']['output']>;
  conflictSolving?: Maybe<Scalars['SkillRating']['output']>;
  consensual?: Maybe<Scalars['SkillRating']['output']>;
  constructive?: Maybe<Scalars['SkillRating']['output']>;
  cooperative?: Maybe<Scalars['SkillRating']['output']>;
  helpful?: Maybe<Scalars['SkillRating']['output']>;
  motivating?: Maybe<Scalars['SkillRating']['output']>;
  organizationallyAware?: Maybe<Scalars['SkillRating']['output']>;
  passionate?: Maybe<Scalars['SkillRating']['output']>;
};

/** The filterable fields of type TeamSpiritSkills */
export type TeamSpiritSkillsFilterInput = {
  and?: InputMaybe<Array<TeamSpiritSkillsFilterInput>>;
  not?: InputMaybe<TeamSpiritSkillsFilterInput>;
  or?: InputMaybe<Array<TeamSpiritSkillsFilterInput>>;
};

export type TextElement = GrowElement & {
  __typename?: 'TextElement';
  content?: Maybe<Scalars['Binary']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<LocalizedText>;
};

/** The filterable fields of type TextElement */
export type TextElementFilterInput = {
  and?: InputMaybe<Array<TextElementFilterInput>>;
  not?: InputMaybe<TextElementFilterInput>;
  or?: InputMaybe<Array<TextElementFilterInput>>;
};

export type TooManyRecordsResult = {
  __typename?: 'TooManyRecordsResult';
  /** The maximum number of records allowed */
  limit?: Maybe<Scalars['Int']['output']>;
};

/** The filterable fields of type TooManyRecordsResult */
export type TooManyRecordsResultFilterInput = {
  and?: InputMaybe<Array<TooManyRecordsResultFilterInput>>;
  not?: InputMaybe<TooManyRecordsResultFilterInput>;
  or?: InputMaybe<Array<TooManyRecordsResultFilterInput>>;
};

export type TypingIndicator = {
  __typename?: 'TypingIndicator';
  conversationId: Scalars['UUID']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  observedAt: Scalars['DateTime']['output'];
  personId: Scalars['UUID']['output'];
  typing: Scalars['Boolean']['output'];
};

/** The filterable fields of type TypingIndicator */
export type TypingIndicatorFilterInput = {
  and?: InputMaybe<Array<TypingIndicatorFilterInput>>;
  not?: InputMaybe<TypingIndicatorFilterInput>;
  or?: InputMaybe<Array<TypingIndicatorFilterInput>>;
};

export type UuidFilterInput = {
  /** Logical 'and' of one or more predicates */
  and?: InputMaybe<Array<UuidFilterInput>>;
  /** If true, checks if the field has a value, or, if false, checks if the field is missing a value */
  any?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks if the field's value is equal to the given value */
  eq?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks if the field's value is in the list of the given values */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Checks if the field's value is not equal to the given value */
  ne?: InputMaybe<Scalars['UUID']['input']>;
  /** Negates the predicate */
  not?: InputMaybe<UuidFilterInput>;
  /** Logical 'or' of one or more predicates */
  or?: InputMaybe<Array<UuidFilterInput>>;
};

export type UnreadChatMessageCount = {
  __typename?: 'UnreadChatMessageCount';
  conversationId?: Maybe<Scalars['UUID']['output']>;
  count: Scalars['Int']['output'];
};

/** The filterable fields of type UnreadChatMessageCount */
export type UnreadChatMessageCountFilterInput = {
  and?: InputMaybe<Array<UnreadChatMessageCountFilterInput>>;
  not?: InputMaybe<UnreadChatMessageCountFilterInput>;
  or?: InputMaybe<Array<UnreadChatMessageCountFilterInput>>;
};

/** Unread notification count for the current user. */
export type UnreadNotificationCount = {
  __typename?: 'UnreadNotificationCount';
  count: Scalars['Int']['output'];
};

/** The filterable fields of type UnreadNotificationCount */
export type UnreadNotificationCountFilterInput = {
  and?: InputMaybe<Array<UnreadNotificationCountFilterInput>>;
  not?: InputMaybe<UnreadNotificationCountFilterInput>;
  or?: InputMaybe<Array<UnreadNotificationCountFilterInput>>;
};

export type UpdateAddressDataInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  district?: InputMaybe<Scalars['String']['input']>;
  line?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<CountryStateRelationInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AddressType>;
  use: AddressUse;
};

export type UpdateAddressInput = {
  data: UpdateAddressDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAddressOutput = UpdateAddressResult | ValidateAddressResult;

/** The actual data structure of updating an instance of Address */
export type UpdateAddressResult = {
  __typename?: 'UpdateAddressResult';
  /** The actual data returned for Address */
  result: Address;
};

export type UpdateCertificateDataInput = {
  date?: InputMaybe<CreateDateInstantDataInput>;
  name: Scalars['String']['input'];
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
};

export type UpdateCertificateInput = {
  data: UpdateCertificateDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCertificateOutput = UpdateCertificateResult | ValidateCertificateResult;

/** The actual data structure of updating an instance of Certificate */
export type UpdateCertificateResult = {
  __typename?: 'UpdateCertificateResult';
  /** The actual data returned for Certificate */
  result: Certificate;
};

export type UpdateContractTypeDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateContractTypeInput = {
  data: UpdateContractTypeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContractTypeOutput = UpdateContractTypeResult | ValidateContractTypeResult;

/** The actual data structure of updating an instance of ContractType */
export type UpdateContractTypeResult = {
  __typename?: 'UpdateContractTypeResult';
  /** The actual data returned for ContractType */
  result: ContractType;
};

export type UpdateCurriculumVitaeDataInput = {
  apiVersion: Scalars['Int']['input'];
  configuration?: InputMaybe<Scalars['Object']['input']>;
  content?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurriculumVitaeInput = {
  data: UpdateCurriculumVitaeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCurriculumVitaeOutput = UpdateCurriculumVitaeResult | ValidateCurriculumVitaeResult;

/** The actual data structure of updating an instance of CurriculumVitae */
export type UpdateCurriculumVitaeResult = {
  __typename?: 'UpdateCurriculumVitaeResult';
  /** The actual data returned for CurriculumVitae */
  result: CurriculumVitae;
};

export type UpdateDegreeDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateDegreeInput = {
  data: UpdateDegreeDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDegreeOutput = UpdateDegreeResult | ValidateDegreeResult;

export type UpdateDegreeResult = {
  __typename?: 'UpdateDegreeResult';
  result: Degree;
};

export type UpdateDocumentDataInput = {
  category?: InputMaybe<DocumentClassifier>;
  group?: InputMaybe<DocumentGroupRelationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDocumentGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdateDocumentGroupInput = {
  data: UpdateDocumentGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDocumentGroupOutput = UpdateDocumentGroupResult | ValidateDocumentGroupResult;

/** The actual data structure of updating an instance of DocumentGroup */
export type UpdateDocumentGroupResult = {
  __typename?: 'UpdateDocumentGroupResult';
  /** The actual data returned for DocumentGroup */
  result: DocumentGroup;
};

export type UpdateDocumentInput = {
  data: UpdateDocumentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentOutput = UpdateDocumentResult | ValidateDocumentResult;

/** The actual data structure of updating an instance of Document */
export type UpdateDocumentResult = {
  __typename?: 'UpdateDocumentResult';
  /** The actual data returned for Document */
  result: Document;
};

export type UpdateEducationDataInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryRelationInput>;
  degree?: InputMaybe<DegreeRelationInput>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  field: Scalars['String']['input'];
  institution?: InputMaybe<Scalars['String']['input']>;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
  startDate?: InputMaybe<CreateDateInstantDataInput>;
};

export type UpdateEducationInput = {
  data: UpdateEducationDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEducationOutput = UpdateEducationResult | ValidateEducationResult;

/** The actual data structure of updating an instance of Education */
export type UpdateEducationResult = {
  __typename?: 'UpdateEducationResult';
  /** The actual data returned for Education */
  result: Education;
};

export type UpdateExperienceDataInput = {
  activities?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<CountryRelationInput>;
  department?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<CreateDateInstantDataInput>;
  industry?: InputMaybe<IndustryRelationInput>;
  jobTitle: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
  startDate?: InputMaybe<CreateDateInstantDataInput>;
};

export type UpdateExperienceInput = {
  data: UpdateExperienceDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExperienceOutput = UpdateExperienceResult | ValidateExperienceResult;

/** The actual data structure of updating an instance of Experience */
export type UpdateExperienceResult = {
  __typename?: 'UpdateExperienceResult';
  /** The actual data returned for Experience */
  result: Experience;
};

export type UpdateExpertiseDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  level: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
};

export type UpdateExpertiseInput = {
  data: UpdateExpertiseDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateExpertiseOutput = UpdateExpertiseResult | ValidateExpertiseResult;

/** The actual data structure of updating an instance of Expertise */
export type UpdateExpertiseResult = {
  __typename?: 'UpdateExpertiseResult';
  /** The actual data returned for Expertise */
  result: Expertise;
};

export type UpdateExtendedContactDetailDataInput = {
  address?: InputMaybe<AddressRelationInput>;
  name?: InputMaybe<Array<InputMaybe<CreateHumanNameDataInput>>>;
  organization?: InputMaybe<OrganizationRelationInput>;
  purpose?: InputMaybe<ExtendedContactDetailRelationInput>;
  telecom?: InputMaybe<Array<InputMaybe<CreateContactPointDataInput>>>;
};

export type UpdateExtendedContactDetailInput = {
  data: UpdateExtendedContactDetailDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateExtendedContactDetailOutput = UpdateExtendedContactDetailResult | ValidateExtendedContactDetailResult;

/** The actual data structure of updating an instance of ExtendedContactDetail */
export type UpdateExtendedContactDetailResult = {
  __typename?: 'UpdateExtendedContactDetailResult';
  /** The actual data returned for ExtendedContactDetail */
  result: ExtendedContactDetail;
};

export type UpdateGenderDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGenderInput = {
  data: UpdateGenderDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateGenderOutput = UpdateGenderResult | ValidateGenderResult;

/** The actual data structure of updating an instance of Gender */
export type UpdateGenderResult = {
  __typename?: 'UpdateGenderResult';
  /** The actual data returned for Gender */
  result: Gender;
};

export type UpdateIndustryDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateIndustryInput = {
  data: UpdateIndustryDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIndustryOutput = UpdateIndustryResult | ValidateIndustryResult;

/** The actual data structure of updating an instance of Industry */
export type UpdateIndustryResult = {
  __typename?: 'UpdateIndustryResult';
  /** The actual data returned for Industry */
  result: Industry;
};

export type UpdateJobDepartmentDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateJobDepartmentInput = {
  data: UpdateJobDepartmentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobDepartmentOutput = UpdateJobDepartmentResult | ValidateJobDepartmentResult;

/** The actual data structure of updating an instance of JobDepartment */
export type UpdateJobDepartmentResult = {
  __typename?: 'UpdateJobDepartmentResult';
  /** The actual data returned for JobDepartment */
  result: JobDepartment;
};

export type UpdateJobLocationDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateJobLocationInput = {
  data: UpdateJobLocationDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobLocationOutput = UpdateJobLocationResult | ValidateJobLocationResult;

/** The actual data structure of updating an instance of JobLocation */
export type UpdateJobLocationResult = {
  __typename?: 'UpdateJobLocationResult';
  /** The actual data returned for JobLocation */
  result: JobLocation;
};

export type UpdateLanguageSkillDataInput = {
  cefr?: InputMaybe<CefrScale>;
  languageTag: Scalars['String']['input'];
  nativeSpeaker: Scalars['Boolean']['input'];
  selfAssessed?: InputMaybe<Scalars['Boolean']['input']>;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
};

export type UpdateLanguageSkillInput = {
  data: UpdateLanguageSkillDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLanguageSkillOutput = UpdateLanguageSkillResult | ValidateLanguageSkillResult;

/** The actual data structure of updating an instance of LanguageSkill */
export type UpdateLanguageSkillResult = {
  __typename?: 'UpdateLanguageSkillResult';
  /** The actual data returned for LanguageSkill */
  result: LanguageSkill;
};

export type UpdateMaritalStatusDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** Stable canonical English name, locale-independent — lets clients match extraction scan values to ids regardless of UI locale. */
  nameEn?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMaritalStatusInput = {
  data: UpdateMaritalStatusDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMaritalStatusOutput = UpdateMaritalStatusResult | ValidateMaritalStatusResult;

/** The actual data structure of updating an instance of MaritalStatus */
export type UpdateMaritalStatusResult = {
  __typename?: 'UpdateMaritalStatusResult';
  /** The actual data returned for MaritalStatus */
  result: MaritalStatus;
};

export type UpdateMatchCandidateDataInput = {
  locked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchCandidateInput = {
  data: UpdateMatchCandidateDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchCandidateOutput = UpdateMatchCandidateResult | ValidateMatchCandidateResult;

/** The actual data structure of updating an instance of MatchCandidate */
export type UpdateMatchCandidateResult = {
  __typename?: 'UpdateMatchCandidateResult';
  /** The actual data returned for MatchCandidate */
  result: MatchCandidate;
};

export type UpdateMatchDataInput = {
  access?: InputMaybe<Array<CreateMatchAccessDataInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  design?: InputMaybe<Scalars['Object']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedItem?: InputMaybe<SharedItemRelationInput>;
};

export type UpdateMatchInput = {
  data: UpdateMatchDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchOutput = UpdateMatchResult | ValidateMatchResult;

/** The actual data structure of updating an instance of Match */
export type UpdateMatchResult = {
  __typename?: 'UpdateMatchResult';
  /** The actual data returned for Match */
  result: Match;
};

export type UpdateMatchResultDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<CreateMatchResultTeamDataInput>>;
};

export type UpdateMatchResultInput = {
  data: UpdateMatchResultDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMatchResultOutput = UpdateMatchResultResult | ValidateMatchResultResult;

/** The actual data structure of updating an instance of MatchResult */
export type UpdateMatchResultResult = {
  __typename?: 'UpdateMatchResultResult';
  /** The actual data returned for MatchResult */
  result: MatchResult;
};

export type UpdateOrganizationDataInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contact?: InputMaybe<Array<InputMaybe<ExtendedContactDetailRelationInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partOf?: InputMaybe<OrganizationRelationInput>;
  type?: InputMaybe<OrganizationType>;
};

export type UpdateOrganizationInput = {
  data: UpdateOrganizationDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationOutput = UpdateOrganizationResult | ValidateOrganizationResult;

/** The actual data structure of updating an instance of Organization */
export type UpdateOrganizationResult = {
  __typename?: 'UpdateOrganizationResult';
  /** The actual data returned for Organization */
  result: Organization;
};

export type UpdatePersonDataInput = {
  administrativeGender?: InputMaybe<AdministrativeGender>;
  alternativeAvatar?: InputMaybe<CreateFileDataInput>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<CreateFileDataInput>;
  bio?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  childCount?: InputMaybe<Scalars['Int']['input']>;
  citizenships?: InputMaybe<Array<InputMaybe<CountryRelationInput>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<ContractTypeRelationInput>;
  country?: InputMaybe<CountryRelationInput>;
  countryState?: InputMaybe<CountryStateRelationInput>;
  currentActivity?: InputMaybe<Scalars['String']['input']>;
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  currentTasks?: InputMaybe<Scalars['String']['input']>;
  deceased?: InputMaybe<CreateDeceasedDataInput>;
  drivingLicence?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderRelationInput>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  jobDepartment?: InputMaybe<JobDepartmentRelationInput>;
  jobLocation?: InputMaybe<JobLocationRelationInput>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<MaritalStatusRelationInput>;
  miscellaneous?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<CreateHumanNameDataInput>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  profession?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  sharedAttributes?: InputMaybe<CreatePersonSharedAttributesDataInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workingTimeModel?: InputMaybe<WorkingTimeModelRelationInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdatePersonGroupInput = {
  data: UpdatePersonGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePersonGroupOutput = UpdatePersonGroupResult | ValidatePersonGroupResult;

/** The actual data structure of updating an instance of PersonGroup */
export type UpdatePersonGroupResult = {
  __typename?: 'UpdatePersonGroupResult';
  /** The actual data returned for PersonGroup */
  result: PersonGroup;
};

export type UpdatePersonInput = {
  data: UpdatePersonDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePersonOutput = UpdatePersonResult | ValidatePersonResult;

/** The actual data structure of updating an instance of Person */
export type UpdatePersonResult = {
  __typename?: 'UpdatePersonResult';
  /** The actual data returned for Person */
  result: Person;
};

export type UpdatePinGroupDataInput = {
  name: Scalars['String']['input'];
};

export type UpdatePinGroupInput = {
  data: UpdatePinGroupDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePinGroupOutput = UpdatePinGroupResult | ValidatePinGroupResult;

/** The actual data structure of updating an instance of PinGroup */
export type UpdatePinGroupResult = {
  __typename?: 'UpdatePinGroupResult';
  /** The actual data returned for PinGroup */
  result: PinGroup;
};

export type UpdateSelfAssessmentDataInput = {
  questions?: InputMaybe<Array<InputMaybe<SelfAssessmentStatementRelationInput>>>;
};

export type UpdateSelfAssessmentInput = {
  data: UpdateSelfAssessmentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSelfAssessmentOutput = UpdateSelfAssessmentResult | ValidateSelfAssessmentResult;

/** The actual data structure of updating an instance of SelfAssessment */
export type UpdateSelfAssessmentResult = {
  __typename?: 'UpdateSelfAssessmentResult';
  /** The actual data returned for SelfAssessment */
  result: SelfAssessment;
};

export type UpdateSharedItemCommentDataInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  sharedItem?: InputMaybe<SharedItemRelationInput>;
  sharedItemId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateSharedItemCommentInput = {
  data: UpdateSharedItemCommentDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSharedItemCommentOutput = UpdateSharedItemCommentResult | ValidateSharedItemCommentResult;

/** The actual data structure of updating an instance of SharedItemComment */
export type UpdateSharedItemCommentResult = {
  __typename?: 'UpdateSharedItemCommentResult';
  /** The actual data returned for SharedItemComment */
  result: SharedItemComment;
};

export type UpdateSharedItemDataInput = {
  darkMode?: InputMaybe<CreateColorsDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<CreateFileDataInput>>;
  filesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  images?: InputMaybe<Array<CreateFileDataInput>>;
  imagesToDelete?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lightMode?: InputMaybe<CreateColorsDataInput>;
  mainImage?: InputMaybe<CreateFileDataInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sharedWith?: InputMaybe<Array<InputMaybe<AudienceRelationInput>>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSharedItemInput = {
  data: UpdateSharedItemDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSharedItemOutput = UpdateSharedItemResult | ValidateSharedItemResult;

/** The actual data structure of updating an instance of SharedItem */
export type UpdateSharedItemResult = {
  __typename?: 'UpdateSharedItemResult';
  /** The actual data returned for SharedItem */
  result: SharedItem;
};

export type UpdateTeamProfileDataInput = {
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
  weights?: InputMaybe<Array<CreateElementWeightDataInput>>;
};

export type UpdateTeamProfileInput = {
  data: UpdateTeamProfileDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTeamProfileOutput = UpdateTeamProfileResult | ValidateTeamProfileResult;

/** The actual data structure of updating an instance of TeamProfile */
export type UpdateTeamProfileResult = {
  __typename?: 'UpdateTeamProfileResult';
  /** The actual data returned for TeamProfile */
  result: TeamProfile;
};

export type UpdateWorkingTimeModelDataInput = {
  localizedDesc?: InputMaybe<CreateLocalizedTextDataInput>;
  localizedName?: InputMaybe<CreateLocalizedTextDataInput>;
};

export type UpdateWorkingTimeModelInput = {
  data: UpdateWorkingTimeModelDataInput;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWorkingTimeModelOutput = UpdateWorkingTimeModelResult | ValidateWorkingTimeModelResult;

/** The actual data structure of updating an instance of WorkingTimeModel */
export type UpdateWorkingTimeModelResult = {
  __typename?: 'UpdateWorkingTimeModelResult';
  /** The actual data returned for WorkingTimeModel */
  result: WorkingTimeModel;
};

export type UsedDocumentTagsInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
};

export type UsedDocumentTagsOutput = UsedDocumentTagsResult;

export type UsedDocumentTagsResult = {
  __typename?: 'UsedDocumentTagsResult';
  tags: Array<Scalars['String']['output']>;
};

/** The filterable fields of type UsedDocumentTagsResult */
export type UsedDocumentTagsResultFilterInput = {
  and?: InputMaybe<Array<UsedDocumentTagsResultFilterInput>>;
  not?: InputMaybe<UsedDocumentTagsResultFilterInput>;
  or?: InputMaybe<Array<UsedDocumentTagsResultFilterInput>>;
};

export enum UserRank {
  Rank1 = 'RANK1',
  Rank2 = 'RANK2',
  Rank3 = 'RANK3',
  Rank4 = 'RANK4',
  Rank5 = 'RANK5',
  Rank6 = 'RANK6',
  Rank7 = 'RANK7',
  Rank8 = 'RANK8'
}

export type ValidateAddressIssue = ValidationIssue & {
  __typename?: 'ValidateAddressIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateAddressResult = ValidationIssues & {
  __typename?: 'ValidateAddressResult';
  issues: Array<ValidationIssue>;
};

export type ValidateCertificateIssue = ValidationIssue & {
  __typename?: 'ValidateCertificateIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateCertificateResult = ValidationIssues & {
  __typename?: 'ValidateCertificateResult';
  issues: Array<ValidationIssue>;
};

export type ValidateContractTypeIssue = ValidationIssue & {
  __typename?: 'ValidateContractTypeIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateContractTypeResult = ValidationIssues & {
  __typename?: 'ValidateContractTypeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateCurriculumVitaeIssue = ValidationIssue & {
  __typename?: 'ValidateCurriculumVitaeIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateCurriculumVitaeResult = ValidationIssues & {
  __typename?: 'ValidateCurriculumVitaeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDegreeResult = ValidationIssues & {
  __typename?: 'ValidateDegreeResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDocumentGroupIssue = ValidationIssue & {
  __typename?: 'ValidateDocumentGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDocumentGroupResult = ValidationIssues & {
  __typename?: 'ValidateDocumentGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidateDocumentIssue = ValidationIssue & {
  __typename?: 'ValidateDocumentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateDocumentResult = ValidationIssues & {
  __typename?: 'ValidateDocumentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateEducationIssue = ValidationIssue & {
  __typename?: 'ValidateEducationIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateEducationResult = ValidationIssues & {
  __typename?: 'ValidateEducationResult';
  issues: Array<ValidationIssue>;
};

export type ValidateExperienceIssue = ValidationIssue & {
  __typename?: 'ValidateExperienceIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateExperienceResult = ValidationIssues & {
  __typename?: 'ValidateExperienceResult';
  issues: Array<ValidationIssue>;
};

export type ValidateExpertiseIssue = ValidationIssue & {
  __typename?: 'ValidateExpertiseIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateExpertiseResult = ValidationIssues & {
  __typename?: 'ValidateExpertiseResult';
  issues: Array<ValidationIssue>;
};

export type ValidateExtendedContactDetailIssue = ValidationIssue & {
  __typename?: 'ValidateExtendedContactDetailIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateExtendedContactDetailResult = ValidationIssues & {
  __typename?: 'ValidateExtendedContactDetailResult';
  issues: Array<ValidationIssue>;
};

export type ValidateGenderIssue = ValidationIssue & {
  __typename?: 'ValidateGenderIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateGenderResult = ValidationIssues & {
  __typename?: 'ValidateGenderResult';
  issues: Array<ValidationIssue>;
};

export type ValidateIndustryIssue = ValidationIssue & {
  __typename?: 'ValidateIndustryIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateIndustryResult = ValidationIssues & {
  __typename?: 'ValidateIndustryResult';
  issues: Array<ValidationIssue>;
};

export type ValidateJobDepartmentIssue = ValidationIssue & {
  __typename?: 'ValidateJobDepartmentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateJobDepartmentResult = ValidationIssues & {
  __typename?: 'ValidateJobDepartmentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateJobLocationIssue = ValidationIssue & {
  __typename?: 'ValidateJobLocationIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateJobLocationResult = ValidationIssues & {
  __typename?: 'ValidateJobLocationResult';
  issues: Array<ValidationIssue>;
};

export type ValidateLanguageSkillIssue = ValidationIssue & {
  __typename?: 'ValidateLanguageSkillIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateLanguageSkillResult = ValidationIssues & {
  __typename?: 'ValidateLanguageSkillResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMaritalStatusIssue = ValidationIssue & {
  __typename?: 'ValidateMaritalStatusIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMaritalStatusResult = ValidationIssues & {
  __typename?: 'ValidateMaritalStatusResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchCandidateIssue = ValidationIssue & {
  __typename?: 'ValidateMatchCandidateIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchCandidateResult = ValidationIssues & {
  __typename?: 'ValidateMatchCandidateResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchIssue = ValidationIssue & {
  __typename?: 'ValidateMatchIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchResult = ValidationIssues & {
  __typename?: 'ValidateMatchResult';
  issues: Array<ValidationIssue>;
};

export type ValidateMatchResultIssue = ValidationIssue & {
  __typename?: 'ValidateMatchResultIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateMatchResultResult = ValidationIssues & {
  __typename?: 'ValidateMatchResultResult';
  issues: Array<ValidationIssue>;
};

export type ValidateOrganizationIssue = ValidationIssue & {
  __typename?: 'ValidateOrganizationIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateOrganizationResult = ValidationIssues & {
  __typename?: 'ValidateOrganizationResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePersonGroupIssue = ValidationIssue & {
  __typename?: 'ValidatePersonGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePersonGroupResult = ValidationIssues & {
  __typename?: 'ValidatePersonGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePersonIssue = ValidationIssue & {
  __typename?: 'ValidatePersonIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePersonResult = ValidationIssues & {
  __typename?: 'ValidatePersonResult';
  issues: Array<ValidationIssue>;
};

export type ValidatePinGroupIssue = ValidationIssue & {
  __typename?: 'ValidatePinGroupIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidatePinGroupResult = ValidationIssues & {
  __typename?: 'ValidatePinGroupResult';
  issues: Array<ValidationIssue>;
};

export type ValidateSelfAssessmentIssue = ValidationIssue & {
  __typename?: 'ValidateSelfAssessmentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateSelfAssessmentResult = ValidationIssues & {
  __typename?: 'ValidateSelfAssessmentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateSharedItemCommentIssue = ValidationIssue & {
  __typename?: 'ValidateSharedItemCommentIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateSharedItemCommentResult = ValidationIssues & {
  __typename?: 'ValidateSharedItemCommentResult';
  issues: Array<ValidationIssue>;
};

export type ValidateSharedItemIssue = ValidationIssue & {
  __typename?: 'ValidateSharedItemIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateSharedItemResult = ValidationIssues & {
  __typename?: 'ValidateSharedItemResult';
  issues: Array<ValidationIssue>;
};

export type ValidateTeamProfileIssue = ValidationIssue & {
  __typename?: 'ValidateTeamProfileIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateTeamProfileResult = ValidationIssues & {
  __typename?: 'ValidateTeamProfileResult';
  issues: Array<ValidationIssue>;
};

export type ValidateWorkingTimeModelIssue = ValidationIssue & {
  __typename?: 'ValidateWorkingTimeModelIssue';
  error: ValidationError;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ValidateWorkingTimeModelResult = ValidationIssues & {
  __typename?: 'ValidateWorkingTimeModelResult';
  issues: Array<ValidationIssue>;
};

/** Technical description of the validation error. */
export enum ValidationError {
  /** The value of the field is supposed to be unique but it is already used elsewhere */
  AlreadyExists = 'ALREADY_EXISTS',
  /** The value of the field does not match the expected format (eg. invalid email address or URL) */
  FormatError = 'FORMAT_ERROR',
  /** The field is mandatory but either an empty value or no value was provided */
  IsMandatory = 'IS_MANDATORY',
  /** Other errors. Human-readable details can be found the message field. */
  Other = 'OTHER'
}

/** Describes an error condition that occurred during input validation */
export type ValidationIssue = {
  /** A technical description of the error */
  error?: Maybe<ValidationError>;
  /** The name of the field that caused the error */
  field?: Maybe<Scalars['String']['output']>;
  /** A human-readable description of the error. The language of the text might depend on the HTTP 'Accept-Language' header */
  message?: Maybe<Scalars['String']['output']>;
};

/** Collection of validation errors occurred during input validation */
export type ValidationIssues = {
  /** List of validation errors */
  issues: Array<ValidationIssue>;
};

export type VideoElement = GrowElement & PlayableGrowElement & {
  __typename?: 'VideoElement';
  lengthMilliseconds?: Maybe<Scalars['Int']['output']>;
  manifest: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  thumbnail?: Maybe<Scalars['Binary']['output']>;
  title: LocalizedText;
};

/** The filterable fields of type VideoElement */
export type VideoElementFilterInput = {
  and?: InputMaybe<Array<VideoElementFilterInput>>;
  not?: InputMaybe<VideoElementFilterInput>;
  or?: InputMaybe<Array<VideoElementFilterInput>>;
};

export type ViewSharedItemInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId: Scalars['UUID']['input'];
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewSharedItemOutput = ViewSharedItemResult;

export type ViewSharedItemResult = {
  __typename?: 'ViewSharedItemResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type ViewSharedItemResult */
export type ViewSharedItemResultFilterInput = {
  and?: InputMaybe<Array<ViewSharedItemResultFilterInput>>;
  not?: InputMaybe<ViewSharedItemResultFilterInput>;
  or?: InputMaybe<Array<ViewSharedItemResultFilterInput>>;
};

export type ViewUserProfileInput = {
  userProfileId: Scalars['UUID']['input'];
};

export type ViewUserProfileOutput = ViewUserProfileResult;

export type ViewUserProfileResult = {
  __typename?: 'ViewUserProfileResult';
  userProfileId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type ViewUserProfileResult */
export type ViewUserProfileResultFilterInput = {
  and?: InputMaybe<Array<ViewUserProfileResultFilterInput>>;
  not?: InputMaybe<ViewUserProfileResultFilterInput>;
  or?: InputMaybe<Array<ViewUserProfileResultFilterInput>>;
};

export type WatchSharedItemInput = {
  person?: InputMaybe<Scalars['UUID']['input']>;
  sharedItemId?: InputMaybe<Scalars['UUID']['input']>;
  watching?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WatchSharedItemOutput = WatchSharedItemResult;

export type WatchSharedItemResult = {
  __typename?: 'WatchSharedItemResult';
  sharedItemId?: Maybe<Scalars['UUID']['output']>;
};

/** The filterable fields of type WatchSharedItemResult */
export type WatchSharedItemResultFilterInput = {
  and?: InputMaybe<Array<WatchSharedItemResultFilterInput>>;
  not?: InputMaybe<WatchSharedItemResultFilterInput>;
  or?: InputMaybe<Array<WatchSharedItemResultFilterInput>>;
};

export type WorkingTimeModel = Node & {
  __typename?: 'WorkingTimeModel';
  desc?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localizedDesc?: Maybe<LocalizedText>;
  localizedName?: Maybe<LocalizedText>;
  name?: Maybe<Scalars['String']['output']>;
};

/** The filterable fields of type WorkingTimeModel */
export type WorkingTimeModelFilterInput = {
  and?: InputMaybe<Array<WorkingTimeModelFilterInput>>;
  desc?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<WorkingTimeModelFilterInput>;
  or?: InputMaybe<Array<WorkingTimeModelFilterInput>>;
};

/** Contains information for linking 'WorkingTimeModel' to other entities */
export type WorkingTimeModelRelationInput = {
  /** The identifier of 'WorkingTimeModel' */
  id: Scalars['ID']['input'];
};

export type WorkingTimeModelSortInput = {
  desc?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type WorkingTimeModelsResult = {
  __typename?: 'WorkingTimeModelsResult';
  workingTimeModels: Array<WorkingTimeModel>;
};

/** The filterable fields of type WorkingTimeModelsResult */
export type WorkingTimeModelsResultFilterInput = {
  and?: InputMaybe<Array<WorkingTimeModelsResultFilterInput>>;
  not?: InputMaybe<WorkingTimeModelsResultFilterInput>;
  or?: InputMaybe<Array<WorkingTimeModelsResultFilterInput>>;
};
